// src/data/ProjectsData.js
const projects = [
    // Flats
    {
        "id": "aspire-ameya",
        "project_name": "Asper Ameya",
        "category": "Flats",
        "title": "Asper Spaces Ameya",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aspire-ameya/asper-ameya.png"),
        project_overview: [
            { icon: "fas fa-vector-square", title: "Extent", value: "10 Acres" },
            { icon: "fas fa-building", title: "Blocks", value: "9 Blocks" },
            { icon: "fas fa-layer-group", title: "Floors", value: "13" },
            { icon: "fas fa-door-open", title: "Units", value: "1066" },
            { icon: "fas fa-home", title: "Flats", value: "2, 2.5, 3BHK" },
            { icon: "fas fa-ruler-combined", title: "2BHK (Sft)", value: "1210, 1330" },
            { icon: "fas fa-ruler-combined", title: "2.5BHK (Sft)", value: "1495" },
            { icon: "fas fa-ruler-combined", title: "3BHK (Sft)", value: "1625, 1715, 1940" }
        ]
        ,
        "description": "Aspire Spaces is a premier real estate developer committed to delivering high-quality, well-designed spaces. Backed by experienced founders and expert partners, the company focuses on customer satisfaction through quality, consistency, and sustainability."
        ,
        "amenities": [
            { "name": "Reception With Double Height Lobby", "icon": "fas fa-concierge-bell" },
            { "name": "Co-Working Space/ Business Lounge", "icon": "fas fa-briefcase" },
            { "name": "Indoor & Outdoor Gym", "icon": "fas fa-dumbbell" },
            { "name": "Dedicated Work Station (WFH)", "icon": "fas fa-laptop" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Conference & Meeting Room", "icon": "fas fa-users" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Children's Play Area", "icon": "fas fa-child" },
            { "name": "Multipurpose Banquet Hall with Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Swimming Pool with Toddler Pool", "icon": "fas fa-swimmer" },
            { "name": "Sandpit", "icon": "fas fa-umbrella-beach" },
            { "name": "Kids' Pool With Canopy", "icon": "fas fa-baby" },
            { "name": "Badminton Court", "icon": "fas fa-table-tennis" },
            { "name": "Box Cricket", "icon": "fas fa-baseball-ball" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Indoor Games (Snooker/Carrom/TT)", "icon": "fas fa-chess-board" },
            { "name": "DIY Zone & Drive-in Car Wash Area", "icon": "fas fa-car" },
            { "name": "Health Club / Yoga Room", "icon": "fas fa-spa" },
            { "name": "Movie Theatre", "icon": "fas fa-film" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Kids’ Crèche & Collaboration Zone", "icon": "fas fa-users-cog" },
            { "name": "Party Lawn", "icon": "fas fa-cocktail" },
            { "name": "Spa, Sauna & Salon", "icon": "fas fa-hot-tub" },
            { "name": "Meditation Zone", "icon": "fas fa-praying-hands" },
            { "name": "Coffee Shop", "icon": "fas fa-coffee" },
            { "name": "Grocery Store", "icon": "fas fa-shopping-basket" }
        ],
        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure",
                "content": "RCC framed structure with AAC or solid blocks"
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "Vitrified tiles in living, kitchen & bedrooms; anti-skid tiles in balconies"
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Doors & Windows",
                "content": "Premium quality engineered doors and UPVC windows"
            },
            {
                "icon": "fas fa-paint-roller",
                "title": "Painting",
                "content": "Premium acrylic paint for interiors and exterior finish"
            },
            {
                "icon": "fas fa-th",
                "title": "Tile Cladding",
                "content": "Bathroom & kitchen walls with ceramic tiles"
            },
            {
                "icon": "fas fa-utensils",
                "title": "Kitchen",
                "content": "Water connection & provision for hob, chimney and exhaust"
            },
            {
                "icon": "fas fa-phone-alt",
                "title": "Telecom",
                "content": "Intercom and telephone provision in all units"
            },
            {
                "icon": "fas fa-bath",
                "title": "Bathrooms",
                "content": "Quality sanitary ware and CP fittings"
            },
            {
                "icon": "fas fa-bolt",
                "title": "Electrical",
                "content": "Power points for all major appliances with modular switches"
            },
            {
                "icon": "fas fa-charging-station",
                "title": "Power Backup",
                "content": "100% DG backup for common areas & flats"
            },
            {
                "icon": "fas fa-tv",
                "title": "Cable TV",
                "content": "TV points in living and bedrooms"
            },
            {
                "icon": "fas fa-wifi",
                "title": "Internet",
                "content": "Provision in living room and bedrooms"
            },
            {
                "icon": "fas fa-gas-pump",
                "title": "LPG / PNG",
                "content": "Piped gas system provided"
            },
            {
                "icon": "fas fa-trash-alt",
                "title": "Waste Management",
                "content": "Garbage chutes for every floor"
            },
            {
                "icon": "fas fa-shield-alt",
                "title": "Security",
                "content": "24/7 CCTV, intercom & panic buttons"
            },
            {
                "icon": "fas fa-elevator",
                "title": "Lifts",
                "content": "Automatic lifts with power backup"
            },
            {
                "icon": "fas fa-water",
                "title": "Water Supply",
                "content": "Softened water & rainwater harvesting"
            },
            {
                "icon": "fas fa-fire-extinguisher",
                "title": "Fire & Safety",
                "content": "Sprinklers, fire alarm & public address system"
            },
            {
                "icon": "fas fa-file-invoice-dollar",
                "title": "Billing System",
                "content": "Automated billing for utilities"
            }
        ]
        ,
        "gallery": [
            require("../images/projects/Flats/Aspire-ameya/gallery-1.png"),
            require("../images/projects/Flats/Aspire-ameya/gallery-2.png"),
            require("../images/projects/Flats/Aspire-ameya/gallery-3.png"),
            require("../images/projects/Flats/Aspire-ameya/gallery-4.png"),
        ],
        // "google_map": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.571211204348!2d78.36008407432843!3d17.432166501312113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93b94a9fb28f%3A0xe13b0b28fa5c12f2!2sGachibowli%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v1625669098301!5m2!1sen!2sin"
    },
    //The Legacey
    {
        "id": "thelegacey",
        "project_name": "The Legacey",
        "category": "Flats",
        "title": "The Legacey by Ananda Homes",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Ananda Homes - The Legacey/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "18.1 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "12" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "22" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "2238" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5, 3BHK" },
            { "icon": "fas fa-ruler-combined", "title": "2BHK (Sft)", "value": "1295, 1329.99, 1350" },
            { "icon": "fas fa-ruler-combined", "title": "2.5BHK (Sft)", "value": "1460, 1495" },
            { "icon": "fas fa-ruler-combined", "title": "3BHK (Sft)", "value": "2215" }
        ],
        "description": "The Legacey is an upscale residential project by Ananda Homes, located in the vibrant area of Puppalaguda, Hyderabad. Spanning 18.1 acres with 12 towers and over 2200 premium units, this gated community offers thoughtfully designed 2, 2.5, and 3BHK flats. It blends contemporary architecture with resort-style living, featuring world-class amenities like dual clubhouses, a grand entrance lobby, swimming pools, indoor games, a mini theatre, yoga spaces, and more. Strategically positioned for easy access to IT hubs, schools, and hospitals, The Legacey promises a lifestyle of elegance, convenience, and community living.",
        "amenities": [
            { "name": "Dual Clubhouses (100,000+ sqft)", "icon": "fas fa-building" },
            { "name": "Double-height Grand Lobby", "icon": "fas fa-door-open" },
            { "name": "Banquet & Mini Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Swimming Pool & Kid’s Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Yoga Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Mini Theatre", "icon": "fas fa-film" },
            { "name": "Library & Study Lounge", "icon": "fas fa-book-reader" },
            { "name": "BBQ Area", "icon": "fas fa-fire" },
            { "name": "Crèche / Day Care", "icon": "fas fa-baby" },
            { "name": "Golf Course Access", "icon": "fas fa-golf-ball" },
            { "name": "Children's Play Area", "icon": "fas fa-child" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with AAC blocks; earthquake-resistant design" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in all rooms, anti-skid tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak wood main door, flush doors internally, UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Weather-proof exterior paint; acrylic emulsion for interiors" },
            { "icon": "fas fa-th", "title": "Tile Cladding", "content": "Full-height ceramic tiles in bathrooms & kitchen walls" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Provision for chimney, hob, exhaust and water purifier" },
            { "icon": "fas fa-phone-alt", "title": "Telecom", "content": "Intercom and broadband provision in all flats" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitaryware and CP fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with modular switches" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "Backup for common areas and essential power points in flats" },
            { "icon": "fas fa-tv", "title": "Cable TV", "content": "Provision in living and master bedroom" },
            { "icon": "fas fa-wifi", "title": "Internet", "content": "Fiber connectivity in living and bedrooms" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Piped gas system with prepaid meters" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "Garbage chute system on every floor" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24x7 security, CCTV, video door phones" },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "Automatic lifts with ARD and backup power" },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Municipal supply, rainwater harvesting and STP" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Sprinkler system, smoke detectors and fire alarms" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Smart metering for electricity, gas and water" }
        ],
        "gallery": [
            require("../images/projects/Flats/Ananda Homes - The Legacey/gallery_1.jpg"),
            require("../images/projects/Flats/Ananda Homes - The Legacey/gallery_2.jpg"),
            require("../images/projects/Flats/Ananda Homes - The Legacey/gallery_3.jpg"),
            require("../images/projects/Flats/Ananda Homes - The Legacey/gallery_4.jpg"),
        ]
        // "google_map": "https://www.google.com/maps/embed?pb=..." // optional if available
    },

    //Ananda Homes - The Drizzle
    {
        "id": "the-drizzle",
        "project_name": "Ananda Homes - The Drizzle",
        "category": "Flats",
        "title": "Ananda Homes - The Drizzle",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Ananda Homes - The Drizzle/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "18.1 Acres + 3 Acres greens" },
            { "icon": "fas fa-building", "title": "Towers", "value": "6+" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Up to 14" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,200+ (approx)" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 3BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Configurations (Sft)", "value": "Varied – see floor plans" }
        ],
        "description": "The Drizzle is a luxury high‑rise residential community by Ananda Homes in Narsingi, Hyderabad. Set on an expansive 18+ acres with over 3 acres dedicated to open green spaces and a scenic lakeside park, it offers resort‑style living. With several towers housing premium 2 and 3 BHK apartments, the project emphasizes connectivity—just minutes from ORR, IT hubs, schools, and hospitals. Its unique dual‑clubhouse concept and full‑fledged sports arena elevate the living experience to one of exclusivity and wellness. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Dual Clubhouses", "icon": "fas fa-building" },
            { "name": "Double-height Entry Lobby", "icon": "fas fa-door-open" },
            { "name": "Banquet Halls", "icon": "fas fa-glass-cheers" },
            { "name": "Indoor + Outdoor Gyms", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Games (snooker, billiards, chess)", "icon": "fas fa-chess-board" },
            { "name": "Mini Theatre", "icon": "fas fa-film" },
            { "name": "Conference & Co‑Working Rooms", "icon": "fas fa-briefcase" },
            { "name": "Spa & Salon", "icon": "fas fa-hot-tub" },
            { "name": "Crèche / Clinic / Pharmacy", "icon": "fas fa-baby" },
            { "name": "Squash Court", "icon": "fas fa-table-tennis" },
            { "name": "Multiple Sports Courts (badminton, tennis, basketball)", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Nets & Football Ground", "icon": "fas fa-football-ball" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Pets Park", "icon": "fas fa-paw" },
            { "name": "Aroma Garden & Landscaped Lawns", "icon": "fas fa-seedling" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed superstructure; earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium vitrified tiles in living & bedrooms; anti‑skid in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, flush internal doors; UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Exterior textured/weather‑shield; interior emulsion" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Provision for hob, chimney, exhaust; concealed plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tiles to lintel, CP fittings, anti‑skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "DG backup for common areas and essential points" },
            { "icon": "fas fa-gas-pump", "title": "Gas", "content": "Piped gas provision" },
            { "icon": "fas fa-water", "title": "Water Supply & Sustainability", "content": "Municipal water, rainwater harvesting, STP" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, boom barriers" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Smoke detectors, fire alarms, sprinkler system" }
        ],
        "gallery": [
            require("../images/projects/Flats/Ananda Homes - The Drizzle/gallery_1.jpg"),
            require("../images/projects/Flats/Ananda Homes - The Drizzle/gallery_2.jpg"),
            require("../images/projects/Flats/Ananda Homes - The Drizzle/galler_3.jpg"),
            require("../images/projects/Flats/Ananda Homes - The Drizzle/galler_4.jpg")
        ]
    },

    //Anvita High 9
    {
        "id": "anvita-high9",
        "project_name": "Anvita High 9",
        "category": "Flats",
        "title": "Anvita High 9",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Anvita High 9/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "15 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "9" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "30" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "2,200+ Units" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 3BHK + 4 BHK Sky Villas" },
            { "icon": "fas fa-ruler-combined", "title": "2BHK (Sft)", "value": "1,355" },
            { "icon": "fas fa-ruler-combined", "title": "3BHK (Sft)", "value": "1,695–2,615" },
            { "icon": "fas fa-ruler-combined", "title": "4BHK Sky Villas (Sft)", "value": "Cloud Villas" }
        ],
        "description": "Anvita High9 is a luxury gated apartment community by Anvita Group in Kollur, Hyderabad, spanning 15 acres with 80% open green spaces. It features 9 towers up to 30 floors, offering 2 & 3 BHK apartments and exclusive 4 BHK sky villas. Set beside ORR Exit‑2, the project includes a 1.6 km skywalk, designer terraces with lawns, and podium-style living. Dual clubhouse blocks host sports complexes, gaming, spa, indoor & outdoor gyms, pools, creche, pet park, and more. With a traffic-free podium, solar fencing, centralized LPG, 100% power backup, and rooftop amenities, High9 delivers a refined, contemporary lifestyle in Tellapur's thriving locale. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Skywalk (1.6 km)", "icon": "fas fa-walking" },
            { "name": "Designer Terraces & Sun Decks", "icon": "fas fa-seedling" },
            { "name": "Dual Clubhouse & Sports Complex", "icon": "fas fa-building" },
            { "name": "Swimming Pools", "icon": "fas fa-swimmer" },
            { "name": "Indoor & Outdoor Gyms", "icon": "fas fa-dumbbell" },
            { "name": "Spa, Salon & Jacuzzi", "icon": "fas fa-hot-tub" },
            { "name": "Crèche / Clinic", "icon": "fas fa-baby" },
            { "name": "Mini Theatre & Multipurpose Hall", "icon": "fas fa-film" },
            { "name": "Sports Courts: Badminton, Tennis, Basketball, Cricket Nets", "icon": "fas fa-basketball-ball" },
            { "name": "Pet Park & Participatory Gardens", "icon": "fas fa-paw" },
            { "name": "Skating Rink, Amphitheatre, Jogging Track", "icon": "fas fa-skating" },
            { "name": "Pavilion & Party Lawn", "icon": "fas fa-glass-cheers" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed superstructure, podium style, solar fencing" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium vitrified in living/bedrooms, anti-skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors, flush internal doors, UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured weather‑shield exterior, emulsion interior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Provision for hob, chimney, exhaust; concealed plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tiles to lintel, CP fittings, anti-skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for flats and common areas" },
            { "icon": "fas fa-gas-pump", "title": "LPG", "content": "Centralized piped LPG supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, rainwater harvesting, STP" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, boom barriers, solar fencing" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing", "content": "Smart metering for utilities" }
        ],
        "gallery": [
            require("../images/projects/Flats/Anvita High 9/gallery-1.jpg"),
            require("../images/projects/Flats/Anvita High 9/gallery-2.jpg"),
            require("../images/projects/Flats/Anvita High 9/gallery-3.jpg"),
            require("../images/projects/Flats/Anvita High 9/gallery-4.jpg")
        ]
    },

    //Aparna Zenon
    {
        "id": "aparna-zenon",
        "project_name": "Aparna Zenon",
        "category": "Flats",
        "title": "Aparna Zenon",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aparna Zenon/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "30.15 Acres" },
            { "icon": "fas fa-building", "title": "Blocks", "value": "14" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Up to 32" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "3,664" },
            { "icon": "fas fa-home", "title": "Flats", "value": "1, 2, 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "1 BHK (Sft)", "value": "1,020‑1,147" },
            { "icon": "fas fa-ruler-combined", "title": "2 BHK (Sft)", "value": "1,243‑1,342" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sft)", "value": "1,514‑2,257" }
        ],
        "description": "Aparna Zenon is a massive gated community by Aparna Constructions in Puppalaguda, Hyderabad, spread over 30.15 acres with 14 towers of up to 32 floors and 3,664 units. It offers 1, 2, and 3 BHK apartments ranging from 1,020 to 2,257 sqft super built‑up area. The project features a grand clubhouse (86,423 sqft), sports complex, commercial block, and solar-powered common areas. Designed for luxury and convenience, it includes EV charging, central gas, solar water heating, automated car wash, and thoughtfully landscaped spaces. Scheduled for possession in September 2027, it is RERA‑registered (P02400003722) and targeted at homebuyers seeking futuristic living in a prime IT-adjacent location.",
        "amenities": [
            { "name": "Children's Play Area", "icon": "fas fa-child" },
            { "name": "Multipurpose Hall / Banquet", "icon": "fas fa-glass-cheers" },
            { "name": "Gymnasium (Aqua Gym included)", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Yoga & Aerobics", "icon": "fas fa-spa" },
            { "name": "Badminton, Squash, Tennis Courts", "icon": "fas fa-table-tennis" },
            { "name": "Mini Futsal Field", "icon": "fas fa-futbol" },
            { "name": "Spa & Clinic", "icon": "fas fa-hot-tub" },
            { "name": "Business Lounge / Clubhouse", "icon": "fas fa-briefcase" },
            { "name": "Coffee Lounge", "icon": "fas fa-coffee" },
            { "name": "EV Charging Stations", "icon": "fas fa-charging-station" },
            { "name": "Automated Car Wash", "icon": "fas fa-car" },
            { "name": "Pet Park", "icon": "fas fa-paw" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed superstructure, earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; flush internal doors; UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured/weather‑shield exterior; emulsion interior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite platform; provision for hob, chimney, exhaust; concealed plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tiles to lintel; quality CP fittings; anti‑skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging points" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas with pre‑paid meters" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, rainwater harvesting, STP, solar water heating" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV, intercom, boom barriers" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire-fighting systems, sprinkler, alarms" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized utility billing system" }
        ],
        "gallery": [
            require("../images/projects/Flats/Aparna Zenon/gallery-1.jpg"),
            require("../images/projects/Flats/Aparna Zenon/gallery-2.jpg"),
            require("../images/projects/Flats/Aparna Zenon/gallery-3.jpg"),
            require("../images/projects/Flats/Aparna Zenon/gallery-4.jpg")

        ]
    },

    //Aparna Newlands
    {
        "id": "aparna-newlands",
        "project_name": "Aparna Newlands",
        "category": "Flats",
        "title": "Aparna Newlands",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aparna Newlands/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "14+ Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "8" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "42" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,976" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2.5, 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "2.5 BHK (Sft)", "value": "1,475" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sft)", "value": "1,690–1,991" }
        ],
        "description": "Aparna Newlands is a premium gated community by Aparna Constructions located in Tellapur, Hyderabad. Spread over 14+ acres, it comprises 8 high‑rise towers of 42 floors and 1,976 thoughtfully designed 2.5 & 3 BHK apartments ranging from 1,475 to 1,991 sq ft super built‑up. With two entry/exit points (Osman Nagar/ORR and Gopanpally/Financial District), it ensures seamless connectivity. The project offers resort‑style luxury through a 72,865 sq ft clubhouse, a 9,428 sq ft commercial block, indoor & outdoor sports facilities, thematic gardens, and eco‑friendly features like water recycling, solar power, EV charging, and automated car wash. Scheduled for possession in Dec 2028 (RERA P01100007480), Newlands delivers elevated urban living in a thriving neighbourhood. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Clubhouse (G + 4, 72,865 sq ft)", "icon": "fas fa-building" },
            { "name": "Commercial Block (9,428 sq ft)", "icon": "fas fa-store" },
            { "name": "Swimming Pool (Temperature‑controlled)", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Multipurpose / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Indoor & Outdoor Sports Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Badminton & Squash Courts", "icon": "fas fa-table-tennis" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Spa & Clinic", "icon": "fas fa-hot-tub" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "EV Charging Stations", "icon": "fas fa-charging-station" },
            { "name": "Automated Car Wash", "icon": "fas fa-car" },
            { "name": "Landscaped Thematic Gardens", "icon": "fas fa-seedling" },
            { "name": "Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall framed structure, earthquake‑resistant, floor‑to‑floor height 3.15 m" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; hardwood internal doors; UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior emulsion; acrylic interior finish" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite platform; provision for hob, chimney, exhaust, purifier" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Vitrified/ceramic tiles; CP fittings; anti‑skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "DG backup; EV charging points" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas" },
            { "icon": "fas fa-water", "title": "Water Supply & Sustainability", "content": "Municipal supply, rainwater harvesting, STP, solar power" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV, boom barriers" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized utility billing" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire sprinklers, alarms, firefighting systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Aparna Newlands/gallery-1.jpg"),
            require("../images/projects/Flats/Aparna Newlands/gallery-2.jpg"),
            require("../images/projects/Flats/Aparna Newlands/gallery-3.jpg"),
            require("../images/projects/Flats/Aparna Newlands/gallery-4.jpg")
        ]
    },

    //Aparna CyberHeights
    {
        "id": "aparna-cyberheights",
        "project_name": "Aparna CyberHeights",
        "category": "Flats",
        "title": "Aparna CyberHeights",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aparna CyberHeights/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "6.68 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Up to 22" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "708" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,345–1,981" }
        ],
        "description": "Aparna CyberHeights is an upscale gated community in Osman Nagar spanning 6.68 acres with five towers up to 22 floors and 708 homes. Offering 2, 2.5 & 3 BHK apartments sized between 1,345 and 1,981 sq ft, the project blends modern aesthetics with smart design. It features a clubhouse, gym, swimming pool, mini-theatre, creche, business lounge, outdoor sports courts, skating rink, pet park, aromatic gardens, EV charging, central gas, and 100% power backup. Strategically located just ~8 km from Lingampally railway station and near ORR, hospitals, schools, and retail hubs, it aims for possession by Aug 2028. RERA‑registered under P01100005166. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Multipurpose Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Business Lounge & Waiting Lounge", "icon": "fas fa-briefcase" },
            { "name": "Coffee Lounge & Preview Theatre", "icon": "fas fa-coffee" },
            { "name": "Gym, Aerobics, Yoga/Meditation Studio", "icon": "fas fa-dumbbell" },
            { "name": "Spa, Salon", "icon": "fas fa-hot-tub" },
            { "name": "Swimming Pool & Kids' Pool", "icon": "fas fa-swimmer" },
            { "name": "Children's Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Cricket Practice Pitch", "icon": "fas fa-futbol" },
            { "name": "Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "Aromatic / Medicinal Garden", "icon": "fas fa-seedling" },
            { "name": "EV Charging Points", "icon": "fas fa-charging-station" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear-wall framed structure, earthquake-resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti-skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; hardwood internal doors; UPVC windows with HS glass" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior; smooth acrylic emulsion interior" },
            { "icon": "fas fa-th", "title": "Tile Cladding", "content": "Glazed tiles to lintel in bathrooms & kitchen" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite platform; provision for hob, chimney, exhaust; CPVC plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Anti-skid flooring, CP fittings, glazed tile cladding" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging stations" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal water; STP; rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, boom barriers, intercom" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized utility billing" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Sprinklers, alarms, firefighting systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Aparna CyberHeights/gallery-1.jpg"),
            require("../images/projects/Flats/Aparna CyberHeights/gallery-2.jpg"),
            require("../images/projects/Flats/Aparna CyberHeights/gallery-3.jpg"),
            require("../images/projects/Flats/Aparna CyberHeights/gallery-4.jpg")
        ],
        "possession": {
            "expected": "August 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹7,200–7,499",
            "price_range_crores": ["1.07", "1.68"]
        },
        "rera": "P01100005166"
    },

    //Aparna CyberStar
    {
        "id": "aparna-cyberstar",
        "project_name": "Aparna CyberStar",
        "category": "Flats",
        "title": "Aparna CyberStar",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aparna CyberStar/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3.35 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "16–22" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "272" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Size (Sqft)", "value": "1,270–1,839" }
        ],
        "description": "Aparna CyberStar is a gated residential project in Osman Nagar, Hyderabad, developed by Aparna Constructions. Spread across approximately 3.35 acres, it comprises two towers with up to 16 floors (some listings mention 22), offering 272 units of 2, 2.5, and 3 BHK apartments sized between 1,270 and 1,839 sq ft. The project features a clubhouse, gym, pool, creche, indoor games, multipurpose hall, amphitheater, yoga studio, pet park, EV charging, central gas, and 100% backup power. Well‑connected with proximity to Lingampally Railway Station (~8 km), ORR (~4.7 km), and health & education hubs, it is scheduled for possession by August 2027 and is RERA‑registered under P01100005167.",
        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool & Kids' Pool", "icon": "fas fa-swimmer" },
            { "name": "Multipurpose / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Indoor Games (chess, billiards)", "icon": "fas fa-chess-board" },
            { "name": "Crèche / Day Care", "icon": "fas fa-baby" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Yoga/Aerobics Studio", "icon": "fas fa-spa" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "EV Charging Stations", "icon": "fas fa-charging-station" },
            { "name": "Waiting Lounge", "icon": "fas fa-coffee" },
            { "name": "Lift", "icon": "fas fa-elevator" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure; earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid ceramic tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak wood main doors; flush internal doors; UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior; acrylic emulsion interior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertop; provision for hob, chimney, exhaust; concealed plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tiles to lintel; premium CP fittings; anti‑skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for all units and common areas" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal water, rainwater harvesting, STP" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV, boom barriers, intercom" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Sprinklers, alarms & firefighting systems" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized smart metering for utilities" }
        ],
        "gallery": [
            require("../images/projects/Flats/Aparna CyberStar/gallery-1.jpg"),
            require("../images/projects/Flats/Aparna CyberStar/gallery-2.jpg"),
            require("../images/projects/Flats/Aparna CyberStar/gallery-3.jpg"),
            require("../images/projects/Flats/Aparna CyberStar/gallery-4.jpg")
        ],
        "possession": {
            "expected": "August 2027",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹6,999–7,300",
            "price_range_crores": ["0.95", "1.30"]
        },
        "rera": "P01100005167"
    },

    //Aparna CyberShine
    {
        "id": "aparna-cybershine",
        "project_name": "Aparna CyberShine",
        "category": "Flats",
        "title": "Aparna CyberShine",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aparna CyberShine/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3.35 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "16–22" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "330" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,314–1,824" }
        ],
        "description": "Aparna CyberShine is a luxury gated community in Osman Nagar, Hyderabad, spread across ~3.35 acres with two towers (16–22 storeys) and 330 premium flats. Designed for modern families, it offers 2, 2.5 & 3 BHK units ranging from 1,314 to 1,824 sq ft. The project frames the serene Osman Nagar lake and places you near thriving IT hubs. Residents get a clubhouse, gym, swimming pool, tennis courts, creche, indoor games, amphitheatre, yoga zones, pet park, EV charging, piped gas, and 100% power backup. It's 8 km from Lingampally railway station, 4.7 km from the ORR exit, and enjoys a traffic-free kids’ zone. Scheduled for possession in Dec 2025 (RERA P01100005196), it starts from ~₹99 Lakhs onwards and is priced around ₹7,049 / sq ft.",
        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Tennis Courts", "icon": "fas fa-table-tennis" },
            { "name": "Crèche / Day Care", "icon": "fas fa-baby" },
            { "name": "Indoor Games (chess, billiards)", "icon": "fas fa-chess-board" },
            { "name": "Multipurpose / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Yoga / Meditation Zone", "icon": "fas fa-spa" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "EV Charging Stations", "icon": "fas fa-charging-station" },
            { "name": "Traffic-free Kids' Zone & Play Area", "icon": "fas fa-child" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed, earthquake-resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti-skid tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; hardwood internal doors; UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior; interior acrylic emulsion" },
            { "icon": "fas fa-th", "title": "Tile Cladding", "content": "Glazed tiles to lintel in kitchen & bathrooms" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertop; provision for hob, chimney, exhaust; CPVC plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tile cladding; premium CP fittings; anti-skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for homes & common areas" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal water; rainwater harvesting; STP" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, boom barriers, intercom" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized utility billing" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Sprinklers, alarms & firefighting systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Aparna CyberShine/gallery-1.jpg"),
            require("../images/projects/Flats/Aparna CyberShine/gallery-2.jpg"),
            require("../images/projects/Flats/Aparna CyberShine/gallery-3.jpg"),
            require("../images/projects/Flats/Aparna CyberShine/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2025",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹7,049",
            "starting_price_lakhs": "99"
        },
        "rera": "P01100005196"
    },

    //Aparna CyberOn
    {
        "id": "aparna-cyberon",
        "project_name": "Aparna CyberOn",
        "category": "Flats",
        "title": "Aparna CyberOn",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Aparna CyberOn/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2.54 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "10 Floors" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "160" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2.5, 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,465–1,880" }
        ],
        "description": "Aparna CyberOn is a wellness-themed gated community in Osman Nagar, Hyderabad, spread across 2.54 acres with two 10‑floor towers and 160 thoughtfully designed 2.5 & 3 BHK apartments ranging from 1,465 to 1,880 sq ft. Priced from ₹1.07 Cr onwards (~₹6,899/sq ft), the project offers a blend of modern living and lush landscaping centered around resident well‑being. Positioned ~8 km from Lingampally station and ~4.7 km from the ORR, it’s an ideal choice for families seeking connectivity, lifestyle convenience, and a wellness-first environment. Possession expected June 2027 (RERA P01100005168).",
        "amenities": [
            { "name": "Children's Play Area", "icon": "fas fa-child" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Swimming + Kids' Pool", "icon": "fas fa-swimmer" },
            { "name": "Aerobics & Yoga Studio", "icon": "fas fa-spa" },
            { "name": "Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Practice Pitch", "icon": "fas fa-futbol" },
            { "name": "Creche & Utility Office", "icon": "fas fa-baby" },
            { "name": "Waiting Lounge", "icon": "fas fa-coffee" },
            { "name": "Chess & Billiards Room", "icon": "fas fa-chess-board" },
            { "name": "Lift", "icon": "fas fa-elevator" },
            { "name": "Party Lawn", "icon": "fas fa-glass-cheers" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure, earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; flush internal doors; UPVC windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior; acrylic for interiors" },
            { "icon": "fas fa-th", "title": "Tile Cladding", "content": "Glazed tiles in bathrooms & kitchen" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertop; provision for hob/chimney; CPVC plumbing" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Anti‑skid flooring; CP fittings; glazed tile up to lintel" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for common areas" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, STP, rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV, intercom, boom barriers" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized metering for utilities" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire-fighting systems, sprinklers, alarms" }
        ],
        "gallery": [
            require("../images/projects/Flats/Aparna CyberOn/gallery-1.jpg"),
            require("../images/projects/Flats/Aparna CyberOn/gallery-2.jpg"),
            require("../images/projects/Flats/Aparna CyberOn/gallery-3.jpg"),
            require("../images/projects/Flats/Aparna CyberOn/gallery-4.jpg")
        ],
        "possession": {
            "expected": "June 2027",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹6,899",
            "price_range_crores": ["1.07", "1.27"]
        },
        "rera": "P01100005168"
    },

    //Auro Realty - The Pearl
    {
        "id": "the-pearl",
        "project_name": "Auro Realty - The Pearl",
        "category": "Flats",
        "title": "Auro Realty - The Pearl",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Auro Realty - The Pearl/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "8.54 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "7" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+33" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "414" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK + Home Office & Servant Room" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "5,300–5,400" }
        ],
        "description": "The Pearl is an ultra‑luxury gated community by Auro Realty located in Hyderabad’s HITEC City. Sprawled over 8.54 acres, it features seven iconic towers rising up to 33 storeys, comprising 414 exclusive 4 BHK sky mansions (5,300–5,400 sq ft), each with private foyer, home office, servant room, and landscape balconies. Crafted by award‑winning architects Chapman Taylor, the project prioritizes bespoke design, opulence, and serenity.",
        "amenities": [
            { "name": "62,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Private Balcony for Every Room", "icon": "fas fa-door-open" },
            { "name": "2 Exclusive Elevators per Residence", "icon": "fas fa-elevator" },
            { "name": "Sports Bar & VR Theatre", "icon": "fas fa-film" },
            { "name": "Infinity Pool & Indoor Pool", "icon": "fas fa-swimmer" },
            { "name": "Jogging Track & Theme Garden", "icon": "fas fa-running" },
            { "name": "Outdoor Cinema", "icon": "fas fa-video" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "Basketball & Badminton Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Cafeteria / Bar / Lounge", "icon": "fas fa-coffee" },
            { "name": "Crèche & Kids’ Club", "icon": "fas fa-child" },
            { "name": "Bowling Alley", "icon": "fas fa-bowling-ball" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Advanced RCC concrete structure designed for wind & seismic loads; 3.45 m floor‑to‑floor height" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Marble flooring in living, dining & bedrooms, acrylic paint finishing" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "8‑ft teak main door, aluminium‑framed energy‑efficient windows, engineered internal doors" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Premium marble countertops, modular kitchen, dry/wet kitchen, water purifier provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Marble vanity counters, wall‑hung EWC, CP fittings, ceramic tile cladding" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, LED fixtures, home automation, video doorbell, intercom" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup, electric vehicle charging in common parking" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal water, rainwater harvesting, sewage treatment plant" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24/7 CCTV surveillance, boom barriers, BMS monitoring, intercom" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Comprehensive firefighting systems, sprinklers, fire alarms" }
        ],
        "gallery": [
            require("../images/projects/Flats/Auro Realty - The Pearl/gallery-1.jpg"),
            require("../images/projects/Flats/Auro Realty - The Pearl/gallery-2.jpg"),
            require("../images/projects/Flats/Auro Realty - The Pearl/gallery-3.jpg"),
            require("../images/projects/Flats/Auro Realty - The Pearl/gallery-4.jpg")

        ],
        "possession": {
            "expected": "August 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹12,000–12,500",
            "price_range_cr": ["6.5", "7.5"]
        },
        "rera": "P02400005068"
    },

    //Auro Realty - The Pearl
    {
        "id": "the-regent",
        "project_name": "Auro Realty - The Pearl",
        "category": "Flats",
        "title": "Auro Realty - The Pearl",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Auro Realty - The Regent/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "10.38 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+39" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,400" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Size (Sqft)", "value": "1,864–2,191" }
        ],
        "description": "The Regent by Auro Realty is a premium gated community in Kondapur, Hyderabad, set across 10.38 acres with five 39‑storey towers overlooking scenic Gopi Cheruvu and 2300 acres of HCU greenery. Offering upscale 3 BHK residences (1,864–2,191 sq ft), it includes a 50,000 sq ft clubhouse and 80+ lifestyle amenities ranging from outdoor gyms to open‑air theatre. With high‑rise tranquility yet prime connectivity to HITEC City, hospitals, schools, metro, rail, and airport, it's a thoughtfully planned luxury habitat. Launched Aug 2023 with possession starting July 2028; RERA P02500003587 / P02400006675. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "50,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Outdoor Gym & Jogging Track", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool + Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Open‑Air Theatre (250 seats)", "icon": "fas fa-theater-masks" },
            { "name": "Basketball, Tennis, Volleyball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Practice Pitch", "icon": "fas fa-futbol" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Aroma & Theme Gardens", "icon": "fas fa-seedling" },
            { "name": "Kids’ Play Area & Nanny’s Corner", "icon": "fas fa-child" },
            { "name": "Senior Citizens Area", "icon": "fas fa-umbrella-beach" },
            { "name": "Yoga Pavilion", "icon": "fas fa-praying-hands" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall framed structure with cement concrete block in non‑structural zones" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Teak flooring in master bedrooms; vitrified tiles elsewhere; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak/engineered wood main doors; UPVC/aluminium windows with toughened glass" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior emulsion; smooth acrylic interior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite platform; multiple electrical points; piped gas provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Anti‑skid vitrified/ceramic tiling; quality CP fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV & broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging planned" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, STP, rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV, boom barriers, intercom" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralised utility metering" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Sprinkler systems, fire alarms, firefighting measures" }
        ],
        "gallery": [
            require("../images/projects/Flats/Auro Realty - The Regent/gallery-1.jpg"),
            require("../images/projects/Flats/Auro Realty - The Regent/gallery-2.jpg"),
            require("../images/projects/Flats/Auro Realty - The Regent/gallery-3.jpg"),
            require("../images/projects/Flats/Auro Realty - The Regent/gallery-4.jpg")
        ],
        "possession": {
            "expected": "July 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹8.6 K",
            "price_range_cr": ["1.6", "1.88"]
        },
        "rera": "P02500003587 / P02400006675"
    },

    //Auro Realty - The Kohinoor
    {
        "id": "auro-kohinoor",
        "project_name": "Auro Realty - The Kohinoor",
        "category": "Flats",
        "title": "Auro Realty - The Kohinoor",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Auro Realty - The Kohinoor/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "12.3 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "7" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G + 41" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "Approx. 1400+ (Phase I)" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 3, 4 BHK & Duplex" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,296–3,094" }
        ],
        "description": "Auro Kohinoor is a grand luxury gated community developed by Auro Realty in HITEC City, Hyderabad. Spanning 12.3 acres with seven soaring towers up to 41 floors, it offers 2 to 4 BHK apartments and duplexes (1,296–3,094 sq ft super built‑up). With 80% open space, a 50,000 sq ft clubhouse and 50+ amenities including open‑air theatre, sports courts, gardens, creche, and rooftop leisure zones, it blends urban convenience with resort‑style living. Phase I possession is set for January 2026 (RERA P02400001822). Apartments start around ₹1.78 Cr for 2 BHK and go up to ₹4.25 Cr for 4 BHK duplexes. ([99acres.com](https://www.99acres.com/kohinoor-by-auro-realty-hi-tech-city-hyderabad-npxid-r354792))",
        "amenities": [
            { "name": "50,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Open‑Air Theatre", "icon": "fas fa-theater-masks" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Creche / Day Care", "icon": "fas fa-baby" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Badminton, Basketball & Volleyball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Pet’s Garden", "icon": "fas fa-paw" },
            { "name": "Jogging Track & Reflexology Path", "icon": "fas fa-running" },
            { "name": "Theme & Flower Gardens", "icon": "fas fa-seedling" },
            { "name": "Gazebo & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Children's Play Area", "icon": "fas fa-child" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall framed structure; cement concrete blocks for non‑structural zones" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Marble in living/dining; vitrified in other rooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak/engineered wood main doors; UPVC/aluminum windows; toughened glass, mosquito mesh provision" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior emulsion; smooth acrylic interior finish" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertops; 5 electrical points; piped gas provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Anti‑skid vitrified/ceramic tiles; quality CP fittings; glass shower partitions in master bathroom" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "3‑phase concealed copper wiring; modular switches; TV/internet points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging infrastructure" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Water softening plant; STP; rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV; boom barriers; video door-phone in flats; intercom; panic buttons in lifts" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire hydrant & sprinkler systems in basement, lobby & units; fire pumps" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Centralized smart metering for utilities" }
        ],
        "gallery": [
            require("../images/projects/Flats/Auro Realty - The Kohinoor/gallery-1.jpg"),
            require("../images/projects/Flats/Auro Realty - The Kohinoor/gallery-2.jpg"),
            require("../images/projects/Flats/Auro Realty - The Kohinoor/gallery-3.jpg"),
            require("../images/projects/Flats/Auro Realty - The Kohinoor/gallery-4.jpg")
        ],
        "possession": {
            "expected": "January 2026",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "price_range_cr": ["1.78", "4.25"],
            "avg_price_per_sqft": "₹10K+"
        },
        "rera": "P02400001822 / P02400002867"
    },

    //ASBL Broadway
    {
        "id": "asbl-broadway",
        "project_name": "ASBL Broadway",
        "category": "Flats",
        "title": "ASBL Broadway",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/ASBL Broadway/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.03 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+50" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "885" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 3.5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "2,035–2,650" }
        ],
        "description": "ASBL Broadway is a premium gated community by Ashoka Builders, inspired by Manhattan, located in Hyderabad’s Financial District near Gachibowli. Spread over approximately 5 acres with 75% open space, it comprises three tall towers of G+50 and four basement levels, offering 885 luxury 3 & 3.5 BHK apartments sized 2,035–2,650 sq ft. With panoramic glass façades, expansive balconies, and seamless indoor–outdoor living, it integrates a 55,000 sq ft urban corridor and boasts 107,000 sq ft of indoor amenities. Featuring sky‑level gym, clubhouse, pools, sports courts, creche, guest rooms, advanced security, and full backup, it's set for possession by December 2029 (RERA P02400009684).",
        "amenities": [
            { "name": "55,000 sq ft Urban Corridor & Clubhouse", "icon": "fas fa-building" },
            { "name": "Sky‑level Gym", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Outdoor Sports Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Party Hall / Banquet", "icon": "fas fa-glass-cheers" },
            { "name": "Medical Facility", "icon": "fas fa-clinic-medical" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with curtain‑wall glazed façade" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows; glass railings" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Weather‑shield exterior; acrylic interior finish" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular setup with tiled backsplash; hob/chimney provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tile cladding; premium CP fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging infrastructure" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "24×7 municipal water; STP; rainwater harvesting" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Firefighting systems, sprinklers, alarms" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Smart metering for utilities" }
        ],
        "gallery": [
            require("../images/projects/Flats/ASBL Broadway/gallery-1.jpg"),
            require("../images/projects/Flats/ASBL Broadway/gallery-2.jpg"),
            require("../images/projects/Flats/ASBL Broadway/gallery-3.jpg"),
            require("../images/projects/Flats/ASBL Broadway/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2029",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹8,799",
            "price_range_cr": ["1.79", "2.33"]
        },
        "rera": "P02400009684"
    },

    //ASBL Landmark
    {
        "id": "asbl-landmark",
        "project_name": "ASBL Landmark",
        "category": "Flats",
        "title": "ASBL Landmark",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/ASBL Landmark/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "6.6 Acres" },
            { "icon": "fas fa-building", "title": "Blocks/Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+19/20" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "676" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 3.5 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,645–2,860" }
        ],
        "description": "ASBL Landmark is a luxury gated residential community by ASBL (Ashoka Builders) located at the Y Junction in Kukatpally, Hyderabad. Spanning 6.6 acres with 75% open landscaped spaces, it comprises 4 towers reaching up to 19/20 storeys, offering 676 spacious 3, 3.5 & 4 BHK apartments ranging from 1,645 to 2,860 sq ft. It features a 52,000 sq ft clubhouse, premium amenities, seamless connectivity to metro, IT hubs, retail and healthcare outlets, and is designed for modern family living. Possession starts March 2028. (RERA P02200008770)",
        "amenities": [
            { "name": "52,000 sq ft Clubhouse (G+4)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Fitness Centre", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Sports: Squash, Badminton", "icon": "fas fa-table-tennis" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Children’s Play Zones & Creche", "icon": "fas fa-child" },
            { "name": "Party / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Medical Facility", "icon": "fas fa-clinic-medical" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure; curtain‑wall glazed façade" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti‑skid in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows with glass railings" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Weather‑shield exterior; acrylic interior finish" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular setup with tiled backsplash; hob/chimney provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tile cladding; premium CP fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging infrastructure" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, STP, rainwater harvesting" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire‑fighting systems, sprinklers, alarms" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Smart metering for utilities" }
        ],
        "gallery": [
            require("../images/projects/Flats/ASBL Landmark/gallery-1.jpg"),
            require("../images/projects/Flats/ASBL Landmark/gallery-2.jpg"),
            require("../images/projects/Flats/ASBL Landmark/gallery-3.jpg"),
            require("../images/projects/Flats/ASBL Landmark/gallery-4.jpg")
        ],
        "possession": {
            "expected": "March 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹8,199–8,799",
            "price_range_cr": ["1.35", "2.34"]
        },
        "rera": "P02200008770"
    },

    //ASBL Spectra
    {
        "id": "asbl-spectra",
        "project_name": "ASBL Spectra",
        "category": "Flats",
        "title": "ASBL Spectra",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/ASBL Spectra/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.85 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+39" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,182" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,980–2,220" }
        ],
        "description": "ASBL Spectra is an upscale, gated 3 BHK apartment complex by Ashoka Builders nestled in Gachibowli’s Financial District, spanning 7.85 acres across four 39-storey towers. With 76% open space and 1,182 homes featuring expansive Outdoor Living balconies (1,980–2,220 sq ft), it redefines luxury living. Includes a 75,000 sq ft clubhouse with multiple sports courts, indoor games, gym, pool, creche, EV charging, and 100% backup. Positioned near ORR, IT corridors, schools, and hospitals. RERA-accredited (P02400003071) and scheduled for possession in December 2025.",
        "amenities": [
            { "name": "75,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Outdoor Living Balconies", "icon": "fas fa-door-open" },
            { "name": "Gymnasium & Outdoor Sports Courts", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Games Room (Squash, Badminton)", "icon": "fas fa-chess-board" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Party Hall / Banquet", "icon": "fas fa-glass-cheers" },
            { "name": "EV Charging Infrastructure", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Jogging & Cycling Tracks", "icon": "fas fa-running" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC frame; independent walling per home" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti‑skid in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; UPVC/aluminium windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior; acrylic interior finish" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular setup; provision for hob, chimney, exhaust" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed tiles, CP fittings, anti‑skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for homes & common areas" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Central piped gas system" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply; STP; rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV, boom barriers" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Smart metering for utilities" }
        ],
        "gallery": [
            require("../images/projects/Flats/ASBL Spectra/gallery-1.jpg"),
            require("../images/projects/Flats/ASBL Spectra/gallery-2.jpg"),
            require("../images/projects/Flats/ASBL Spectra/gallery-3.jpg"),
            require("../images/projects/Flats/ASBL Spectra/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2025",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹5,177–5,500",
            "price_range_cr": ["1.68", "2.22"]
        },
        "rera": "P02400003071"
    },

    //ASBL Spire
    {
        "id": "asbl-spire",
        "project_name": "ASBL Spire",
        "category": "Flats",
        "title": "ASBL Spire",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/ASBL Spire/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2.85 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+36 (≈36–35)" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "393" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,905–2,120" }
        ],
        "description": "ASBL Spire is a premium single‑tower gated community by Ashoka Builders in Kokapet, Hyderabad, overlooking the lake. Spread over 2.85 acres, it has 393 exclusive 3 BHK apartments of 1,905 and 2,120 sq ft, each featuring an outdoor‑living balcony with planter boxes, water points and charging outlets. Boasting a 24,000 sq ft three‑storey clubhouse and resort‑style amenities, it offers lakefront living with high‑speed V3F lifts, 4‑level basement parking, full power/water backup, and 75% open landscaped spaces. Ready for occupancy since November 2023 (RERA P02400002261), it is one of Kokapet’s tallest (36 floors) and best‑connected lakeside residences..",
        "amenities": [
            { "name": "24,000 sq ft Clubhouse (3 storeys)", "icon": "fas fa-building" },
            { "name": "Sky‑level Gym & Fitness Studio", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Badminton Court", "icon": "fas fa-table-tennis" },
            { "name": "Children’s Play Area & Sandpit", "icon": "fas fa-child" },
            { "name": "Multipurpose Party Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Creche / Salon / Conference Room", "icon": "fas fa-users" },
            { "name": "Guest Waiting Lounge", "icon": "fas fa-coffee" },
            { "name": "4-level Basement Parking", "icon": "fas fa-car" },
            { "name": "24×7 CCTV & Security", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall framed; wind & earthquake‑resistant (Zone‑2)" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; uPVC/aluminium windows; glass balcony railings" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Textured exterior; acrylic emulsion interiors" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchen provision; hob/chimney, water purifier points" },
            { "icon": "fas fa-th", "title": "Outdoor Balcony", "content": "50% wider with planter, water inlet/outlet & power point" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, TV/broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup with acoustic enclosure & AMF" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Piped LPG provision" },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 municipal supply, STP, rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "CCTV, intercoms, boom barriers" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire alarms, sprinklers, wet risers" }
        ],
        "gallery": [
            require("../images/projects/Flats/ASBL Spire/gallery-1.jpg"),
            require("../images/projects/Flats/ASBL Spire/gallery-2.jpg"),
            require("../images/projects/Flats/ASBL Spire/gallery-3.jpg"),
            require("../images/projects/Flats/ASBL Spire/gallery-4.jpg")
        ],
        "possession": {
            "expected": "November 2023",
            "construction_status": "Ready to Move"
        },
        "price_info": {
            "avg_price_per_sqft": "₹6,188–7,800",
            "price_range_cr": ["1.12", "1.31"]
        },
        "rera": "P02400002261"
    },

    //Brigade Gateway
    {
        "id": "brigade-gateway",
        "project_name": "Brigade Gateway",
        "category": "Flats",
        "title": "Brigade Gateway",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Brigade Gateway/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "9.71 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+59" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "580" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 4, 5 & 6 BHK Luxury Homes" }
        ],
        "description": "Brigade Gateway is a highly anticipated pre‑launch residential landmark by Brigade Group in the heart of Kokapet, Hyderabad. Spread over 9.71 acres with a single 59‑storey tower housing 580 ultra‑spacious 3 to 6 BHK apartments, it blends contemporary design with world‑class finishes. With premium Italian marble interiors, panoramic glass façades, and thoughtfully planned layouts, Brigade Gateway promises an elevated urban living experience.",
        "amenities": [
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym", "icon": "fas fa-dumbbell" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "Yoga Pavilion", "icon": "fas fa-spa" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "24/7 CCTV & Security", "icon": "fas fa-shield-alt" },
            { "name": "Club House", "icon": "fas fa-building" },
            { "name": "Mini Theatre", "icon": "fas fa-film" }
        ],
        "specifications": [
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "Imported Italian natural marble flooring in all living areas"
            }
        ],
        "price_info": {
            "starting_price_cr": "4.12",
            "configurations": [
                {
                    "config": "3 BHK + Study",
                    "price_range_cr": "4.12–4.40",
                    "area_sqft": "3,065–3,075"
                },
                {
                    "config": "3 BHK + Study + Maid Room",
                    "price_range_cr": "4.47–4.79",
                    "area_sqft": "3,350"
                },
                {
                    "config": "4 BHK + Maid Room",
                    "price_range_cr": "5.57–6.01",
                    "area_sqft": "4,120–4,175"
                },
                {
                    "config": "4 BHK + Maid Room",
                    "price_range_cr": "6.96–7.16",
                    "area_sqft": "4,950–4,980"
                },
                {
                    "config": "5 BHK Duplex + Maid Room",
                    "price_range": "On Request",
                    "area_sqft": "5,760–5,800"
                },
                {
                    "config": "6 BHK Duplex + Maid Room + Home Office",
                    "price_range": "On Request",
                    "area_sqft": "9,785–9,860"
                }
            ]
        },
        "gallery": [
            require("../images/projects/Flats/Brigade Gateway/gallery-1.jpg"),
            require("../images/projects/Flats/Brigade Gateway/gallery-2.jpg"),
            require("../images/projects/Flats/Brigade Gateway/gallery-3.jpg"),
            require("../images/projects/Flats/Brigade Gateway/gallery-4.jpg")
        ],
        "rera": "P02400009142",
        "possession": {
            "status": "Pre‑launch",
            "expected": "TBD after RERA registration"
        }
    },

    //Candeur Crescent
    {
        "id": "candeur-crescent",
        "project_name": "Candeur Crescent",
        "category": "Flats",
        "title": "Candeur Crescent",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Candeur Crescent/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.5 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+50" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,230" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2.5 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,537–2,656" }
        ],
        "description": "Candeur Crescent is a premium high-rise gated community by Candeur Constructions in Serilingampally, Hyderabad. Spread over 5.5 acres with five towers of up to 50 storeys, it offers 1,230 luxury 2.5 & 3 BHK apartments ranging from 1,537 to 2,656 sq ft. With 80% corner flats, 10.1 ft ceilings, and a 62,000 sq ft clubhouse, the project ensures exclusivity (5 units per floor), abundant open spaces, and superior privacy. Strategically located near Lingampally railway (~200 m) and Metro, with seamless connectivity to ORR and Gachibowli. Possession starts December 2025. RERA P02500004515. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "62,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Badminton & Squash Courts", "icon": "fas fa-table-tennis" },
            { "name": "Multipurpose Hall & Banquet", "icon": "fas fa-glass-cheers" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Barbecue Area & Pavilion", "icon": "fas fa-hotdog" },
            { "name": "Spa, Sauna, Steam Room", "icon": "fas fa-spa" },
            { "name": "Football & Basketball Courts", "icon": "fas fa-futbol" },
            { "name": "Outdoor Gym", "icon": "fas fa-dumbbell" },
            { "name": "Conference / Business Lounge", "icon": "fas fa-briefcase" },
            { "name": "Medical Clinic", "icon": "fas fa-clinic-medical" },
            { "name": "24×7 Security, CCTV & Power Backup", "icon": "fas fa-shield-alt" },
            { "name": "ATM & Convenience Store", "icon": "fas fa-store" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high-rise structure (up to 50 storeys)" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in balconies & wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; flush internal doors; UPVC/aluminium windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Acrylic emulsion interior; weather-shield exterior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchen provision; hob/chimney/exhaust fittings" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings; glazed tile cladding; anti-skid floors" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed wiring; modular switches; TV & broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for flats & common areas" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Centralized piped gas supply" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, STP, rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security with access control & CCTV" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Sprinklers, fire alarms & firefighting systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Candeur Crescent/gallery-1.jpg"),
            require("../images/projects/Flats/Candeur Crescent/gallery-2.jpg"),
            require("../images/projects/Flats/Candeur Crescent/gallery-3.jpg"),
            require("../images/projects/Flats/Candeur Crescent/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2025",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹8,680–8,775",
            "price_range_cr": ["1.27", "2.33"]
        },
        "rera": "P02500004515"
    },

    //Candeur Lakescape
    {
        "id": "candeur-lakescape",
        "project_name": "Candeur Lakescape",
        "category": "Flats",
        "title": "Candeur Lakescape",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Candeur Lakescape/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "9.11 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "7" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+47" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,990" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5, 3 & 3.5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,296–2,416" }
        ],
        "description": "Candeur Lakescape is a lakeside luxury project by Candeur Constructions, situated in Kondapur, Hyderabad. Spread across 9.11 acres with seven 47‑storey towers and 1,990 apartments ranging from 2 to 3.5 BHK (1,296–2,416 sq ft), it offers high‑ceilings (≈11 ft), expansive lake views, and a 100,000 sq ft clubhouse. With 70% open greenspace, 50+ amenities, and strong connectivity to Lingampally station, Gachibowli, and ORR, possession is expected by December 2028 (RERA P02400005724).",
        "amenities": [
            { "name": "100,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Badminton & Squash Courts", "icon": "fas fa-table-tennis" },
            { "name": "Multipurpose / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Creche / Day Care", "icon": "fas fa-child" },
            { "name": "Rooftop Infinity Pool", "icon": "fas fa-swimmer" },
            { "name": "Outdoor Games Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Conference / Workspace Lounge", "icon": "fas fa-briefcase" },
            { "name": "Medical Clinic", "icon": "fas fa-clinic-medical" },
            { "name": "24×7 Security & Power Backup", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall framed structure, zone‑2 wind & earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "800×800 mm vitrified tiles in living/bedrooms; anti‑skid tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak wood main door; UPVC windows with mosquito mesh; flush internal doors" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Acrylic emulsion interiors; weather‑shield exterior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular provision; hob/chimney/exhaust points; tiled backsplash" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings; glazed tiles; anti‑skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup; treated water supply 24×7" },
            { "icon": "fas fa-gas-pump", "title": "LPG / PNG", "content": "Piped gas provision" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "Municipal supply, STP, rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, boom barriers, intercom" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire pumps, sprinklers & alarms" }
        ],
        "gallery": [
            require("../images/projects/Flats/Candeur Lakescape/gallery-1.jpg"),
            require("../images/projects/Flats/Candeur Lakescape/gallery-2.jpg"),
            require("../images/projects/Flats/Candeur Lakescape/gallery-3.jpg"),
            require("../images/projects/Flats/Candeur Lakescape/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹6,500–8,550",
            "price_range_cr": ["1.11", "2.07"]
        },
        "rera": "P02400005724"
    },

    //Cybercity Westbrook
    {
        "id": "cybercity-westbrook",
        "project_name": "Cybercity Westbrook",
        "category": "Flats",
        "title": "Cybercity Westbrook",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Cybercity Westbrook/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.8 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+35" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,102" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,075–2,400" }
        ],
        "description": "Cybercity Westbrook is a luxury scenic‑lake‑facing gated community in Kokapet, Hyderabad, developed by Cybercity Builders. Spread across 7.8 acres with three 35‑floor towers housing 1,102 spacious 2/3/4 BHK apartments (1,075–2,400 sq ft), it offers IGBC pre‑certified green‑building standards and ~82% open greenery. Designed by Hafeez Contractor, it features panoramic views, double‑height lobbies, and thoughtfully planned high‑rise living. Possession begins in October 2025 (RERA P02400003031).",
        "amenities": [
            { "name": "2 × 50,000 sq ft Clubhouses", "icon": "fas fa-building" },
            { "name": "Swimming Pools + Kids’ Pools", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Fitness Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Sports Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Squash & Badminton Courts", "icon": "fas fa-chess-board" },
            { "name": "Amphitheatre & Party Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Areas & Creche", "icon": "fas fa-child" },
            { "name": "Salon, Café & Grocery", "icon": "fas fa-coffee" },
            { "name": "Jogging & Cycling Tracks", "icon": "fas fa-running" },
            { "name": "EV Charging & 100 % Backup", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure & Compliance",
                "content": "RCC shear‑wall framed, IGBC pre‑certified, Vaastu‑compliant"
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "600×600 mm vitrified tiles in living; anti‑skid ceramic in balconies & wet area"
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Doors & Windows",
                "content": "Teak main doors, UPVC/aluminium windows, glass railings"
            },
            {
                "icon": "fas fa-lift",
                "title": "Lifts",
                "content": "High‑speed elevators by Toshiba/Mitsubishi/OTIS with 2.5 m/s speed"
            }
        ],
        "gallery": [
            require("../images/projects/Flats/Cybercity Westbrook/gallery-1.jpg"),
            require("../images/projects/Flats/Cybercity Westbrook/gallery-2.jpg"),
            require("../images/projects/Flats/Cybercity Westbrook/gallery-3.jpg"),
            require("../images/projects/Flats/Cybercity Westbrook/gallery-4.jpg")
        ],
        "possession": {
            "expected": "October 2025",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹9,400",
            "price_range_cr": ["1.01", "2.39"]
        },
        "rera": "P02400003031"
    },

    //Casagrand Evon
    {
        "id": "casagrand-evon",
        "project_name": "Casagrand Evon",
        "category": "Flats",
        "title": "Casagrand Evon",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Casagrand Evon/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "6.8 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+11" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "579" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "2,076–2,929" }
        ],
        "description": "Casagrand Evon is a premium gated community in Kompally, Hyderabad by Casagrand Builder Pvt Ltd. Spanning 6.8 acres with two towers (G+11) and 579 apartments (3 & 4 BHK, 2,076–2,929 sq ft), it offers 62% open landscaping, Japanese-themed gardens, and a vast 35,000 sq ft clubhouse across 4 floors.​:contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "35,000 sq ft Clubhouse (4 floors)", "icon": "fas fa-building" },
            { "name": "Rooftop Infinity Pool & Kids' Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Fitness Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games (Table‑Tennis, Billiards, VR Lounge)", "icon": "fas fa-chess-board" },
            { "name": "Multipurpose Hall & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Area + Creche", "icon": "fas fa-child" },
            { "name": "Senior Citizen Lounge & Reflexology Path", "icon": "fas fa-spa" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "Trampoline Zone & Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Business Centre & Co‑working Space", "icon": "fas fa-briefcase" },
            { "name": "Sky‑Cinema & Terrace Bar", "icon": "fas fa-video" },
            { "name": "24×7 Security, CCTV, Gated Access", "icon": "fas fa-shield-alt" },
            { "name": "Car Wash Bay & EV Charging", "icon": "fas fa-car" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with seismic (Zone‑2) compliance" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "1200×1800 mm vitrified tiles in living; 800×1600 mm anti‑skid in bathrooms; 600×1200 mm wood‑finish on balconies" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Engineered main doors with digital locks; aluminium windows with toughened glass & mosquito mesh" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchen provision with hob, chimney & exhaust points" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Kohler‑equivalent CP fittings; glazed tiles; granite‑top washbasins" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; 3‑phase power; TV & broadband points; DG backup" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, intercom, controlled access" }
        ],
        "gallery": [
            require("../images/projects/Flats/Casagrand Evon/gallery-1.jpg"),
            require("../images/projects/Flats/Casagrand Evon/gallery-2.jpg"),
            require("../images/projects/Flats/Casagrand Evon/gallery-3.jpg"),
            require("../images/projects/Flats/Casagrand Evon/gallery-4.jpg")
        ],
        "possession": {
            "expected": "March 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "starting_price_cr": "1.50",
            "avg_price_per_sqft": "₹7,780",
            "price_range_cr": ["1.50", "2.30"]
        },
        "rera": "P02200009350"
    },

    //Casagrand - GS Infinity
    {
        "id": "casagrand-gs-infinity",
        "project_name": "Casagrand - GS Infinity",
        "category": "Flats",
        "title": "Casagrand - GS Infinity",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Casagrand - GS Infinity/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.8 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+35" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "405" },
            { "icon": "fas fa-home", "title": "Flats & Villas", "value": "3, 4 BHK Apartments & 5 BHK Floor Villas" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "2,386 – 3,917" }
        ],
        "description": "Casagrand GS Infinity is a premium Manhattan‑style gated community in Attapur, Hyderabad, spanning 4.8 acres with three soaring 35‑storey towers and 405 luxury homes including 3/4 BHK apartments and 5 BHK floor villas (2,386–3,917 sq ft). Each corner unit ensures three‑sided ventilation and full‑length private balconies. Featuring a massive 41,000 sq ft clubhouse, over 100 world-class amenities, 80% open landscaped areas, and 24×7 security, the project is scheduled for possession in April 2030 and is RERA‑registered under P02500009503. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "41,000 sq ft Grand Clubhouse (G+5)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Fitness Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Sports Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Mini Theatre & Amphitheatre", "icon": "fas fa-film" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Senior Citizen Lounge & Reflexology Path", "icon": "fas fa-umbrella-beach" },
            { "name": "EV Charging & 100% Backup", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Golf Simulator", "icon": "fas fa-golf-ball" }
        ],
        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure & Ventilation",
                "content": "RCC shear‑wall framed, corner units with three‑sided ventilation, Manhatttan‑style facade"
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "Vitrified tiles in living/bedrooms; premium anti‑skid tiles in wet areas"
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Doors & Windows",
                "content": "8 ft high grand main doors with digital locks; UPVC/Aluminium windows, full‑length balcony railings"
            },
            {
                "icon": "fas fa-lift",
                "title": "Lifts",
                "content": "High‑speed passenger and service lifts servicing all floors"
            }
        ],
        "gallery": [
            require("../images/projects/Flats/Casagrand - GS Infinity/gallery-1.jpg"),
            require("../images/projects/Flats/Casagrand - GS Infinity/gallery-2.jpg"),
            require("../images/projects/Flats/Casagrand - GS Infinity/gallery-3.jpg"),
            require("../images/projects/Flats/Casagrand - GS Infinity/gallery-4.jpg")
        ],
        "possession": {
            "expected": "April 2030",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹7,325",
            "price_range_cr": ["1.95", "3.19"]
        },
        "rera": "P02500009503"
    },

    //DSR Altitudes
    {
        "id": "dsr-altitudes",
        "project_name": "DSR Altitudes",
        "category": "Flats",
        "title": "DSR Altitudes",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/DSR Altitudes/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+32" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "980" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Size (Sqft)", "value": "2,277" }
        ],
        "description": "DSR Altitudes is a luxury gated community by DSR KC Builders in Osman Nagar, Tellapur (West Hyderabad). Spread over 7 acres with five towers (G+32) and 980 identical 3 BHK apartments (2,277 sq ft), it features 75% open green space, double-height entrance lobbies, IGBC-conscious design, and premium amenities. Priced from around ₹1.73 Cr (~₹7,600–7,800/sq ft) with possession by October 2029 (RERA P01100009092).",
        "amenities": [
            { "name": "50,000 sq ft Clubhouse (G+6)", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Children’s Play Area & Sandpit", "icon": "fas fa-child" },
            { "name": "Outdoor Sports Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "EV Car Charging", "icon": "fas fa-charging-station" },
            { "name": "Grocery Shop", "icon": "fas fa-shopping-basket" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear-wall framed towers with double-height lobbies" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living & bedrooms; anti-skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Acrylic emulsion interiors; exterior weather-shield" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertop; hob & chimney provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Anti-skid tiles; premium CP fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; TV/Broadband points" },
            { "icon": "fas fa-charging-station", "title": "Power & EV", "content": "100% DG backup; EV charging points" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "24×7 water; STP; rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security with boom barriers & CCTV" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire alarms, hydrants & sprinklers" }
        ],
        "gallery": [
            require("../images/projects/Flats/DSR Altitudes/gallery-1.jpg"),
            require("../images/projects/Flats/DSR Altitudes/gallery-2.jpg"),
            require("../images/projects/Flats/DSR Altitudes/gallery-3.jpg"),
            require("../images/projects/Flats/DSR Altitudes/gallery-4.jpg")
        ],
        "possession": {
            "expected": "October 2029",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹7,600–7,800",
            "starting_price_cr": "1.73"
        },
        "rera": "P01100009092"
    },

    //DSR The Twins
    {
        "id": "dsr-the-twins",
        "project_name": "DSR The Twins",
        "category": "Flats",
        "title": "DSR The Twins",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/DSR The Twins/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3.6 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+44" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "85" },
            { "icon": "fas fa-home", "title": "Flats", "value": "5 BHK (one per floor)" },
            { "icon": "fas fa-ruler-combined", "title": "Size (Sqft)", "value": "15,999" }
        ],
        "description": "DSR The Twins is Hyderabad’s ultra‑luxury twin‑tower residential project in Puppalaguda’s Financial District. Spread over 3.6 acres, the two 44‑storey towers feature just 85 exclusive 5 BHK sky homes of 15,999 sq ft each— making them some of India’s largest apartments, with only one flat per floor. The project offers high‑slab heights (13 ft), panoramic glass façades, central vacuum & pest‑control systems, treated fresh‑air ventilation, smart home and biometric access, with possession expected in late 2028. RERA P02400005887."
        ,
        "amenities": [
            { "name": "50,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Infinity & Kids Pool", "icon": "fas fa-swimmer" },
            { "name": "Spa & Snooker Room", "icon": "fas fa-chess-board" },
            { "name": "Gym & Restaurant", "icon": "fas fa-dumbbell" },
            { "name": "Multipurpose Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Squash Court", "icon": "fas fa-baseball-ball" },
            { "name": "Basketball Court, Jogging Track", "icon": "fas fa-basketball-ball" },
            { "name": "Pet Park", "icon": "fas fa-paw" },
            { "name": "Outdoor Party Spaces & Lawns", "icon": "fas fa-tree" },
            { "name": "Central Vacuum & Pest Control", "icon": "fas fa-ban" }
        ],
        "specifications": [
            { "icon": "fas fa-border-style", "title": "Ceiling Height", "content": "Luxurious 13 ft floor-to-floor slab height" },
            { "icon": "fas fa-door-closed", "title": "Facade", "content": "Panoramic glass curtain wall—South India’s first twin towers" },
            { "icon": "fas fa-lift", "title": "Lifts", "content": "High‑speed elevators with treated fresh‑air system" },
            { "icon": "fas fa-shield-alt", "title": "Security & Systems", "content": "Smart home, biometric locks, central vacuum & pest control" }
        ],
        "gallery": [
            require("../images/projects/Flats/DSR The Twins/gallery-1.jpg"),
            require("../images/projects/Flats/DSR The Twins/gallery-2.jpg"),
            require("../images/projects/Flats/DSR The Twins/gallery-3.jpg"),
            require("../images/projects/Flats/DSR The Twins/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "price_range_cr": ["19.08", "19.20"],
            "avg_price_per_sqft": "₹12,000"
        },
        "rera": "P02400005887"
    },

    //DSR SkyMarq
    {
        "id": "dsr-sky-marq",
        "project_name": "DSR SkyMarq",
        "category": "Flats",
        "title": "DSR SkyMarq",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/DSR SkyMarq/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.11 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G + 40 / 42" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "664" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK Sky Homes" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "3,999–5,454" }
        ],
        "description": "DSR Sky Marq is a luxurious gated high-rise community in Puppalaguda by DSR Builders, spanning 7.11 acres with four towers (two with G+40, two with G+42). Housing 664 ultra‑spacious 4 BHK apartments (3,999–5,454 sq ft), it features expansive high-rise lobbies, bioclimatic architecture, and a multi-level clubhouse. Located near the Financial District and ORR, with possession slated for May 2028 (RERA P02400004592).",
        "amenities": [
            { "name": "45,000 sq ft Multi‑level Clubhouse", "icon": "fas fa-building" },
            { "name": "Temperature‑controlled Swimming & Kids Pools", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Fitness Centre", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Badminton, Squash, Table‑Tennis", "icon": "fas fa-chess-board" },
            { "name": "Bowling Alley & Mini‑Theatre", "icon": "fas fa-film" },
            { "name": "Meditation & Yoga Hall", "icon": "fas fa-praying-hands" },
            { "name": "Pet Park & Children’s Play Zones", "icon": "fas fa-child" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Conference Room & Lounge", "icon": "fas fa-briefcase" },
            { "name": "Salon & Spa", "icon": "fas fa-spa" },
            { "name": "Coffee Lounge", "icon": "fas fa-coffee" },
            { "name": "Barbecue & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Multipurpose Hall", "icon": "fas fa-users" },
            { "name": "Central Vacuum & Temperature‑Controlled Pools", "icon": "fas fa-bolt" },
            { "name": "24×7 Security, CCTV, Biometric Access", "icon": "fas fa-shield-alt" },
            { "name": "Power & Water Backup", "icon": "fas fa-charging-station" }
        ],
        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure",
                "content": "RCC shear‑wall framed with bioclimatic design; high‑slab heights"
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "Premium vitrified throughout; anti‑skid in wet areas"
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Doors & Windows",
                "content": "Teak main doors; UPVC/aluminium windows; large glazed façades"
            },
            {
                "icon": "fas fa-lift",
                "title": "Lifts",
                "content": "High‑speed elevators with biometric access"
            },
            {
                "icon": "fas fa-charging-station",
                "title": "Power & Backup",
                "content": "100% DG power backup; water with STP"
            }
        ],
        "gallery": [
            require("../images/projects/Flats/DSR SkyMarq/gallery-1.jpg"),
            require("../images/projects/Flats/DSR SkyMarq/gallery-2.jpg"),
            require("../images/projects/Flats/DSR SkyMarq/gallery-3.jpg"),
            require("../images/projects/Flats/DSR SkyMarq/gallery-4.jpg")
        ],
        "possession": {
            "expected": "May 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹11,000",
            "price_range_cr": ["4.39", "5.99"]
        },
        "rera": "P02400004592"
    },

    //DSR - The Classe
    {
        "id": "dsr-the-classe",
        "project_name": "DSR - The Classe",
        "category": "Flats",
        "title": "DSR - The Classe",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/DSR - The Classe/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.9 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+27/28" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "448" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "2,552–3,939" }
        ],
        "description": "DSR The Classe by DSR SSC Builders is a luxury residential project in Narsingi/Puppalaguda, West Hyderabad. Spread over approximately 4.9 acres with four towers of G+27/28, it offers 448 well‑ventilated 3 & 4 BHK apartments ranging from about 2,552 to 3,939 sq ft, each with corner layouts and Vastu compliance. The stilt level is designed as a vehicle‑free zone enhancing safety and tranquility. Scheduled for possession in December 2025, it's RERA‑registered under P02400001671.:contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Multipurpose Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Area & Sandpit", "icon": "fas fa-child" },
            { "name": "Jogging & Cycle Track", "icon": "fas fa-running" },
            { "name": "Reflexology Path / Senior Citizen Lounge", "icon": "fas fa-spa" },
            { "name": "Convenience Store", "icon": "fas fa-shopping-basket" },
            { "name": "Yoga Room", "icon": "fas fa-praying-hands" },
            { "name": "24×7 Security, CCTV, Boom Barriers", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & Treated Water Supply", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC frame with earthquake‑resistant structure and vehicle‑free stilt level" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified flooring in living/bedrooms" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows; video‑door phones" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Acrylic emulsion interiors, weather‑shield exterior" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchen provisions; granite counters; hob/chimney points" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; power backup" },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Treated water 24×7; rainwater harvesting; STP" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, boom barriers, manned gate" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire‑fighting systems, alarms, sprinklers" }
        ],
        "gallery": [
            require("../images/projects/Flats/DSR - The Classe/gallery-1.jpg"),
            require("../images/projects/Flats/DSR - The Classe/gallery-2.jpg"),
            require("../images/projects/Flats/DSR - The Classe/gallery-3.jpg"),
            require("../images/projects/Flats/DSR - The Classe/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2025",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "price_range_cr": ["2.68", "4.14"],
            "avg_price_per_sqft": "₹10.5K"
        },
        "rera": "P02400001671"
    },

    //DSR - Valar
    {
        "id": "dsr-valar",
        "project_name": "DSR - Valar",
        "category": "Flats",
        "title": "DSR - Valar",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/DSR - Valar/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+36" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "282" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "3,242–4,090" }
        ],
        "description": "DSR Valar is an ultra‑luxury gated community by DSR Infra in Kokapet, Hyderabad. Launched in Jan 2023 on a 3‑acre lakeside site, it comprises two 36‑storey towers with 282 spacious 4 BHK apartments (3,242–4,090 sq ft). Each quadrant home is a corner unit offering panoramic views. It features a 32,000 sq ft clubhouse, infinity pool, yoga lawn, amphitheatre, pet zone, creche, and abundant greenery. Priced from ₹3.24–4.09 Cr (~₹10,000/sq ft), with possession starting August 2027 and RERA P02400005583..",
        "amenities": [
            { "name": "32,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Infinity Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Yoga Lawn & Amphitheatre", "icon": "fas fa-praying-hands" },
            { "name": "Pet Zone & Pet House", "icon": "fas fa-paw" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Carrom, TT & Indoor Games", "icon": "fas fa-chess-board" },
            { "name": "Fully Equipped Gym", "icon": "fas fa-dumbbell" },
            { "name": "24×7 Security, CCTV & Intercom", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & Treated Water", "icon": "fas fa-charging-station" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed towers with quadrant‑corner homes" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows" },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Treated 24×7 municipal water; STP & rainwater harvesting" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed wiring; DG backup; intercoms" },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing System", "content": "Automated utility metering" }
        ],
        "gallery": [
            require("../images/projects/Flats/DSR - Valar/gallery-1.jpg"),
            require("../images/projects/Flats/DSR - Valar/gallery-2.jpg"),
            require("../images/projects/Flats/DSR - Valar/gallery-3.jpg"),
            require("../images/projects/Flats/DSR - Valar/gallery-4.jpg")
        ],
        "possession": {
            "expected": "August 2027",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "price_range_cr": ["3.24", "4.09"],
            "avg_price_per_sqft": "₹10,000"
        },
        "rera": "P02400005583"
    },

    //EIPL Cornerstone
    {
        "id": "eipl-cornerstone",
        "project_name": "EIPL Cornerstone",
        "category": "Flats",
        "title": "EIPL Cornerstone",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/EIPL Cornerstone/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "9 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "10" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+14" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "989" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2.5 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,370–2,350" }
        ],
        "description": "EIPL Cornerstone is a gated residential community by EIPL Group located in Puppalaguda, Hyderabad, just minutes from the Outer Ring Road and major IT hubs. Spread across 9 acres, it features 10 towers of G+14 floors with 989 thoughtfully planned 2.5 & 3 BHK flats ranging from 1,370 to 2,350 sq ft. The project offers quality craftsmanship, Vastu design, full power & water backup, piped LPG, and smart living amenities. RERA‑registered (P02400005057), possession is expected by March 2026, and some units are already ready-to-move..",
        "amenities": [
            { "name": "50,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Spa", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games & Mini Theatre", "icon": "fas fa-chess-board" },
            { "name": "Amphitheatre & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Sports Courts (Badminton, Basketball, Cricket)", "icon": "fas fa-basketball-ball" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Business Lounge & ATM", "icon": "fas fa-briefcase" },
            { "name": "Electric Car Charging", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security, CCTV & Boom Barriers", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed, shear‑wall structures with Vastu compliance" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles throughout; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows; intercom-equipped lifts" },
            { "icon": "fas fa-bolt", "title": "Power & Utilities", "content": "100% DG backup, piped LPG, water‑softening plant, STP" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Surveillance cameras, panic buttons, solar/barbed‑wire fencing" },
            { "icon": "fas fa-lift", "title": "Lifts", "content": "High‑speed Mitsubishi elevators with V3F energy efficiency" }
        ],
        "gallery": [
            require("../images/projects/Flats/EIPL Cornerstone/gallery-1.jpg"),
            require("../images/projects/Flats/EIPL Cornerstone/gallery-2.jpg"),
            require("../images/projects/Flats/EIPL Cornerstone/gallery-3.jpg"),
            require("../images/projects/Flats/EIPL Cornerstone/gallery-4.jpg"),
        ],
        "possession": {
            "expected": "March 2026",
            "construction_status": "Under Construction / Some Ready to Move"
        },
        "price_info": {
            "price_range_cr": ["1.00", "2.16"],
            "avg_price_per_sqft": "₹8,175"
        },
        "rera": "P02400005057"
    },

    //EIPL Tamarind
    {
        "id": "eipl-tamarind",
        "project_name": "EIPL Tamarind",
        "category": "Flats",
        "title": "EIPL Tamarind",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/EIPL Tamarind/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3.5 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+14" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "359" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,280–2,410" }
        ],
        "description": "EIPL The Tamarind is a gated mid‑rise community by EIPL Group located in the emerging Neknampur/Manikonda corridor, Hyderabad. Spread across 3.5 acres with three 14‑storey towers and 359 apartments (2–3 BHK, 1,280–2,410 sq ft), it offers a 20,000 sq ft clubhouse, landscaped gardens, modern amenities including indoor games, sports courts, swimming pools, gym, yoga studio, banquet hall, treated water, piped gas & full backup. Launched in May 2023, possession expected May 2027. RERA P02400006803.",
        "amenities": [
            { "name": "20,000 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Aerobics & Yoga Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games (TT, Billiards, Chess/Carrom)", "icon": "fas fa-chess-board" },
            { "name": "Badminton & Cricket Practice Court", "icon": "fas fa-basketball-ball" },
            { "name": "Multipurpose / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Jogging & Cycle Tracks", "icon": "fas fa-running" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Piped LPG & Power Backup", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security, CCTV & Boom Barriers", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with shear walls, earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living & bedrooms; anti‑skid in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; UPVC/aluminium windows" },
            { "icon": "fas fa-bolt", "title": "Electrical & Utilities", "content": "Concealed wiring; modular switches; TV/Broadband points; 100% DG backup; piped gas; treated water" },
            { "icon": "fas fa-shield-alt", "title": "Safety & Security", "content": "24×7 surveillance, intercom, fire alarms & firefighting" }
        ],
        "gallery": [
            require("../images/projects/Flats/EIPL Tamarind/gallery-1.jpg"),
            require("../images/projects/Flats/EIPL Tamarind/gallery-2.jpg"),
            require("../images/projects/Flats/EIPL Tamarind/gallery-3.jpg"),
            require("../images/projects/Flats/EIPL Tamarind/gallery-4.jpg")
        ],
        "possession": {
            "expected": "May 2027",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "price_range_cr": ["0.88", "1.73"],
            "avg_price_per_sqft": "₹8,500"
        },
        "rera": "P02400006803"
    },

    //E - Infra Moonglade
    {
        "id": "ira-moonglade",
        "project_name": "E - Infra Moonglade",
        "category": "Flats",
        "title": "E - Infra Moonglade",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/E - Infra Moonglade/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "14 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "7" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "2B+Stilt+4 Podium+40" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈2,400" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,400–3,950" }
        ],
        "description": "Ira Moonglade (by E‑Infra & Ira Ventures) is a luxurious high‑rise gated community in Kokapet, Hyderabad. Sprawled across 14 acres with seven majestic towers rising to 40 floors, it houses approximately 2,400 premium 3 and 4 BHK apartments (1,400–3,950 sq ft). The project features an 8‑storey starlight clubhouse, expansive podiums, vehicle‑free zones, bioclimatic architecture with sky‑bridges, and extensive greenery with lakeside and park views. Strategically located off the ORR near Kothaguda Exit 18A, it offers seamless connectivity to Gachibowli, Financial District, and HITEC City. Possession begins November 2029 under RERA P02400009267. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "8‑storey Starlight Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pools (Adult + Kids)", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Yoga & Aerobics Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games & Mini‑Theatre", "icon": "fas fa-chess-board" },
            { "name": "Multipurpose Hall & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Jogging & Cycling Tracks", "icon": "fas fa-running" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Oxygen Valley & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Sky‑bridges & Water‑bridges", "icon": "fas fa-water" },
            { "name": "Business Centre & Lounge", "icon": "fas fa-briefcase" },
            { "name": "EV Charging & 100% Backup", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security, CCTV & Boom Barriers", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high‑rise structure with bioclimatic design & vehicle‑free podium" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified flooring in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors; UPVC/aluminium windows" },
            { "icon": "fas fa-water", "title": "Water & Sustainability", "content": "24×7 treated water, STP, rain‑water harvesting" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, TV/Broadband points, 100% DG backup" },
            { "icon": "fas fa-shield-alt", "title": "Security & Safety", "content": "Intercoms, fire alarms, surveillance, boom barriers" }
        ],
        "gallery": [
            require("../images/projects/Flats/E - Infra Moonglade/gallery-1.jpg"),
            require("../images/projects/Flats/E - Infra Moonglade/gallery-2.jpg"),
            require("../images/projects/Flats/E - Infra Moonglade/gallery-3.jpg"),
            require("../images/projects/Flats/E - Infra Moonglade/gallery-4.jpg")
        ],
        "possession": {
            "expected": "November 2029",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "price_range_cr": ["1.26", "4.00"],
            "avg_price_per_sqft": "₹9,000"
        },
        "rera": "P02400009267"
    },

    //E - Infra Skyven
    {
        "id": "the-skyven",
        "project_name": "E - Infra Skyven",
        "category": "Flats",
        "title": "E - Infra Skyven",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/E - Infra Skyven/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "4 Basement+3 Stilt+63" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "210" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK Sky Residences/ Skyvillas" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "5,662–6,278" }
        ],
        "description": "The Skyven, by E‑Infra & PVR Pingle Ventures, is South India’s tallest residential tower in Kokapet. Rising 755 ft over 63 floors, it features 210 ultra‑luxury 4 BHK sky homes (5,662–6,278 sq ft), each with L‑shaped balconies, private home theatres, family lounges, and dual maid rooms. With just one building on a 2‑acre site, The Skyven emphasizes exclusivity, privacy, and skyline living experience. RERA‑registered (P02400009501), possession expected Feb 2030."
        ,
        "amenities": [
            { "name": "100,000 sq ft Clubhouse over floors 4–6", "icon": "fas fa-building" },
            { "name": "Rooftop Infinity Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Star Observatory on 63rd Floor", "icon": "fas fa-star" },
            { "name": "Cigar Room & Lounge", "icon": "fas fa-smoking" },
            { "name": "Home Theatre in Each Apartment", "icon": "fas fa-film" },
            { "name": "Gym, Yoga Studio & Indoor Games", "icon": "fas fa-dumbbell" },
            { "name": "Squash & Badminton Courts", "icon": "fas fa-table-tennis" },
            { "name": "Library, Banquet Hall & Party Lawns", "icon": "fas fa-glass-cheers" },
            { "name": "Co‑working Spaces", "icon": "fas fa-briefcase" },
            { "name": "Helipad & EV Charging", "icon": "fas fa-charging-station" },
            { "name": "24×7 AI Security, Biometrics & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Water Softener & 100% DG Backup", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-border-style", "title": "Ceiling Height", "content": "12 ft floor‑to‑ceiling slab heights" },
            { "icon": "fas fa-door-closed", "title": "Facade & Doors", "content": "Panoramic glazed façades; teak doors; L‑shaped balconies" },
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed skyscraper with bioclimatic design" },
            { "icon": "fas fa-bolt", "title": "Smart & Utilities", "content": "Smart BMS, biometric lifts, EV‑ready, 100% backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/E - Infra Skyven/gallery-1.jpg"),
            require("../images/projects/Flats/E - Infra Skyven/gallery-2.jpg"),
            require("../images/projects/Flats/E - Infra Skyven/gallery-3.jpg"),
            require("../images/projects/Flats/E - Infra Skyven/gallery-4.jpg")
        ],
        "possession": {
            "expected": "February 2030",
            "construction_status": "New Launch / Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹11,000",
            "price_range_cr": ["3.89", "6.91"]
        },
        "rera": "P02400009501"
    },

    //Frontline Seven
    {
        "id": "frontline-seven",
        "project_name": "Frontline Seven",
        "category": "Flats",
        "title": "Frontline Seven",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Frontline Seven/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "6.84 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "6" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "2 Basements + Ground + 12 Floors" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "670" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,330–2,185" }
        ],
        "description": "Frontline Seven by Frontline Builders is a ready-to-move gated community in Kokapet, Hyderabad. Covering 6.84 acres with six towers (G+12) and 670 units of 2 & 3 BHK homes (1,330–2,185 sq ft), it offers a balance of location and lifestyle. Launched in Jan 2020 and RERA‑registered under P02400001563, possession began Oct 2024. Units are priced between ₹1.18 Cr and ₹1.94 Cr (~₹8.7–8.9 K / sq ft).",
        "amenities": [
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Badminton & Tennis Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Pitch", "icon": "fas fa-baseball-ball" },
            { "name": "Multipurpose Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Senior Citizen Lounge", "icon": "fas fa-spa" },
            { "name": "Convenience Store & Community Clinic", "icon": "fas fa-shopping-basket" },
            { "name": "Medical Store / Pharmacy", "icon": "fas fa-clinic-medical" },
            { "name": "Restaurant / Coffee Lounge", "icon": "fas fa-coffee" },
            { "name": "Conference Room", "icon": "fas fa-briefcase" },
            { "name": "Party Lounge & Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Preview Theatre", "icon": "fas fa-video" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power & Water Backup", "icon": "fas fa-charging-station" },
            { "name": "Treated Water & Solar Heating", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with Vastu compliance" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti-skid in wet zones" },
            { "icon": "fas fa-bolt", "title": "Utilities", "content": "Concealed wiring, modular switches, 24x7 treated water, STP, piped LPG, 100% DG backup" },
            { "icon": "fas fa-shield-alt", "title": "Safety", "content": "24×7 CCTV, intercom, fire-fighting systems" },
            { "icon": "fas fa-lift", "title": "Lifts", "content": "High-speed elevators with power backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/Frontline Seven/gallery-1.jpg"),
            require("../images/projects/Flats/Frontline Seven/gallery-2.jpg"),
            require("../images/projects/Flats/Frontline Seven/gallery-3.jpg"),
            require("../images/projects/Flats/Frontline Seven/gallery-4.jpg")
        ],
        "possession": {
            "expected": "October 2024",
            "construction_status": "Ready to Move"
        },
        "price_info": {
            "price_range_cr": ["1.18", "1.94"],
            "avg_price_per_sqft": "₹8,700–8,900"
        },
        "rera": "P02400001563"
    },

    //Fuji Halcyon
    {
        "id": "fuji-halcyon",
        "project_name": "Fuji Halcyon",
        "category": "Flats",
        "title": "Fuji Halcyon",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Fuji Halcyon/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2.2 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "11 Floors (4 Cellar + Stilt + 11)" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "75" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 & 5 BHK Ultra‑Luxury Homes" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "7,504–10,121" }
        ],
        "description": "Fuji Halcyon is Hyderabad's most premium hilltop gated residence located in Jubilee Hills. Spread over 2.2 acres on a private hilltop, this exclusive single‑tower project offers only 75 sprawling 4 and 5 BHK residences (7,504–10,121 sq ft), each with private lifts and spectacular 360° city views. Featuring 40,000 sq ft terrace amenities and a 17,625 sq ft clubhouse, the project is scheduled for possession in December 2028, under RERA P02500005860..",
        "amenities": [
            { "name": "40,000 sq ft Terrace Amenities", "icon": "fas fa-tree" },
            { "name": "17,625 sq ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Multi‑Sport Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Meditation Hall & Spa", "icon": "fas fa-praying-hands" },
            { "name": "Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Conference Rooms", "icon": "fas fa-briefcase" },
            { "name": "Luxury Salon", "icon": "fas fa-spa" },
            { "name": "Deluxe Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "Pet Zone", "icon": "fas fa-paw" },
            { "name": "Movie Theatre", "icon": "fas fa-film" },
            { "name": "Creche / Day Care", "icon": "fas fa-child" },
            { "name": "Yoga / Reflexology Deck", "icon": "fas fa-spa" },
            { "name": "EV Charging & 100% Backup", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high‑end construction with private lifts to each home" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Designer hardwood doors; panoramic glazed façades" },
            { "icon": "fas fa-bolt", "title": "Utilities", "content": "Concealed wiring; modular switches; full DG & water backup" },
            { "icon": "fas fa-shield-alt", "title": "Safety & Security", "content": "24×7 surveillance, intercom, fire‑fighting systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Fuji Halcyon/gallery-1.jpg"),
            require("../images/projects/Flats/Fuji Halcyon/gallery-2.jpg"),
            require("../images/projects/Flats/Fuji Halcyon/gallery-3.jpg"),
            require("../images/projects/Flats/Fuji Halcyon/gallery-4.jpg")
        ],
        "possession": {
            "expected": "December 2028",
            "construction_status": "Under Construction"
        },
        "price_info": {
            "avg_price_per_sqft": "₹14,000 / sq ft",
            "price_range_cr": ["On Request"]
        },
        "rera": "P02500005860"
    },

    // Bhanu
    // Gem Nakshathra 
    {
        "id": "gemnakshathra",
        "project_name": "Gem Nakshathra",
        "category": "Flats",
        "title": "Gem Nakshathra by Gem Vivendas",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Gem Nakshathra/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector‑square", "title": "Extent", "value": "2.1 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3 (Phase I)" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "18" },
            { "icon": "fas fa-door‑open", "title": "Units", "value": "576" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5, 3 BHK" },
            { "icon": "fas fa-ruler‑combined", "title": "2 BHK (Sqft)", "value": "1,290; 1,295" },
            { "icon": "fas fa-ruler‑combined", "title": "2.5 BHK (Sqft)", "value": "1,485" },
            { "icon": "fas fa-ruler‑combined", "title": "3 BHK (Sqft)", "value": "1,640; 1,815–1,885" }
        ],
        "description": "Gem Nakshathra by Gem Vivendas is a premium gated community in Kokapet, Hyderabad, featuring 576 Vastu-compliant 2, 2.5, and 3 BHK apartments across three 18-storey towers on 2.1 acres. With spacious layouts, modern amenities, and RERA approval, it offers ready-to-move homes close to schools, hospitals, and IT hubs.",
        "amenities": [
            { "name": "Exclusive Clubhouse (27,000 sqft)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Aerobics", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Multipurpose Hall", "icon": "fas fa-users" },
            { "name": "Amphitheatre", "icon": "fas fa-film" },
            { "name": "Guest Rooms", "icon": "fas fa-door-open" },
            { "name": "Convenience Store & Laundry", "icon": "fas fa-store" },
            { "name": "Outdoor Gym, Jogging Track", "icon": "fas fa-running" },
            { "name": "Badminton & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Yoga & Meditation Zone", "icon": "fas fa-spa" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Creche / Crèche", "icon": "fas fa-baby" },
            { "name": "24×7 Power Backup", "icon": "fas fa-bolt" },
            { "name": "Covered Car Parking", "icon": "fas fa-car" },
            { "name": "CCTV & Security", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/dining; anti‑skid tiles in wet areas" },
            { "icon": "fas fa-door‑closed", "title": "Doors & Windows", "content": "Teak main door, flush internal doors, UPVC windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modern modular kitchen provisioned for chimney, hob, water purifier" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitaryware with full-height tiles" },
            { "icon": "fas fa-wifi", "title": "Internet / Telecom", "content": "Intercom, broadband & cable TV provision" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with premium modular switches" },
            { "icon": "fas fa-battery-full", "title": "Power Backup", "content": "100% DG backup for common areas & essential flats" },
            { "icon": "fas fa-water", "title": "Water", "content": "Treated water supply & STP" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "Sewage treatment plant and drainage" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV surveillance & manned entry" },
            { "icon": "fas fa-car", "title": "Parking", "content": "Covered car parking with EV charging provision" }
        ],
        "gallery": [
            require("../images/projects/Flats/Gem Nakshathra/gallery_1.jpg"),
            require("../images/projects/Flats/Gem Nakshathra/gallery_2.jpg"),
            require("../images/projects/Flats/Gem Nakshathra/gallery_3.jpg"),
            require("../images/projects/Flats/Gem Nakshathra/gallery_4.jpg"),
            require("../images/projects/Flats/Gem Nakshathra/gallery_5.jpg"),
            require("../images/projects/Flats/Gem Nakshathra/gallery_6.jpg"),
        ]
    },

    // Godrej Madison Avenue
    {
        "id": "godrej_madison_avenue",
        "project_name": "Godrej Madison Avenue",
        "category": "Flats",
        "title": "Godrej Madison Avenue by Godrej Properties",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Godrej Madison Avenue/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3.0 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "B+G+50" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈518" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sqft)", "value": "2351–2500" },
            { "icon": "fas fa-ruler-combined", "title": "4 BHK (Sqft)", "value": "2900–3368" }
        ],
        "description": "Godrej Madison Avenue is a luxury high-rise by Godrej Properties in Kokapet, Hyderabad. Spread over 3 acres with one 50‑storey tower, it offers ~518 spacious 3 and 4 BHK apartments (2,351–3,368 sqft). Inspired by Manhattan, the project features premium amenities, 80% open spaces, and strong connectivity. RERA‑registered (P02400009227), with possession from Dec 2029.",
        "amenities": [
            { "name": "Multi-level Clubhouse", "icon": "fas fa-building" },
            { "name": "Covered Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Spa", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Squash & Pickleball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Mini Theatre", "icon": "fas fa-film" },
            { "name": "Lounge & Terrace Theatre", "icon": "fas fa-couch" },
            { "name": "Children’s Play Area & Pet Park", "icon": "fas fa-child" },
            { "name": "Jogging Track & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Covered Car Parking with EV Provision", "icon": "fas fa-car" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Backup Power & 24Hrs Water", "icon": "fas fa-bolt" },
            { "name": "Sewage Treatment Plant & Rainwater Harvesting", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high‑rise with earthquake resistance" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/dining; anti‑skid in baths" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, UPVC windows, laminated flush internal doors" },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Fungal‑resistant exterior, acrylic emulsion interiors" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular with chimney, hob, exhaust & purifier provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium fittings with full-height tiles" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "DG backup for common and essential flat areas" },
            { "icon": "fas fa-wifi", "title": "Telecom & Internet", "content": "Intercom, broadband & cable provisions" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "STP & rainwater harvesting systems" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security, CCTV" },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "High-speed elevators" }
        ],
        "gallery": [
            require("../images/projects/Flats/Godrej Madison Avenue/gallery_1.jpg"),
            require("../images/projects/Flats/Godrej Madison Avenue/gallery_2.jpg"),
            require("../images/projects/Flats/Godrej Madison Avenue/gallery_3.jpg"),
            require("../images/projects/Flats/Godrej Madison Avenue/gallery_4.jpg"),
        ]
    },

    // Godrej Rajendra Nagar
    {
        "id": "godrej_rajendra_nagar",
        "project_name": "Godrej Rajendra Nagar",
        "category": "Flats",
        "title": "Godrej Rajendra Nagar by Godrej Properties",
        "location": "Rajendra Nagar, Hyderabad",
        "image": require("../images/projects/Flats/Godrej Rajendra Nagar/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "12.5 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "9" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+40 to G+42" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈1,600" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2.5, 3, 3.5, 4, 5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,150–3,450" }
        ],
        "description": "New‑launch luxury gated community by Godrej Properties in Rajendra Nagar, Hyderabad. Spread across 12.5 acres with 9 high‑rise towers (G+40–42), offering ~1,600 premium apartments from 2.5 to 5 BHK (1,150–3,450 sqft). Designed for natural ventilation, premium finishes, and strong connectivity to ORR and Shamshabad Airport. EOI from ₹1 Cr onwards and possession expected by 2029.",
        "amenities": [
            { "name": "Grand Clubhouse", "icon": "fas fa-building" },
            { "name": "Infinity Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym & Yoga Deck", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Co‑working Space", "icon": "fas fa-users" },
            { "name": "Children’s & Senior Zones", "icon": "fas fa-child" },
            { "name": "Jogging Track & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Multi‑purpose & Party Halls", "icon": "fas fa-glass-cheers" },
            { "name": "Sports Courts (unspecified)", "icon": "fas fa-basketball-ball" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & 24H Water", "icon": "fas fa-bolt" },
            { "name": "STP & Rainwater Harvesting", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high‑rise (G+40–42)" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/dining; laminated in bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "High‑quality flush doors; UPVC windows; wood main door" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modern modular kitchen with premium fittings" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitary ware, full‑height tiles" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, 100% DG backup" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "Backup for apartments, common areas & lifts" },
            { "icon": "fas fa-wifi", "title": "Telecom/Internet", "content": "Provision for broadband, intercom & cable TV" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "STP with rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 CCTV, gated access" },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "High‑speed elevators in each tower" }
        ],
        "gallery": [
            require("../images/projects/Flats/Godrej Rajendra Nagar/gallery_1.jpg"),
            require("../images/projects/Flats/Godrej Rajendra Nagar/gallery_3.jpg"),
            require("../images/projects/Flats/Godrej Rajendra Nagar/gallery_2.jpg"),
            require("../images/projects/Flats/Godrej Rajendra Nagar/gallery_4.jpg"),
        ]
    },

    // The Cascades
    {
        "id": "the_cascades",
        "project_name": "The Cascades",
        "category": "Flats",
        "title": "The Cascades by GHR Infra",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/The Cascades by GHR/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.34 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Up to 63" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,199" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "2,560–4,825" }
        ],
        "description": "The Cascades is a luxury high‑rise project by GHR Infra in Kokapet, Hyderabad. Spanning 7.34 acres with five towers rising up to 63 floors, it offers 1,199 spacious 3 and 4 BHK apartments (2,560–4,825 sqft) with premium finishes and abundant natural light. Strategically located near IT hubs, schools, hospitals, and the Outer Ring Road.",
        "amenities": [
            { "name": "Grand Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "STP & Rainwater Harvesting", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high‑rise towers" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/dining; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Premium flush doors; UPVC/Aluminium windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchens with chimney, hob, water purifier provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitary ware with full-height tiles" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with modular switches" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "DG backup for common areas & essential flats" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "Sewage treatment plant & rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 security & CCTV" },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "High-speed elevators with backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/The Cascades by GHR/gallery_1.jpg"),
            require("../images/projects/Flats/The Cascades by GHR/gallery_2.jpg"),
            require("../images/projects/Flats/The Cascades by GHR/gallery_3.jpg"),
            require("../images/projects/Flats/The Cascades by GHR/gallery_4.jpg"),
        ]
    },

    // Hallmark Sunnyside
    {
        "id": "hallmark_sunnyside",
        "project_name": "Hallmark Sunnyside",
        "category": "Flats",
        "title": "Hallmark Sunnyside by Hallmark Builders",
        "location": " Hyderabad",
        "image": require("../images/projects/Flats/Hallmark Sunnyside/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.7 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+9" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "499" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,115–1,945" }
        ],
        "description": "Hallmark Sunnyside is a ready‑to‑move gated community in Manchirevula, Hyderabad. Spread over 5.7 acres across five G+9 towers, it offers 499 spacious 2 & 3 BHK apartments (1,115–1,945 sqft) designed for natural light and ventilation. With abundant greenery, water bodies, and top‑class amenities, it's well‑connected via ORR to IT hubs and the airport.",
        "amenities": [
            { "name": "World‑class Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Yoga Center", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Squash & Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Banquet Hall & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Creche / Day Care", "icon": "fas fa-baby" },
            { "name": "Library & Reading Lounge", "icon": "fas fa-book-reader" },
            { "name": "Cricket Net & Indoor Sports", "icon": "fas fa-futbol" },
            { "name": "Café & Lounge", "icon": "fas fa-coffee" },
            { "name": "Supermarket & Salon & Spa", "icon": "fas fa-store" },
            { "name": "Jogging Track & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Covered Car Parking", "icon": "fas fa-car" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "24×7 Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "STP & Rainwater Harvesting", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed G+9 towers" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, premium internal doors, UPVC windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite counters, chimney/hob & purifier provisions" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitaryware with full‑height tiles" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with modular switches" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for flats & common areas" },
            { "icon": "fas fa-wifi", "title": "Telecom/Internet", "content": "Intercom, broadband & cable TV provision" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "Sewage Treatment Plant, garbage chutes" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry, 24×7 CCTV & guards" },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "High‑speed automatic elevators" }
        ],
        "gallery": [
            require("../images/projects/Flats/Hallmark Sunnyside/gallery_1.jpg"),
            require("../images/projects/Flats/Hallmark Sunnyside/gallery_2.jpg"),
            require("../images/projects/Flats/Hallmark Sunnyside/gallery_3.jpg"),
            require("../images/projects/Flats/Hallmark Sunnyside/gallery_4.jpg"),
        ],
    },

    // Hallmark Treasor
    {
        "id": "hallmark_treasor",
        "project_name": "Hallmark Treasor",
        "category": "Flats",
        "title": "Hallmark Treasor by Hallmark Builders",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Hallmark Treasor/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.62 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+29" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "526–540" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,765–5,080" }
        ],
        "description": "Hallmark Treasor is an ultra‑luxury G+29 high‑rise in Gandipet (Kokapet), Hyderabad, built using MIVAN technology. Spread over 4.62 acres with two towers and 526–540 expansive 3 & 4 BHK apartments (1,765–5,080 sqft), it offers wide balconies and serene lake/green views. Under construction with possession starting Nov 2024.",
        "amenities": [
            { "name": "35,000 sqft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym & Spa", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Badminton, Squash & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Mini Theatre", "icon": "fas fa-film" },
            { "name": "Café, Restaurant & Salon", "icon": "fas fa-coffee" },
            { "name": "Creche/Day Care", "icon": "fas fa-baby" },
            { "name": "Library", "icon": "fas fa-book-reader" },
            { "name": "Yoga/Meditation Zone", "icon": "fas fa-spa" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Jogging Track & Greens", "icon": "fas fa-tree" },
            { "name": "Gated Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & 24×7 Water", "icon": "fas fa-bolt" },
            { "name": "STP & Rainwater Harvesting", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed G+29 towers with MIVAN monolithic construction" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Designer main door, premium internal doors, anodized/aluminium windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchen with chimney/hob & purifier provisions" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium fittings, full‑height tiles, shower panels" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, 100% DG backup" },
            { "icon": "fas fa-wifi", "title": "Telecom/Internet", "content": "Intercom, broadband & cable provisions" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "Sewage treatment plant & rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 guards & CCTV" },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "High‑speed elevators with backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/Hallmark Treasor/gallery_1.jpg"),
            require("../images/projects/Flats/Hallmark Treasor/gallery_2.jpg"),
            require("../images/projects/Flats/Hallmark Treasor/gallery_3.jpg"),
            require("../images/projects/Flats/Hallmark Treasor/gallery_4.jpg"),
        ]
    },

    // Lansum Elena Residences
    {
        "id": "lansum_elena",
        "project_name": "Lansum Elena Residences",
        "category": "Flats",
        "title": "Lansum Elena by Lansum Endpoint Developers LLP",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Lansum Elena Residences/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "3.61 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "B4+Podium+55" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "540" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "2,337–3,775" }
        ],
        "description": "Lansum Elena is a twin‑tower (55-storey) luxury development in Kokapet spanning 3.61 acres, offering 540 premium 3 & 4 BHK apartments between 2,337–3,775 sqft. RERA‑registered (P02400007478), under construction with possession expected by December 2028, and designed with extensive sky amenities and natural light..",
        "amenities": [
            { "name": "50,000+ sqft Clubhouse + Refuge-level amenities", "icon": "fas fa-building" },
            { "name": "Infinity & Lap Pools", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Spa & Yoga Deck", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games, Mini Theatre", "icon": "fas fa-chess-board" },
            { "name": "Kids’ Play Area & Senior Zone", "icon": "fas fa-child" },
            { "name": "Jogging & Cycling Tracks", "icon": "fas fa-running" },
            { "name": "Tennis, Squash & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Sky Lounge & Party Decks", "icon": "fas fa-glass-cheers" },
            { "name": "4‑level Basement Parking + EV bays", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV & Fire Safety", "icon": "fas fa-shield-alt" },
            { "name": "100% Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "STP, Rainwater Harvesting & Waste Chutes", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed construction with basement + podium + 55 floors" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/dining; laminated in bedrooms; anti-skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Engineered main doors, premium interiors, double-glazed balconies" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular kitchen with chimney, hob & PNG/LPG provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium fittings with full-height glazed tiles" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC provision & 100% DG backup" },
            { "icon": "fas fa-charging-station", "title": "Parking", "content": "Four-level basement parking with EV charging & car wash bays" },
            { "icon": "fas fa-wifi", "title": "Telecom", "content": "Intercom, broadband & cable TV provision" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 access control, CCTV & fire-fighting systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Lansum Elena Residences/gallery_1.jpg"),
            require("../images/projects/Flats/Lansum Elena Residences/gallery_2.jpg"),
            require("../images/projects/Flats/Lansum Elena Residences/gallery_3.jpg"),
            require("../images/projects/Flats/Lansum Elena Residences/gallery_4.jpg"),
        ]
    },

    // Lansum El Dorado
    {
        "id": "lansum_el_dorado",
        "project_name": "Lansum El Dorado",
        "category": "Flats",
        "title": "Lansum El Dorado by Lansum Properties LLP",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Lansum El Dorado/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.2 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "4B+2S+40" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "872" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,860–2,225" }
        ],
        "description": "Lansum El Dorado is a premium twin‑tower (40‑storey) residential project spanning ~4.2 acres in Narsingi, Hyderabad. It comprises 872 spacious 3 BHK apartments (1,860–2,225 sqft), featuring biophilic architecture, a sky‑deck, elevated skywalk, and a six‑level clubhouse. Possession starts December 2025, RERA‑registered (P02400002654).",
        "amenities": [
            { "name": "6‑level Clubhouse", "icon": "fas fa-building" },
            { "name": "Sky‑Deck & Elevated Skywalk (30th Floor)", "icon": "fas fa-tree" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Spa", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Badminton & Squash Courts (2 basement floors)", "icon": "fas fa-basketball-ball" },
            { "name": "Tennis & Half‑Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Pitch & Outdoor Courts", "icon": "fas fa-futbol" },
            { "name": "Co‑working Space & Coffee Shop", "icon": "fas fa-coffee" },
            { "name": "Preview / Mini Theatre", "icon": "fas fa-film" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Temple & Elderly Seating Areas", "icon": "fas fa-pray" },
            { "name": "Jogging/Cycling Tracks", "icon": "fas fa-running" },
            { "name": "Cricket Net & Billiards", "icon": "fas fa-billiards" },
            { "name": "Car Wash & Drivers’ Lounge", "icon": "fas fa-car" },
            { "name": "4‑Level Basement Parking + EV Bay", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security, CCTV & Fire Safety", "icon": "fas fa-shield-alt" },
            { "name": "100% Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "STP, Rainwater Harvesting & Waste Chutes", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "High‑rise RCC framed with shear‑wall design" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered internal doors, UPVC/Double‑glazed windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite counter kitchen with chimney/hob & purifier provision" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitary fittings, full‑height glazed tiles" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC provision & 100% DG backup" },
            { "icon": "fas fa-charging-station", "title": "Parking", "content": "Two basement floors with EV charging & car wash" },
            { "icon": "fas fa-wifi", "title": "Telecom/Internet", "content": "Intercom, broadband & cable provisions" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated community with CCTV & 24×7 security" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire‑fighting systems & smoke detectors" }
        ],
        "gallery": [
            require("../images/projects/Flats/Lansum El Dorado/gallery_1.jpg"),
            require("../images/projects/Flats/Lansum El Dorado/gallery_2.jpg"),
            require("../images/projects/Flats/Lansum El Dorado/gallery_3.jpg"),
            require("../images/projects/Flats/Lansum El Dorado/gallery_4.jpg"),
        ]
    },

    // Levonor Egeira 
    {
        "id": "levonor_egeira",
        "project_name": "Levonor Egeira",
        "category": "Flats",
        "title": "Levonor Egeira by Levonor Lifespaces Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Levonor Egeira/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.7 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+35" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "744" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,550–2,660" }
        ],
        "description": "Levonor Egeira is a luxury gated community of 3 BHK apartments in Kollur, Hyderabad, spread over 4.7 acres with three G+35 towers. It offers 744 Vastu‑compliant homes (1,550–2,660 sqft) with high ceilings, four-level basement parking, two exclusive clubhouses and over 55 premium amenities. RERA‑registered (P01100005935), possession begins December 2026.:contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Two Clubhouses (~75,000 sqft)", "icon": "fas fa-building" },
            { "name": "Swimming Pools (incl. Kids')", "icon": "fas fa-swimmer" },
            { "name": "Spa & Massage Centre", "icon": "fas fa-spa" },
            { "name": "Mini‑Theatre", "icon": "fas fa-film" },
            { "name": "Indoor Squash & Badminton Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Sports Courts & Amphitheatre", "icon": "fas fa-chess-board" },
            { "name": "Jogging, Cycling & Skating Tracks", "icon": "fas fa-running" },
            { "name": "Pet Garden & Senior Zone", "icon": "fas fa-child" },
            { "name": "Reading Corners & Business Café", "icon": "fas fa-book-reader" },
            { "name": "Car Wash & Driver’s Lounge", "icon": "fas fa-car" },
            { "name": "Four‑Level Basement Parking with Express Ramps", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security, CCTV & Access Control", "icon": "fas fa-shield-alt" },
            { "name": "100 % Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "STP, Rainwater Harvesting & Waste Chutes", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bed; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Engineered main door; UPVC/double‑glazed windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular with chimney/hob & water purifier provision" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with modular switches & AC provision" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Smoke detectors, alarms, hydrants & sprinklers" },
            { "icon": "fas fa-trash-alt", "title": "Waste Management", "content": "STP plus organic waste converter & chutes" },
            { "icon": "fas fa-charging-station", "title": "Parking", "content": "Basement parking with EV charging & car wash" }
        ],
        "gallery": [
            require("../images/projects/Flats/Levonor Egeira/gallery_1.jpg"),
            require("../images/projects/Flats/Levonor Egeira/gallery_2.jpg"),
            require("../images/projects/Flats/Levonor Egeira/gallery_3.jpg"),
            require("../images/projects/Flats/Levonor Egeira/gallery_4.jpg"),
            require("../images/projects/Flats/Levonor Egeira/gallery_5.jpg"),
            require("../images/projects/Flats/Levonor Egeira/gallery_6.jpg"),
        ]
    },

    // Magna East Side 
    {
        "id": "magna_east_side",
        "project_name": "Magna East Side",
        "category": "Flats",
        "title": "Magna East Side by Magna Infratech India Pvt. Ltd.",
        "location": "Hyderabad",
        "image": "require(\"../images/projects/Flats/Magna East Side/Main.jpg\")",
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "0.24 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+5" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "15" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,190–1,501" }
        ],
        "description": "Magna East Side in Nallagandla is an eco‑friendly gated community by Magna Infratech, offering 15 Vastu‑compliant 2 & 3 BHK flats (1,190–1,501 sqft) in a 6‑floor tower. Known as Hyderabad’s sustainable mid‑rise project, it’s RERA‑approved and ready by Jun 2027, featuring natural ventilation, EV charging, and green design.:contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "24×7 Water Supply", "icon": "fas fa-water" },
            { "name": "Covered Car Parking", "icon": "fas fa-car" },
            { "name": "Gated Community", "icon": "fas fa-shield-alt" },
            { "name": "Lift", "icon": "fas fa-elevator" },
            { "name": "Natural Ventilation & Green Roofing", "icon": "fas fa-leaf" },
            { "name": "Electric Vehicle Charging", "icon": "fas fa-charging-station" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Seismic resistant RCC frame with AAC blocks for thermal performance" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered internal doors, UPVC windows with mosquito mesh" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring (Finolex), modular switches" }
        ],
        "gallery": [
            "require(\"../images/projects/Flats/Magna East Side/gallery_1.jpg\")",
            "require(\"../images/projects/Flats/Magna East Side/gallery_2.jpg\")",
            "require(\"../images/projects/Flats/Magna East Side/gallery_3.jpg\")",
            "require(\"../images/projects/Flats/Magna East Side/gallery_4.jpg\")"
        ],

    },

    // Mahaveer Crystal Garden
    {
        "id": "mahaveer_crystal_garden",
        "project_name": "Mahaveer Crystal Garden",
        "category": "Flats",
        "title": "Mahaveer Crystal Garden by Mahaveer Constructions",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Mahaveer Crystal Garden/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.02 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+35" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "785" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 4, 5 BHK + Duplex" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,640–5,345" }
        ],
        "description": "Mahaveer Crystal Garden is a luxury gated community in Attapur, Hyderabad, spanning ~5 acres with three G+35 towers and 785 premium 3–5 BHK apartments (1,640–5,345 sqft, including duplexes). It features a 60,000 sqft clubhouse, high ceilings (3.3 m), and over 70 amenities. RERA‑registered (P02500004287), under construction with possession from December 2026 onwards..",
        "amenities": [
            { "name": "60,000 sqft Club Kohinoor", "icon": "fas fa-building" },
            { "name": "Indoor & Outdoor Swimming Pools", "icon": "fas fa-swimmer" },
            { "name": "Gym, Spa, Steam & Sauna", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games, Mini‑Theatre", "icon": "fas fa-chess-board" },
            { "name": "Squash, Badminton, Tennis & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Pitch & Skating Rink", "icon": "fas fa-futbol" },
            { "name": "Banquet Hall, Party Lawn, Restaurant & Café", "icon": "fas fa-glass-cheers" },
            { "name": "Library, Business Centre & Conference Hall", "icon": "fas fa-book-reader" },
            { "name": "Creche & Senior Citizen Zone", "icon": "fas fa-baby" },
            { "name": "Pet Zone & Landscaped Gardens", "icon": "fas fa-child" },
            { "name": "Jogging Track & Amphitheatre", "icon": "fas fa-tree" },
            { "name": "Covered Parking + EV Charging & Car Wash", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV, Panic Button", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & 24×7 Water", "icon": "fas fa-bolt" },
            { "name": "STP, Rainwater Harvesting & Waste Chutes", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Aluminium formwork + RCC shear‑wall frame, seismic & wind resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "800×800 mm vitrified tiles in living/bedrooms; anti‑skid ceramic in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Engineered/teak main doors; UPVC/aluminium sliding windows with mesh; teak flush internal doors" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Modular with chimney/hob & purifier points; glazed tile backsplash" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium sanitaryware, full-height glazed tiles, anti-skid flooring" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, VRF AC provision" },
            { "icon": "fas fa-charging-station", "title": "Parking", "content": "Multi-level covered parking with EV charging & car wash bay" },
            { "icon": "fas fa-wifi", "title": "Telecom/Internet", "content": "Intercom, broadband & cable provision" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Access-controlled, round-the-clock CCTV, panic buttons in lifts" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire & Safety", "content": "Fire hydrants, sprinklers, smoke alarms, PA system" },
            { "icon": "fas fa-water", "title": "Water & Environment", "content": "Water purification, STP, rainwater harvesting & recharge pits" }
        ],
        "gallery": [
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_1.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_2.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_3.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_4.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_5.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_6.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_7.jpg"),
            require("../images/projects/Flats/Mahaveer Crystal Garden/gallery_8.jpg"),
        ]
    },

    // Myscape Songs of the Sun 
    {
        "id": "myscape_songs_of_the_sun",
        "project_name": "Myscape Songs of the Sun",
        "category": "Flats",
        "title": "Myscape Songs of the Sun by Myscape Properties Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Myscape Songs of the Sun/Main.png"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.92 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+37" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "592" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sqft)", "value": "2,825–2,915" },
            { "icon": "fas fa-ruler-combined", "title": "4 BHK (Sqft)", "value": "3,280–3,295" }
        ],
        "description": "Myscape Songs of the Sun is an ultra‑premium high‑rise in Hyderabad's Financial District. Spread over ~6 acres with four G+37 towers, it houses 592 spacious 3 & 4 BHK residences (2,825–3,295 sqft) on corner-corner layouts for light-filled living. Features include linear design, expansive open spaces, and a 50,000 sqft clubhouse. RERA‑registered (P02400008721), possession begins from Jul 2029. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "50,000 sqft Clubhouse (4 storeys)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Indoor Games", "icon": "fas fa-dumbbell" },
            { "name": "Badminton & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Tennis Court", "icon": "fas fa-tennis-ball" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Café, Party Hall & Guest Rooms", "icon": "fas fa-glass-cheers" },
            { "name": "Landscaped Gardens & Skating Rink", "icon": "fas fa-tree" },
            { "name": "Covered Car & Visitor Parking", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV & Power Backup", "icon": "fas fa-shield-alt" },
            { "name": "Sewage Treatment Plant & Gas Pipeline", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall frame, wind & earthquake resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors, engineered internal doors, UPVC windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC provision" }
        ],
        "gallery": [
            require("../images/projects/Flats/Myscape Songs of the Sun/gallery_1.png"),
            require("../images/projects/Flats/Myscape Songs of the Sun/gallery_2.png"),
            require("../images/projects/Flats/Myscape Songs of the Sun/gallery_3.png"),
            require("../images/projects/Flats/Myscape Songs of the Sun/gallery_4.png"),
        ]
    },

    // Muppas Melody 
    {
        "id": "muppas_melody",
        "project_name": "Muppas Melody",
        "category": "Flats",
        "title": "Muppas Melody by Muppa Projects India Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Muppas Melody/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "8.33 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "7" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "B+G+17" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,054" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5, 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "2 BHK (Sqft)", "value": "1,010" },
            { "icon": "fas fa-ruler-combined", "title": "2.5 BHK (Sqft)", "value": "1,400" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sqft)", "value": "1,655–1,725" }
        ],
        "description": "Muppas Melody is a gated community in Tellapur, spread over 8.33 acres with 7 towers (17 floors), offering 1,054 premium 2, 2.5, and 3 BHK homes (1,010–1,725 sqft). With 75% open space, dual clubhouses, and ready-to-move units, it emphasizes luxury, connectivity, and wellness. RERA-approved (P01100002646), possession from Dec 2027. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "2 Clubhouses (42,000 sqft each)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Indoor Games Room", "icon": "fas fa-dumbbell" },
            { "name": "Badminton, Basketball & Cricket Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Party Hall & Landscaped Gardens", "icon": "fas fa-glass-cheers" },
            { "name": "Covered Car Parking", "icon": "fas fa-car" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Seismic‑resistant RCC framed towers" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bed; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered internal doors, UPVC windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC provision" }
        ],
        "gallery": [
            require("../images/projects/Flats/Muppas Melody/gallery_1.jpg"),
            require("../images/projects/Flats/Muppas Melody/gallery_2.jpg"),
            require("../images/projects/Flats/Muppas Melody/gallery_3.jpg"),
            require("../images/projects/Flats/Muppas Melody/gallery_4.jpg"),
        ]
    },

    // One by MSN   
    {
        "id": "one_by_msn",
        "project_name": "One by MSN",
        "category": "Flats",
        "title": "One by MSN by MSN Realty",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/One by MSN/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.7 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+55" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "655" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "4 BHK (Sqft)", "value": "5,250–7,460" }
        ],
        "description": "One by MSN is a flagship ultra‑luxury high‑rise by MSN Realty at Neopolis, Kokapet. Spread over 7.7 acres across five 55‑storey towers, it offers 655 expansive 4 BHK residences (5,250–7,460 sqft) with private lobbies, smart home features, and panoramic lake and greenery views. With 1.8 lakh sqft of amenity space (clubhouse, podium, sky‑park) and RERA-registered (P02400009393), possession is expected by Feb 2030..",
        "amenities": [
            { "name": "180,000 sqft Clubhouse + Skypark", "icon": "fas fa-building" },
            { "name": "3 Swimming Pools (including Sky Deck)", "icon": "fas fa-swimmer" },
            { "name": "Aqua Gym & Sky Yoga Deck", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Games (tennis, squash, pickleball)", "icon": "fas fa-basketball-ball" },
            { "name": "Football & Cricket Simulator, Bowling Alley, Golf Simulator", "icon": "fas fa-football-ball" },
            { "name": "Sky Party Lawn & Open-Air Sky Cinema", "icon": "fas fa-film" },
            { "name": "Jogging Track & Amphitheatre", "icon": "fas fa-tree" },
            { "name": "Co‑working Lounge & Conference Rooms", "icon": "fas fa-users" },
            { "name": "Children’s Play Area & Creche", "icon": "fas fa-child" },
            { "name": "Exclusive Private Lobbies", "icon": "fas fa-door-open" },
            { "name": "EV Charging & Stilt Parking", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV & Fire Safety", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall frame, wind & earthquake resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium vitrified tiles and wood/stone finishes" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered internal doors, UPVC/double‑glazed windows" },
            { "icon": "fas fa-bolt", "title": "Electrical & Smart Tech", "content": "Concealed copper wiring, modular switches, home automation-ready" }
        ],
        "gallery": [
            require("../images/projects/Flats/One by MSN/gallery_1.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_2.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_3.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_4.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_5.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_6.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_7.jpg"),
            require("../images/projects/Flats/One by MSN/gallery_8.jpg"),
        ]
    },

    // My Home Apas 
    {
        "id": "my_home_apas",
        "project_name": "My Home Apas",
        "category": "Flats",
        "title": "My Home Apas by My Home Group & Kosaraju Realty",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/My Home Apas/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "13.52 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "6" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Up to 55" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,338" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 3.5 BHK" }
        ],
        "description": "My Home Apas is a luxury lakeside residential enclave in Kokapet developed by My Home Group with land by Kosaraju Realty. Spread over 13.52 acres, it features six high-rise towers with up to 55 floors, offering 1,338 premium 3 and 3.5 BHK apartments. With 81.6% open spaces, it’s RERA‑approved (P02400006812), designed for upscale, sustainable living..",
        "amenities": [
            { "name": "Lakeside Views & 81.6% Open Space", "icon": "fas fa-water" },
            { "name": "Clubhouse, Gym, Pools & Kids’ Play Zone", "icon": "fas fa-swimmer" },
            { "name": "Jogging/Walking Tracks & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Indoor Games Room & Multipurpose Hall", "icon": "fas fa-chess-board" },
            { "name": "Covered Car Parking with EV Charging", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV & Maintenance Staff", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high-rise construction" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti-skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main doors, UPVC windows, flush internal doors" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, provision for backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/My Home Apas/gallery_1.jpg"),
            require("../images/projects/Flats/My Home Apas/gallery_2.jpg"),
            require("../images/projects/Flats/My Home Apas/gallery_3.jpg"),
            require("../images/projects/Flats/My Home Apas/gallery_4.jpg"),
            require("../images/projects/Flats/My Home Apas/gallery_5.jpg"),
            require("../images/projects/Flats/My Home Apas/gallery_6.jpg"),
        ]
    },

    // My Home Tarkshya 
    {
        "id": "my_home_tarkshya",
        "project_name": "My Home Tarkshya",
        "category": "Flats",
        "title": "My Home Tarkshya by My Home Constructions",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/My Home Tarkshya/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.82 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+32" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "660" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sqft)", "value": "1,957–2,235" }
        ],
        "description": "My Home Tarkshya is a ready-to-move luxury gated community in Kokapet, Hyderabad. Spread over 5.82 acres, it has four high-rise towers (32 floors) offering 660 spacious 3 BHK apartments (1,957–2,235 sqft). With 78% open space, a 34,000 sqft clubhouse, pool, courts, and Wi‑Fi–enabled amenities, it's RERA-registered (P02400001620) and possession started July 2023. :contentReference[oaicite:0]{index=0}",
        "amenities": [
            { "name": "34,000 sqft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Outdoor Play Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Gymnasium & Mini‑Hall", "icon": "fas fa-dumbbell" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Jogging Track & Landscaping", "icon": "fas fa-tree" },
            { "name": "3-Level Parking", "icon": "fas fa-car" },
            { "name": "Wi‑Fi Enabled Community", "icon": "fas fa-wifi" },
            { "name": "24×7 Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "Security & CCTV", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Seismic-resistant RCC framed high-rises" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered internal doors, UPVC windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC & power backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/My Home Tarkshya/gallery_1.jpg"),
            require("../images/projects/Flats/My Home Tarkshya/gallery_2.jpg"),
            require("../images/projects/Flats/My Home Tarkshya/gallery_3.jpg"),
            require("../images/projects/Flats/My Home Tarkshya/gallery_4.jpg"),
            require("../images/projects/Flats/My Home Tarkshya/gallery_5.jpg"),
            require("../images/projects/Flats/My Home Tarkshya/gallery_6.jpg"),
        ]
    },

    // My Home Bhooja 
    {
        "id": "my_home_bhooja",
        "project_name": "My Home Bhooja",
        "category": "Flats",
        "title": "My Home Bhooja by My Home Constructions",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/My Home Bhooja/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "18 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "10+ (Block A–K)" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+36" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈1,544–1,760" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "2,595–4,070" }
        ],
        "description": "My Home Bhooja is a completed ultra‑luxury gated community in Madhapur/HITEC City, Hyderabad. Spanning 18 acres with 10+ towers up to 36 floors, it offers ~1,600 high-end 3 & 4 BHK residences (2,595–4,070 sqft). IGBC Platinum-rated with green features, it’s ready to move with strong connectivity to tech hubs and biodiversity park views..",
        "amenities": [
            { "name": "Clubhouse & Multipurpose Hall", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym, Spa, Indoor Games, Mini Theatre", "icon": "fas fa-dumbbell" },
            { "name": "Courts: Squash, Badminton, Basketball", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Nets, Play Areas & Gardens", "icon": "fas fa-child" },
            { "name": "Jogging / Senior Citizen Tracks", "icon": "fas fa-tree" },
            { "name": "Creche, Grocery, ATM, Café", "icon": "fas fa-store" },
            { "name": "Visitor Parking & Stilt/Basement Parking", "icon": "fas fa-car" },
            { "name": "CCTV, Intercom & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Power Backup & Lift", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall framed towers built to withstand wind & seismic loads" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living; vitrified in bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; engineered internal doors; UPVC/windows with mosquito mesh" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, provisions for AC, intercom, DTH" },
            { "icon": "fas fa-utensils", "title": "Kitchen/Bath", "content": "Modern fittings, geyser points, vanity units, premium sanitaryware" }
        ],
        "gallery": [
            "require(\"../images/projects/Flats/My Home Bhooja/gallery_1.jpg\")",
            "require(\"../images/projects/Flats/My Home Bhooja/gallery_2.jpg\")",
            "require(\"../images/projects/Flats/My Home Bhooja/gallery_3.jpg\")",
            "require(\"../images/projects/Flats/My Home Bhooja/gallery_4.jpg\")",
            "require(\"../images/projects/Flats/My Home Bhooja/gallery_5.jpg\")",
            "require(\"../images/projects/Flats/My Home Bhooja/gallery_6.jpg\")"
        ]
    },


    // Navanaami Megaleio 
    {
        "id": "navanaami_megaleio",
        "project_name": "Navanaami Megaleio",
        "category": "Flats",
        "title": "Navanaami Megaleio by Navanaami Projects Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/My Home Bhooja/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.1 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+50" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "150" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 & 5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "8,888–11,111" }
        ],
        "description": "Navanaami Megaleio is a twin‑tower ultra‑luxury project in Appa Junction, Hyderabad, spanning 4.1 acres with 2 towers of 50 floors and 150 opulent 4 & 5 BHK sky‑homes (8,888–11,111 sqft). Featuring double‑height ceilings, smart home tech, and 150,000 sqft of amenities amid 1,200 acres of green surroundings. RERA‑approved (P02400007676) with possession expected by Dec 2028. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "150,000 sqft integrated amenity space", "icon": "fas fa-building" },
            { "name": "Infinity Pool & Sky Spa", "icon": "fas fa-swimmer" },
            { "name": "Private Chef & Valet Lounge", "icon": "fas fa-door-open" },
            { "name": "Lobby Lounge & Concierge Services", "icon": "fas fa-users" },
            { "name": "Home Automation & Noise‑controlled Windows", "icon": "fas fa-bolt" },
            { "name": "Private Cinema, Party Lawn", "icon": "fas fa-film" },
            { "name": "Pet Park & Landscaped Terrace Gardens", "icon": "fas fa-tree" },
            { "name": "Housekeeping & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "EV Garage & Valet Parking", "icon": "fas fa-car" },
            { "name": "Wellness Spa, Sauna, Gym", "icon": "fas fa-spa" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall frame, wind & seismic resistant" },
            { "icon": "fas fa-border-style", "title": "Ceilings", "content": "Double‑height living rooms in select units" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered interior doors, noise‑controlled glazing" },
            { "icon": "fas fa-bolt", "title": "Smart & Electrical", "content": "Home automation-ready, concealed copper wiring" }
        ],
        "gallery": [
            require("../images/projects/Flats/My Home Bhooja/gallery_1.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_2.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_3.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_4.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_5.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_6.jpg"),
        ]
    },


    // Navanaami K3 
    {
        "id": "navanaami_k3",
        "project_name": "Navanaami K3",
        "category": "Flats",
        "title": "Navanaami K3 by Navanaami Projects Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/My Home Bhooja/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Up to 60" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈300 (5 per floor)" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3.5 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "2,380–3,600" }
        ],
        "description": "Navanaami K3 is a high-rise luxury tower in Kokapet, built on 2 acres with a single tower rising up to 60 floors. The project features approximately 5 apartments per floor—each a spacious 3.5 or 4 BHK home ranging from 2,380 to 3,600 sqft. Prices range from ₹2.10 Cr to ₹2.91 Cr. RERA-registered (P02400007676).",
        "amenities": [
            { "name": "Sky‑high luxury living", "icon": "fas fa-building" },
            { "name": "High‑speed elevators", "icon": "fas fa-elevator" },
            { "name": "Covered parking with EV charging", "icon": "fas fa-car" },
            { "name": "24×7 security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Backup power and water", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall frame, wind & earthquake resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered interior doors, UPVC windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC provision" }
        ],
        "gallery": [
            "require(\"../images/projects/Flats/Navanaami K3/gallery_1.jpg\")",
            "require(\"../images/projects/Flats/Navanaami K3/gallery_2.jpg\")",
            "require(\"../images/projects/Flats/Navanaami K3/gallery_3.jpg\")",
            "require(\"../images/projects/Flats/Navanaami K3/gallery_4.jpg\")"
        ]
    },


    // Bricks Cyberwoods 
    {
        "id": "bricks_cyberwoods",
        "project_name": "Bricks Cyberwoods",
        "category": "Flats",
        "title": "Bricks Cyberwoods by Bricks Infratech LLP",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Bricks Cyberwoods/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2.8 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+15" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "300" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5, 3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "1,230–2,640 sqft" }
        ],
        "description": "Bricks Cyberwoods is a gated contemporary living project by Bricks Infratech in Osman Nagar (Tellapur), spanning ~2.8 acres with two 15-storey towers and 300 units of 2–4 BHK apartments (1,230–2,640 sqft). It features world‑class amenities and is strategically located next to the upcoming TSIIC IT corridor with easy access to ORR and IT hubs. RERA‑registered (P01100003953), possession expected by Dec 2025. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Clubhouse & Banquet Hall", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Terrace Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Indoor Games", "icon": "fas fa-dumbbell" },
            { "name": "Squash, Badminton, Basketball & Cricket Pitch", "icon": "fas fa-basketball-ball" },
            { "name": "Skating Rink & Amphitheatre", "icon": "fas fa-child" },
            { "name": "Yoga/Meditation Deck", "icon": "fas fa-spa" },
            { "name": "Kids’ Play Area & Senior Citizen Park", "icon": "fas fa-child" },
            { "name": "Covered Parking + EV Charging", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV & Power Backup", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed, 2-level basement + stilt + 15 floors with AAC external walls" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "800×800 mm vitrified in living/bedrooms; anti‑skid ceramic in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; engineered internal doors; UPVC/Fenesta sliding windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, central gas bank, solar fencing" }
        ],
        "gallery": [
            require("../images/projects/Flats/My Home Bhooja/gallery_1.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_2.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_3.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_4.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_5.jpg"),
            require("../images/projects/Flats/My Home Bhooja/gallery_6.jpg"),
        ]
    },


    // Poulomi Palazzo 
    {
        "id": "poulomi_palazzo",
        "project_name": "Poulomi Palazzo",
        "category": "Flats",
        "title": "Poulomi Palazzo by Poulomi Estates Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Poulomi Palazzo/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.6 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "B+G+55" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "145" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "4 BHK (Sqft)", "value": "6,225–8,100" }
        ],
        "description": "Poulomi Palazzo is an ultra‑luxury high‑rise in Kokapet, spanning 4.6 acres with three 55‑storey towers and 145 expansive 4 BHK sky‑homes (≈6,225–8,100 sqft). It features double‑height amenities, private lobbies, 47th‑floor infinity pool and sky‑deck, lush podium landscaped zones, and is RERA‑registered (P02400004428) with possession starting March 2028. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "35,000 sqft multi‑storied clubhouse", "icon": "fas fa-building" },
            { "name": "47th‑floor Infinity Pool + Jacuzzi + Sky‑deck", "icon": "fas fa-swimmer" },
            { "name": "Spa, Sauna & Yoga areas", "icon": "fas fa-spa" },
            { "name": "Gym, indoor games, aerobics, dance studios", "icon": "fas fa-dumbbell" },
            { "name": "Private dining, conference & banquet halls", "icon": "fas fa-glass-cheers" },
            { "name": "Tennis, basketball, kids’ play, amphitheatre", "icon": "fas fa-basketball-ball" },
            { "name": "Podium-level lush landscaped plaza & jogging track", "icon": "fas fa-tree" },
            { "name": "24×7 security, CCTV & advanced fire‑safety systems", "icon": "fas fa-shield-alt" },
            { "name": "Covered basement parking + EV charging", "icon": "fas fa-car" },
            { "name": "Sewage treatment, rainwater harvesting & backup power", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall frame designed for wind & seismic loads" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living; premium engineered wood in master; anti‑skid tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; engineered internal doors; UPVC/double‑glazed windows with mosquito mesh" },
            { "icon": "fas fa-bolt", "title": "Electrical & Smart Tech", "content": "Concealed copper wiring, modular switches, home‑automation ready, backup power" }
        ],
        "gallery": [
            require("../images/projects/Flats/Poulomi Palazzo/gallery_1.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_2.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_3.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_4.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_5.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_6.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_7.jpg"),
            require("../images/projects/Flats/Poulomi Palazzo/gallery_8.jpg"),
        ]
    },


    // Poulomi Avante 
    {
        "id": "poulomi_avante",
        "project_name": "Poulomi Avante",
        "category": "Flats",
        "title": "Poulomi Avante by Poulomi Estates Pvt. Ltd.",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Poulomi Avante/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "4.75 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "2 Basement + G + 22" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "475–477" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2 & 3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,330–2,575" }
        ],
        "description": "Poulomi Avante is a gated luxury residential project in Kokapet, Hyderabad. Spread across 4.75 acres with three 22-storey towers, it offers 475‑477 Vastu‑compliant 2 & 3 BHK apartments ranging from 1,330 to 2,575 sqft. RERA‑registered (P02400002634), possession starts Jan 2027. It features a 28,000 sqft clubhouse, terrace pool, sports courts, indoor/outdoor gyms, jogging/cycling tracks, and landscaped gardens. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "28,000 sqft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Terrace Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor & Outdoor Gym", "icon": "fas fa-dumbbell" },
            { "name": "Badminton, Basketball & Cricket Pitch", "icon": "fas fa-basketball-ball" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Children’s Play Areas (×2)", "icon": "fas fa-child" },
            { "name": "Multipurpose Hall & Supermarket", "icon": "fas fa-glass-cheers" },
            { "name": "Spa, Sauna, Steam & Yoga Room", "icon": "fas fa-spa" },
            { "name": "Covered Car Parking + EV Charging", "icon": "fas fa-car" },
            { "name": "24×7 Security, CCTV & Power Backup", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Seismic‑resistant RCC framed towers" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "800×800 mm vitrified tiles in living/bedrooms; laminated wood in master; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door, engineered internal doors; UPVC/Fenesta windows with mosquito mesh" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, 3‑phase supply, AC & geyser points; 100% DG backup" },
            { "icon": "fas fa-water", "title": "Utilities & Safety", "content": "STP, solid waste management, provisions for cable/Internet, fire‑safety systems" }
        ],
        "gallery": [
            require("../images/projects/Flats/Poulomi Avante/gallery_1.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_2.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_3.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_4.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_5.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_6.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_7.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_8.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_9.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_10.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_11.jpg"),
            require("../images/projects/Flats/Poulomi Avante/gallery_12.jpg"),
        ]
    },


    // RNP #1 Stellar 
    {
        "id": "rnp_1_stellar",
        "project_name": "RNP #1 Stellar",
        "category": "Flats",
        "title": "RNP #1 Stellar by RNP Stellar Projects LLP",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/RNP #1 Stellar/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "2" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+15" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "195" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Unit Sizes (Sqft)", "value": "1,585–2,285" }
        ],
        "description": "RNP #1 Stellar is an exclusive boutique project in Kondapur by RNP Stellar Projects LLP. Spread over 2 acres with two G+15 towers, it offers 195 upscale 3 BHK homes (1,585–2,285 sqft) with a 30,000 sqft clubhouse. RERA-registered (P02400003165), ready to move from Dec 2024. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "30,000 sqft Clubhouse (gym, spa, salon)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Game Room, Squash & Badminton Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Yoga/Meditation Hall & Business Lounge", "icon": "fas fa-spa" },
            { "name": "Supermarket within premises", "icon": "fas fa-store" },
            { "name": "24×7 Security, CCTV, Intercom & Boom Barrier Entry", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & Sewage Treatment Plant", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed (3 basements + G+15), earthquake & wind resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti-skid tiles in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak main door; engineered interior doors; UPVC windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC & geyser points" }
        ],
        "gallery": [
            require("../images/projects/Flats/RNP #1 Stellar/gallery_1.jpg"),
            require("../images/projects/Flats/RNP #1 Stellar/gallery_2.jpg"),
            require("../images/projects/Flats/RNP #1 Stellar/gallery_3.jpg"),
            require("../images/projects/Flats/RNP #1 Stellar/gallery_4.jpg"),
        ]
    },


    // Prestige Beverly Hills 
    {
        "id": "prestige_beverly_hills",
        "project_name": "Prestige Beverly Hills",
        "category": "Flats",
        "title": "Prestige Beverly Hills by Prestige Group",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige Beverly Hills/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "5.85 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Ground + 35" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "816" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (SfT)", "value": "1,796–2,124" },
            { "icon": "fas fa-ruler-combined", "title": "4 BHK (SfT)", "value": "2,708" }
        ],
        "description": "Prestige Beverly Hills is a luxury residential project by Prestige Group in Kokapet, Hyderabad. Spread across 5.85 acres with three 35‑storey towers, it features 816 upscale 3 & 4 BHK apartments (1,796–2,708 sqft). With a neoclassical clubhouse, multiple indoor and outdoor sports courts, a mini‑theatre, crèche, and extensive landscaping. RERA‑registered (P02400003715), under construction with possession by Oct 2027. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Neoclassical Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Yoga Deck", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Games Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Mini‑Theatre", "icon": "fas fa-film" },
            { "name": "Crèche & Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Jogging/Cycling Tracks & Amphitheatre", "icon": "fas fa-tree" },
            { "name": "Convenience Store", "icon": "fas fa-store" },
            { "name": "24×7 Security, CCTV & Power Backup", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed towers with earthquake‑proof design" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedroom; ceramic in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Engineered wooden main door; UPVC/aluminium windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertop; provision for chimney and exhaust" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Ceramic tiles up to ceiling; branded fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; ELCB" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_4.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_5.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_6.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_7.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_8.jpg"),
        ]
    },

    // Prestige Clairemont 
    {
        "id": "prestige_clairemont",
        "project_name": "Prestige Clairemont",
        "category": "Flats",
        "title": "Prestige Clairemont by Prestige Group",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige Beverly Hills/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.56 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "2B+G+33/38" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "928" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 3.5 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "1,988–4,060" }
        ],
        "description": "Prestige Clairemont is a luxury gated community in Kokapet's Neopolis layout, spanning 7.56 acres with four high-rise towers (up to 38 floors) and 928 premium 3, 3.5 & 4 BHK apartments (1,988–4,060 sqft). The project will be ready from Nov 2027, RERA‑registered (P02400005677), and features a neoclassical clubhouse, smart amenities, and green initiatives like rainwater harvesting and solar energy integration.:contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Clubhouse, Gym & Spa", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor/Outdoor Courts (squash, badminton, basketball, cricket)", "icon": "fas fa-basketball-ball" },
            { "name": "Mini‑Theatre, Salon, Clinic, Pharmacy", "icon": "fas fa-film" },
            { "name": "Jogging/Cycling Track & Skating Rink", "icon": "fas fa-tree" },
            { "name": "Kids’ Play Area & Crèche", "icon": "fas fa-child" },
            { "name": "Convenience Store", "icon": "fas fa-store" },
            { "name": "24×7 Security, CCTV, Power Backup", "icon": "fas fa-shield-alt" },
            { "name": "Sewage Treatment & Rainwater Harvesting", "icon": "fas fa-water" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall with basements & podium" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; ceramic in balconies/wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Laminated flush doors; UPVC/aluminium windows" },
            { "icon": "fas fa-utensils", "title": "Kitchen", "content": "Granite countertops; exhaust provision; utility space" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Full-height ceramic tiles, branded fittings, geysers" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, ELCB, DG backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_4.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_5.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_6.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_7.jpg"),
            require("../images/projects/Flats/Prestige Beverly Hills/gallery_8.jpg"),
        ]
    },


    // Prestige Spring Heights 
    {
        "id": "prestige_spring_heights",
        "project_name": "Prestige Spring Heights",
        "category": "Flats",
        "title": "Prestige Spring Heights by Prestige Group",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige Spring Heights/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "10.6 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+34" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,556" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "3 BHK (Sqft)", "value": "1,576–2,083" },
            { "icon": "fas fa-ruler-combined", "title": "4 BHK (Sqft)", "value": "2,429–3,051" }
        ],
        "description": "Prestige Spring Heights is a next-gen luxury high-rise precinct by Prestige Group in Budvel, Rajendra Nagar. Spanning 10.6 acres with four G+34 towers, it offers 1,556 premium 3 & 4 BHK homes (1,576–3,051 sqft), with 80% open spaces, RERA‑registered (P02400009416), and possession expected from Mar 2030. It boasts a 100,000 sqft clubhouse, over 50 amenities, and lakeside views near Himayat Sagar and ORR. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "100,000 sqft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Rooftop Garden", "icon": "fas fa-swimmer" },
            { "name": "Gym, Spa, Indoor Games & Multipurpose Hall", "icon": "fas fa-dumbbell" },
            { "name": "Squash, Badminton & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Mini‑Theatre & Cafe Lounge", "icon": "fas fa-film" },
            { "name": "Children’s Play Area & Senior Citizen Zone", "icon": "fas fa-child" },
            { "name": "Jogging/Cycling Track & Reflexology Path", "icon": "fas fa-tree" },
            { "name": "Convenience Store", "icon": "fas fa-store" },
            { "name": "24×7 Security, CCTV & Terrace Lawn", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & Sewage Treatment Plant", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC-frame with vitrified finishes in lobbies; blocks wall & floor-to-ceiling glass windows" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; ceramic/anti‑skid in wet areas & balconies" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Laminated flush/internal doors; UPVC/AL windows with mosquito mesh" },
            { "icon": "fas fa-bolt", "title": "Electrical & Plumbing", "content": "Concealed copper wiring, modular switches, RO in kitchen, ELCB, 100% DG backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige Spring Heights/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige Spring Heights/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige Spring Heights/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige Spring Heights/gallery_4.jpg"),
            require("../images/projects/Flats/Prestige Spring Heights/gallery_5.jpg"),
            require("../images/projects/Flats/Prestige Spring Heights/gallery_6.jpg"),
        ]
    },


    // Prestige Bellagio
    {
        "id": "prestige_bellagio",
        "project_name": "Prestige Bellagio",
        "category": "Flats",
        "title": "Prestige Bellagio at The Prestige City",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige Bellagio/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "24 Acres" },
            { "icon": "fas fa-building", "title": "Units", "value": "119 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2" },
            { "icon": "fas fa-home", "title": "Villas", "value": "4 & 5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (sqft)", "value": "5,308–13,243 built‑up" }
        ],
        "description": "Prestige Bellagio is an ultra‑luxury villa enclave within The Prestige City, Rajendra Nagar. Set across 24 acres overlooking Mulagund Lake, it features 119 beautifully designed 4 & 5 BHK villas (≈5,300–13,200 sqft built‑up) across 3 floors. RERA‑registered (P02400006711), under construction with expected completion by Dec 2025.",
        "amenities": [
            { "name": "30,000 sqft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Spa & Salon", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games, Multipurpose Hall", "icon": "fas fa-basketball-ball" },
            { "name": "Club Lounge & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Jogging/Cycling Paths & Park", "icon": "fas fa-tree" },
            { "name": "24×7 Security, CCTV & Fire Systems", "icon": "fas fa-shield-alt" },
            { "name": "Power & Water Backup", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed villas, earthquake‑resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak/main doors; UPVC/sliding windows" },
            { "icon": "fas fa-bolt", "title": "Electrical & Smart", "content": "Concealed wiring, modular switches, intercom" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige Bellagio/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_4.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_5.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_6.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_7.jpg"),
            require("../images/projects/Flats/Prestige Bellagio/gallery_8.jpg"),
        ]
    },


    // Prestige Tranquil 
    {
        "id": "prestige_tranquil",
        "project_name": "Prestige Tranquil",
        "category": "Flats",
        "title": "Prestige Tranquil by Prestige Group",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige Tranquil/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.85 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+34" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "906" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3 & 3.5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "1,390–2,048 sqft" }
        ],
        "description": "Prestige Tranquil is a luxury gated community in Kokapet spanning 7.85 acres with four 34-storey towers and 906 well‑designed 3 & 3.5 BHK homes (1,390–2,048 sqft). All flats are Vaastu‑compliant, RERA‑registered (P02400002236), and possession begins Sep 2026. It offers thoughtfully planned layouts, abundant green space, and proximity to IT hubs, ORR, and Financial District. :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "Double‑height grand lobby & clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming pool & kid’s pool", "icon": "fas fa-swimmer" },
            { "name": "Gym, spa, squash, badminton & basketball courts", "icon": "fas fa-basketball-ball" },
            { "name": "Indoor games, mini‑theatre & banquet hall", "icon": "fas fa-film" },
            { "name": "Children’s play area & senior‑citizen zones", "icon": "fas fa-child" },
            { "name": "Jogging/cycling tracks & landscaped gardens", "icon": "fas fa-tree" },
            { "name": "Convenience store & café", "icon": "fas fa-store" },
            { "name": "24×7 security, CCTV, fire‑fighting & backup power", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed high‑rise with earthquake‑resistant design" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in living/bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Laminated internal doors; UPVC/aluminium windows" },
            { "icon": "fas fa-bolt", "title": "Electrical & Green", "content": "Concealed copper wiring, modular switches, ELCB, rainwater harvesting & STP" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige Tranquil/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige Tranquil/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige Tranquil/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige Tranquil/gallery_4.jpg"),
        ]
    },


    // Prestige Vaishnaoi Rainbow Waters 
    {
        "id": "prestige_vaishnaoi_rainbow_waters",
        "project_name": "Prestige Vaishnaoi Rainbow Waters",
        "category": "Flats",
        "title": "Prestige Vaishnaoi Rainbow Waters by Prestige Group",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "2.42 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "2B+5P+36" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "150" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 & 5 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "4,955–7,757" }
        ],
        "description": "Prestige Vaishnaoi Rainbow Waters is an ultra‑luxury lake‑facing high‑rise in Gachibowli, Hyderabad. Launched July 2023, this single‑tower project on 2.42 acres offers 150 spacious 4‑5 BHK apartments (4,955–7,757 sqft) with panoramic views of Malkam Cheruvu. RERA‑registered (P02400006240), possession expected by late 2028..",
        "amenities": [
            { "name": "Multi-storey clubhouse & fitness centre", "icon": "fas fa-building" },
            { "name": "Swimming pool & indoor pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor cinema, spa/sauna & lounge", "icon": "fas fa-film" },
            { "name": "Sports courts (basketball, tennis, squash)", "icon": "fas fa-basketball-ball" },
            { "name": "Badminton court", "icon": "fas fa-basketball-ball" },
            { "name": "Jogging track & landscaped gardens", "icon": "fas fa-tree" },
            { "name": "Supermarket, pharmacy & café", "icon": "fas fa-store" },
            { "name": "Children’s play area & amphitheatre", "icon": "fas fa-child" },
            { "name": "24×7 security, CCTV & intercom", "icon": "fas fa-shield-alt" },
            { "name": "100% DG backup & rainwater harvesting", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed, Zone‑3 earthquake resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living/bedrooms; anti‑skid tiles in balconies/utilities" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "8‑ft engineered wood flush doors; aluminum/UPVC windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, VRV AC provisions, 100% DG backup (optional)" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_4.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_5.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_6.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_7.jpg"),
            require("../images/projects/Flats/Prestige Vaishnaoi Rainbow Waters/gallery_8.jpg"),
        ]
    },


    // Prestige High Fields 
    {
        "id": "prestige_high_fields",
        "project_name": "Prestige High Fields",
        "category": "Flats",
        "title": "Prestige High Fields by Prestige Group",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Prestige High Fields/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "21.8 – 22 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "10" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "2B+G+33 (≈33‑floor towers)" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈2,240 – 2,660" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2, 2.5, 3, 3.5 & 4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (sqft)", "value": "1,283 – 2,848" }
        ],
        "description": "Prestige High Fields is a ready-to-move luxury township in Nanakramguda/Gachibowli, spanning ~22 acres with 10 high-rise towers (≈33 floors) featuring ~2,240–2,660 premium 2–4 BHK apartments (1,283–2,848 sqft). Located in the Financial District, it offers super connectivity, extensive amenities and a Disney-themed landscape experience. RERA-registered (P02400002893); possession largely completed by 2021–2022.",
        "amenities": [
            { "name": "Disney-themed landscaping & 40+ amenities", "icon": "fas fa-building" },
            { "name": "Clubhouse, gym, spa, salon", "icon": "fas fa-dumbbell" },
            { "name": "Swimming pool & kids’ pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor/outdoor courts (squash, badminton, basketball, tennis)", "icon": "fas fa-basketball-ball" },
            { "name": "Children’s play areas", "icon": "fas fa-child" },
            { "name": "Jogging/cycling tracks & landscaped gardens", "icon": "fas fa-tree" },
            { "name": "Convenience store, ATM & pantry", "icon": "fas fa-store" },
            { "name": "24×7 security, CCTV, boom barrier access", "icon": "fas fa-shield-alt" },
            { "name": "Power & water backup, sewage treatment", "icon": "fas fa-bolt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed 2B+G+33 towers; wind & earthquake resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; ceramic/anti‑skid in wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Laminated internal/main doors; UPVC/aluminium windows" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches; ELCB; full DG backup" }
        ],
        "gallery": [
            require("../images/projects/Flats/Prestige High Fields/gallery_1.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_2.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_3.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_4.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_5.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_6.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_7.jpg"),
            require("../images/projects/Flats/Prestige High Fields/gallery_8.jpg"),
        ]
    },


    // IRIS by Raghava 
    {
        "id": "raghava_iris",
        "project_name": "IRIS by Raghava",
        "category": "Flats",
        "title": "IRIS by Raghava Projects LLP",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Raghava Iris/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "4B+G+45" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "≈520" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 & 6 BHK (simplex & duplex)" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "5,425–11,990" }
        ],
        "description": "IRIS is an ultra‑luxury residential landmark in Raidurgam, Hyderabad, featuring three 45‑storey towers over 7 acres. It offers approx. 520 Vastu‑compliant 4 & 6 BHK simplex and duplex apartments (5,400–12,000 sqft), each with private elevators and servant rooms. The crown‑jewel: a 1‑lakh sq ft interconnected Sky Island linking all three towers atop the 45th floor. RERA‑registered (P02400005078); possession expected by Sep 2028.",
        "amenities": [
            { "name": "1‑Lakh sqft Sky Island (sky‑deck & pools)", "icon": "fas fa-tree" },
            { "name": "52,000 sqft multi‑level clubhouse", "icon": "fas fa-building" },
            { "name": "Banquet halls, co‑working, cafe, bar, supermarket", "icon": "fas fa-store" },
            { "name": "Private theatre & business lounge", "icon": "fas fa-film" },
            { "name": "Pools (sky + family + kids)", "icon": "fas fa-swimmer" },
            { "name": "Indoor + outdoor courts, play areas, jogging loops", "icon": "fas fa-basketball-ball" },
            { "name": "Forest‑themed fitness stations & amphitheatre", "icon": "fas fa-dumbbell" },
            { "name": "Personal + guest + service lifts", "icon": "fas fa-elevator" },
            { "name": "4‑level basement parking", "icon": "fas fa-car" },
            { "name": "24×7 security, CCTV, DG & rainwater harvesting", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall frame with wind & earthquake resistance" },
            { "icon": "fas fa-border-style", "title": "Basement", "content": "4‑level automated parking" },
            { "icon": "fas fa-bolt", "title": "Electrical & Smart", "content": "Personal elevator, concealed wiring, smart‑home ready" },
            { "icon": "fas fa-water", "title": "Green Features", "content": "Rainwater harvesting, STP, high open‑space ratio (~80%)" }
        ],
        "gallery": [
            require("../images/projects/Flats/Raghava Iris/gallery_1.jpg"),
            require("../images/projects/Flats/Raghava Iris/gallery_2.jpg"),
            require("../images/projects/Flats/Raghava Iris/gallery_3.jpg"),
            require("../images/projects/Flats/Raghava Iris/gallery_4.jpg"),
            require("../images/projects/Flats/Raghava Iris/gallery_5.jpg"),
            require("../images/projects/Flats/Raghava Iris/gallery_6.jpg"),
        ]
    },


    // CINQ by Raghava 
    {
        "id": "raghava_cinq",
        "project_name": "CINQ by Raghava",
        "category": "Flats",
        "title": "CINQ by Raghava Projects LLP",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/CINQ by Raghava/Main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "7.19 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "5" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "5B+Stilt+61" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "1,132 – 1,225" },
            { "icon": "fas fa-home", "title": "Flats", "value": "4 BHK" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes (Sqft)", "value": "3,575–3,644" }
        ],
        "description": "CINQ is an ultra‑luxury 4 BHK high‑rise development by Raghava in Financial District, Nanakramguda. Spread over 7.19 acres, it consists of five 61‑storey towers, offering spacious 3,575–3,644 sqft homes. With only four units per floor, smart‑home integration and world‑class amenities, possession is expected by Dec 2028. RERA‑registered (P02400009341). :contentReference[oaicite:2]{index=2}",
        "amenities": [
            { "name": "55,000 sqft club‑house ‘The Oasis’", "icon": "fas fa-building" },
            { "name": "Tower‑level lounges & amenities (~40,000 sqft each)", "icon": "fas fa-dumbbell" },
            { "name": "Pools in every tower + infinity pool", "icon": "fas fa-swimmer" },
            { "name": "Sky lounges with pickleball, yoga decks", "icon": "fas fa-tree" },
            { "name": "Multi‑level walking tracks, amphitheatre, kids' play areas", "icon": "fas fa-child" },
            { "name": "Gym, spa, indoor games, banquet, creche", "icon": "fas fa-film" },
            { "name": "24×7 security, CCTV, power & water backup", "icon": "fas fa-shield-alt" }
        ],
        "specifications": [
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles living; laminated in master; anti‑skid wet zones" },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Solid‑wood frames; flush doors" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, smart‑home ready" },
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed towers, advanced structural engineering" }
        ],
        "gallery": [
            require("../images/projects/Flats/CINQ by Raghava/gallery_1.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_2.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_3.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_4.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_5.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_6.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_7.jpg"),
            require("../images/projects/Flats/CINQ by Raghava/gallery_8.jpg"),
        ]
    },
    // Bhanu
    // //// Jaggu /////////
    {
        id: "radhey-skye",
        project_name: "Radhey Skye",
        category: "Flats",
        title: "Radhey Skye – Luxury Apartments in Kollur",
        location: "Hyderabad",
        image: require("../images/projects/Flats/radhe-sky/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "10 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "7" },
            { icon: "fas fa-layer-group", title: "Units", value: "1,419" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,325–2,610 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Mar 2026" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P01100006237" }
        ],

        description: [
            "Radhey Skye is a gated premium apartment community in Kollur, Hyderabad. Spanning 10 acres with 7 towers and 1,419 units (2 BHK–3.5 BHK), it offers spacious layouts (1,325–2,610 sq.ft.), abundant green areas, and a rich amenity mix designed for modern family living."
        ],

        amenities: [
            { name: "Skating Rink", icon: "fas fa-skating" },
            { name: "Infinity Walk", icon: "fas fa-walking" },
            { name: "Outdoor Gym", icon: "fas fa-dumbbell" },
            { name: "Pet Park", icon: "fas fa-paw" },
            { name: "Cricket & Volleyball Courts", icon: "fas fa-basketball-ball" },
            { name: "Tennis Court", icon: "fas fa-table-tennis" },
            { name: "Skateboard Park", icon: "fas fa-skateboard" },
            { name: "Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Sand Pit", icon: "fas fa-umbrella-beach" },
            { name: "Zen & Herb Gardens", icon: "fas fa-leaf" },
            { name: "Adventure Play Zone", icon: "fas fa-child" },
            { name: "Co‑Working Space", icon: "fas fa-briefcase" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Flooring",
                content: "Vitrified tiles in living & bedrooms; anti-skid in wet areas"
            },
            {
                icon: "fas fa-window-restore",
                title: "Windows",
                content: "Anodized aluminum sliding windows"
            },
            {
                icon: "fas fa-paint-roller",
                title: "Wall Finish",
                content: "Acrylic emulsion internal; textured external"
            },
            {
                icon: "fas fa-bolt",
                title: "Electrical",
                content: "Modular switches & provision for appliances"
            },
            {
                icon: "fas fa-shield-alt",
                title: "Security",
                content: "24×7 CCTV & gated community access"
            }
        ],

        gallery: [
            require("../images/projects/Flats/radhe-sky/gallery-1.jpg"),
            require("../images/projects/Flats/radhe-sky/gallery-2.jpg"),
            require("../images/projects/Flats/radhe-sky/gallery-3.jpg"),
            require("../images/projects/Flats/radhe-sky/gallery-4.jpg")
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.35!3d17.40"
    }
    ,
    {
        id: "eka-one",
        project_name: "Raichandani Eka One",
        category: "Flats",
        title: "Raichandani Eka One",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Raichandani Eka One/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "–" },
            { icon: "fas fa-building", title: "Tower", value: "1 (45 storeys)" },
            { icon: "fas fa-home", title: "Residences", value: "60 exclusive units" },
            { icon: "fas fa-ruler-combined", title: "Unit Size", value: "6,779–15,825 sq ft" },
            { icon: "fas fa-chalkboard-teacher", title: "Clubhouse", value: "35,000 sq ft" },
            { icon: "fas fa-clock", title: "Possession", value: "–" },
            { icon: "fas fa-id-card", title: "RERA Compliance", value: "Yes" }
        ],

        description: [
            "Eka One is a 45‑storey limited‑edition high‑rise in Kokapet, Hyderabad, featuring just 60 ultra‑luxury residences (6,779–15,825 sq ft). Designed by NA‑Architects along the lake, it delivers grand balconies, imported finishes, premium amenities, and full smart‑home automation."
        ],

        amenities: [
            { name: "Grand Double‑height Lobby", icon: "fas fa-door-open" },
            { name: "35,000 sq ft Clubhouse", icon: "fas fa-building" },
            { name: "Temperature‑controlled Pool", icon: "fas fa-swimmer" },
            { name: "Steam & Sauna", icon: "fas fa-hot-tub" },
            { name: "Guest Rooms", icon: "fas fa-bed" },
            { name: "Indoor Games: Squash, Badminton, Mini‑Theatre", icon: "fas fa-theater-masks" },
            { name: "Library & Business Centre", icon: "fas fa-book" },
            { name: "Conference Rooms", icon: "fas fa-users" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "VRV Central AC", icon: "fas fa-snowflake" },
            { name: "Home Automation", icon: "fas fa-home" },
            { name: "Biometric Access & CCTV", icon: "fas fa-shield-alt" },
            { name: "Rainwater Harvesting", icon: "fas fa-water" },
            { name: "Recycled Water Systems", icon: "fas fa-recycle" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Facade & Floors", content: "Undulating design by NA Architects with imported marble & high ceilings" },
            { icon: "fas fa-window-restore", title: "Windows", content: "Aluminium windows with DGU for insulation" },
            { icon: "fas fa-paint-roller", title: "Wall Finish", content: "Acrylic emulsion interiors, textured exteriors" },
            { icon: "fas fa-bolt", title: "Electrical", content: "Modular switches, appliance-ready points" },
            { icon: "fas fa-shield-alt", title: "Security", content: "Biometric locks, panic buttons, full CCTV" },
            { icon: "fas fa-hot-tub", title: "Pool Control", content: "Deck‑level temperature control" }
        ],

        gallery: [
            require("../images/projects/Flats/Raichandani Eka One/gallery-1.jpg"),
            require("../images/projects/Flats/Raichandani Eka One/gallery-2.jpg"),
            require("../images/projects/Flats/Raichandani Eka One/gallery-3.jpg"),
            require("../images/projects/Flats/Raichandani Eka One/gallery-4.jpg")
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.387!3d17.448"
    }
    ,
    {
        id: "aura-residency",
        project_name: "Raichandani Aura",
        category: "Flats",
        title: "Raichandani Aura",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Raichandani Aura/raichandani-aura.jpg"),

        project_overview: [
            { icon: "fas fa-building", title: "Towers", value: "1" },
            { icon: "fas fa-layer-group", title: "Floors", value: "6" },
            { icon: "fas fa-home", title: "Units", value: "12" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "2,400–3,800 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Ready to Move" },
            { icon: "fas fa-id-card", title: "RERA", value: "RERA‑Approved" }
        ],

        description: [
            "Aura Residency is an exclusive boutique development in prime Banjara Hills, Hyderabad. With just 12 ultra-spacious 3 & 4 BHK apartments, it offers a luxurious living experience spanning 2,400–3,800 sq.ft., designer lobby, landscaped areas, and premium amenities—all in a six‑storey structure."
        ],

        amenities: [
            { name: "Designer Lobby", icon: "fas fa-door-open" },
            { name: "Open Gym", icon: "fas fa-dumbbell" },
            { name: "Yoga Room", icon: "fas fa-spa" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Senior Citizens’ Plaza", icon: "fas fa-walking" },
            { name: "Mud Play Zone", icon: "fas fa-seedling" },
            { name: "Clubhouse", icon: "fas fa-building" },
            { name: "Convenience Store", icon: "fas fa-shopping-basket" },
            { name: "Visitor Parking", icon: "fas fa-parking" },
            { name: "24×7 Security & CCTV", icon: "fas fa-shield-alt" },
            { name: "Lift", icon: "fas fa-elevator" },
            { name: "Fire Fighting System", icon: "fas fa-fire-extinguisher" },
            { name: "Rainwater Harvesting", icon: "fas fa-water" },
            { name: "Recycling Zone", icon: "fas fa-recycle" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Flooring",
                content: "Premium marble in living/dining, vitrified in bedrooms."
            },
            {
                icon: "fas fa-window-restore",
                title: "Windows",
                content: "Aluminium sliding windows with safety grills."
            },
            {
                icon: "fas fa-paint-roller",
                title: "Paint",
                content: "Acrylic washable interior; external weatherproof paint."
            },
            {
                icon: "fas fa-bolt",
                title: "Electrical",
                content: "Concealed wiring, modular switches, backup power."
            },
            {
                icon: "fas fa-shield-alt",
                title: "Security",
                content: "24/7 CCTV, intercom, gated entrance."
            }
        ],

        gallery: [
            require("../images/projects/Flats/Raichandani Aura/gallery-1.png"),
            require("../images/projects/Flats/Raichandani Aura/gallery-2.png"),
            require("../images/projects/Flats/Raichandani Aura/gallery-3.png"),
            require("../images/projects/Flats/Raichandani Aura/gallery-4.png"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.57!2d78.392!3d17.439"
    }
    ,
    {
        id: "ramky-one-astra",
        project_name: "Ramky One Astra",
        category: "Flats",
        title: "Ramky One Astra",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Ramky One Astra/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "3.69 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "3" },
            { icon: "fas fa-layer-group", title: "Floors", value: "15 each" },
            { icon: "fas fa-home", title: "Units", value: "214" },
            { icon: "fas fa-ruler-combined", title: "Size Range", value: "1,720–2,460 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Dec 2026 (Jun 2025 ready units)" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400000034" }
        ],

        description: [
            "Ramky One Astra is a premium gated community of 3 & 4 BHK apartments in Kokapet, Hyderabad. Spanning 3.69 acres, it comprises 3 towers with 214 units across 15 floors, sized between 1,720–2,460 sq.ft., and offers modern amenities in a serene, landscaped setup."
        ],

        amenities: [
            { name: "Butterfly Garden", icon: "fas fa-leaf" },
            { name: "Outdoor Gym", icon: "fas fa-dumbbell" },
            { name: "Jogging Track", icon: "fas fa-running" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Pergolas & Sit-outs", icon: "fas fa-tree" },
            { name: "Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Tennis Court", icon: "fas fa-table-tennis" },
            { name: "Multipurpose Hall", icon: "fas fa-building" },
            { name: "Herb Garden", icon: "fas fa-seedling" },
            { name: "Indoor Games", icon: "fas fa-chess-board" },
            { name: "Aerobics Room", icon: "fas fa-running" },
            { name: "24/7 Security & CCTV", icon: "fas fa-shield-alt" },
            { name: "Rainwater Harvesting & STP", icon: "fas fa-water" }
        ],

        specifications: [
            { icon: "fas fa-building", title: "Structure", content: "RCC frame built to seismic norms" },
            { icon: "fas fa-border-style", title: "Flooring", content: "Vitrified in living/bedrooms; anti-skid in wet areas" },
            { icon: "fas fa-window-restore", title: "Windows", content: "UPVC/aluminium sliding with mesh" },
            { icon: "fas fa-paint-roller", title: "Paint", content: "Acrylic internal; textured external" },
            { icon: "fas fa-bolt", title: "Electrical", content: "Modular switches w/ appliance points" },
            { icon: "fas fa-shield-alt", title: "Security", content: "24×7 CCTV, gated entry" }
        ],

        gallery: [
            require("../images/projects/Flats/Ramky One Astra/gallery-1.jpg"),
            require("../images/projects/Flats/Ramky One Astra/gallery-2.jpg"),
            require("../images/projects/Flats/Ramky One Astra/gallery-3.jpg"),
            require("../images/projects/Flats/Ramky One Astra/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.395!3d17.398"
    }
    ,
    {
        id: "ramky-one-odyssey",
        project_name: "Ramky One Odyssey",
        category: "Flats",
        title: "Ramky One Odyssey – 3‑4.5 BHK Apartments in Kokapet",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Ramky One Odyssey/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "5.3 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "3" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+3+36" },
            { icon: "fas fa-home", title: "Units", value: "783" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,750–3,020 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Dec 2026 – Mar 2027" },
            { icon: "fas fa-id-card", title: "RERA", value: "P02400003991" }
        ],

        description: [
            "Ramky One Odyssey is a luxury gated community in Kokapet, Hyderabad, featuring 783 smartly designed 3, 3.5 & 4.5 BHK apartments across 3 towers on 5.3 acres. It combines high-end amenities with a biophilic design, spacious layouts, and a 50,000 sq.ft clubhouse."
        ],

        amenities: [
            { name: "50,000 sq.ft Clubhouse", icon: "fas fa-building" },
            { name: "Swimming Pool + Toddler Pool", icon: "fas fa-swimmer" },
            { name: "Indoor Badminton & Squash Courts", icon: "fas fa-table-tennis" },
            { name: "Outdoor Courts (Tennis/Basketball/Cricket)", icon: "fas fa-basketball-ball" },
            { name: "Outdoor Gym & Jogging / Cycling Track", icon: "fas fa-dumbbell" },
            { name: "Kids’ Play Area & Amphitheatre", icon: "fas fa-child" },
            { name: "Mini Golf Putting", icon: "fas fa-golf-ball" },
            { name: "Multipurpose Hall", icon: "fas fa-building" },
            { name: "Yoga / Meditation Room", icon: "fas fa-spa" },
            { name: "Board Games & Creative Zones", icon: "fas fa-chess-board" },
            { name: "Guest Rooms & Lounge Area", icon: "fas fa-bed" },
            { name: "CCTV & 24×7 Security", icon: "fas fa-shield-alt" },
            { name: "Power Backup & STP", icon: "fas fa-water" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Flooring", content: "Vitrified in living/bedrooms; anti‑skid in wet areas" },
            { icon: "fas fa-window-restore", title: "Windows", content: "UPVC/aluminium sliding with mesh" },
            { icon: "fas fa-paint-roller", title: "Paint", content: "Acrylic emulsion interior; textured exterior" },
            { icon: "fas fa-bolt", title: "Electrical", content: "Modular switches; appliance provisions" },
            { icon: "fas fa-shield-alt", title: "Safety", content: "24×7 CCTV; gated access" }
        ],

        gallery: [
            require("../images/projects/Flats/Ramky One Odyssey/gallery-1.jpg"),
            require("../images/projects/Flats/Ramky One Odyssey/gallery-2.jpg"),
            require("../images/projects/Flats/Ramky One Odyssey/gallery-3.jpg"),
            require("../images/projects/Flats/Ramky One Odyssey/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.0!2d78.395!3d17.398"
    }
    ,
    {
        id: "ramky-one-symphony",
        project_name: "Ramky One Symphony",
        category: "Flats",
        title: "Ramky One Symphony",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Ramky One Symphony/main.png"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "13.8 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "9" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+14" },
            { icon: "fas fa-home", title: "Units", value: "1,450+ Apartments" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,040–1,585 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Jun 2027" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P01100003145" }
        ],

        description: [
            "Ramky One Symphony is a premium gated community in Patancheru, Hyderabad, spread across 13.8 acres with 9 towers and over 1,450 apartments (2 & 3 BHK, 1,040–1,585 sq.ft.). Featuring eco‑friendly biophilic design, Miyawaki forest, central courtyards, and over 45 modern amenities, it offers a harmonious lifestyle by NH‑65 and ORR connectivity."
        ],

        amenities: [
            { name: "Swimming & Kids’ Pools", icon: "fas fa-swimmer" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Mini Soccer Field", icon: "fas fa-futbol" },
            { name: "Half Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Tennis & Volleyball Courts", icon: "fas fa-table-tennis" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Cricket Practice Net", icon: "fas fa-cricket" },
            { name: "Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Multi‑Purpose Hall", icon: "fas fa-building" },
            { name: "Outdoor Gym & Jogging Track", icon: "fas fa-running" },
            { name: "Miyawaki Forest & Green Courtyards", icon: "fas fa-tree" },
            { name: "Supermarket & Convenience", icon: "fas fa-shopping-basket" },
            { name: "Senior Citizen Zone", icon: "fas fa-walking" },
            { name: "Creche / Daycare", icon: "fas fa-baby" },
            { name: "CCTV & 24×7 Security", icon: "fas fa-shield-alt" },
            { name: "Power Backup & STP", icon: "fas fa-water" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Flooring", content: "Vitrified in living/bedrooms; anti-skid in wet areas" },
            { icon: "fas fa-window-restore", title: "Windows", content: "UPVC/aluminium sliding with mesh" },
            { icon: "fas fa-paint-roller", title: "Wall Finish", content: "Acrylic emulsion internal; textured external" },
            { icon: "fas fa-bolt", title: "Electrical", content: "Modular switches with appliance points" },
            { icon: "fas fa-shield-alt", title: "Security", content: "24×7 CCTV, gated community access" }
        ],

        gallery: [
            require("../images/projects/Flats/Ramky One Symphony/gallery-1.jpg"),
            require("../images/projects/Flats/Ramky One Symphony/gallery-2.jpg"),
            require("../images/projects/Flats/Ramky One Symphony/gallery-3.jpg"),
            require("../images/projects/Flats/Ramky One Symphony/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228.0!2d78.395!3d17.398"
    },
    {
        id: "sattva-lake-ridge",
        project_name: "Sattva Lake Ridge",
        category: "Flats",
        title: "Sattva Lake Ridge",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Sattva Lakeridge/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "9.5 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "6" },
            { icon: "fas fa-layer-group", title: "Floors", value: "Stilt + 36" },
            { icon: "fas fa-home", title: "Units", value: "897 – 946" },
            { icon: "fas fa-ruler-combined", title: "Size Range", value: "2,152 – 5,472 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Jan 2028" },
            { icon: "fas fa-id-card", title: "RERA IDs", value: "P02400006230 / P02400006231" }
        ],

        description: [
            "Sattva Lake Ridge is a luxury gated community in Kokapet (Neopolis), Hyderabad. Spanning ~9.5 acres with 6 towers (Stilt+36 floors) and ~900 apartments, the project offers spacious 3, 4 & 5 BHK units (2,152 – 5,472 sq.ft.) with high‑end finishes, floor‑to‑ceiling glass, private elevators in select towers, and panoramic lake views."
        ],

        amenities: [
            { name: "65,000 sq.ft Clubhouse", icon: "fas fa-building" },
            { name: "Swimming Pool & Kids’ Pool", icon: "fas fa-swimmer" },
            { name: "Gym & Health Club", icon: "fas fa-dumbbell" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Tennis, Badminton & Basketball Courts", icon: "fas fa-table-tennis" },
            { name: "Squash Court", icon: "fas fa-volleyball-ball" },
            { name: "Jogging & Cycling Track", icon: "fas fa-running" },
            { name: "Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Indoor Games (Billiards/Table Tennis)", icon: "fas fa-chess-board" },
            { name: "Business Centre / Office Spaces", icon: "fas fa-briefcase" },
            { name: "Café / Convenience Store", icon: "fas fa-coffee" },
            { name: "Creche / Children’s Pool", icon: "fas fa-baby" },
            { name: "Laundrette", icon: "fas fa-tshirt" },
            { name: "Multipurpose Hall", icon: "fas fa-building" },
            { name: "24×7 Security & CCTV", icon: "fas fa-shield-alt" },
            { name: "Power Backup & STP", icon: "fas fa-water" },
            { name: "Rainwater Harvesting", icon: "fas fa-water" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Flooring",
                content: "Vitrified in living/bedrooms; anti‑skid in wet areas"
            },
            {
                icon: "fas fa-window-restore",
                title: "Windows",
                content: "Double‑glazed, floor-to-ceiling glass for panoramic views"
            },
            {
                icon: "fas fa-paint-roller",
                title: "Paint",
                content: "Acrylic internal; weather‑proof external paint"
            },
            {
                icon: "fas fa-bolt",
                title: "Electrical",
                content: "Concealed copper wiring, modular switches, generator backup"
            },
            {
                icon: "fas fa-shield-alt",
                title: "Safety",
                content: "24×7 surveillance, gated access, fire‑fighting systems"
            }
        ],

        gallery: [
            require("../images/projects/Flats/Sattva Lakeridge/gallery-1.jpg"),
            require("../images/projects/Flats/Sattva Lakeridge/gallery-2.jpg"),
            require("../images/projects/Flats/Sattva Lakeridge/gallery-3.jpg"),
            require("../images/projects/Flats/Sattva Lakeridge/gallery-4.jpg"),
        ],

        google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.395!3d17.398"
    },
    {
        id: "sas-crown",
        project_name: "SAS Crown",
        category: "Flats",
        title: "SAS Crown",
        location: "Hyderabad",
        image: require("../images/projects/Flats/SAS Crown/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "4.5 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "5 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "B+G+57" },
            { icon: "fas fa-home", title: "Units", value: "235 Apartments" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "6,565–8,811 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Mar 2027" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400002786" }
        ],

        description: [
            "Standing at 236 m with 57 floors, SAS Crown is set to be South India’s tallest residential tower. Located on Kokapet’s prestigious Golden Mile Road, this ultra-luxury project includes 4 & 5 BHK sky villas (single unit per floor), private lobbies, imported Italian marble interiors, ceiling heights of 13 ft, and panoramic city views."
        ],

        amenities: [
            { name: "100,000 sq.ft Clubhouse", icon: "fas fa-building" },
            { name: "Olympic‑sized Pool + Jacuzzi + Sun‑deck", icon: "fas fa-swimmer" },
            { name: "Gym & Spa", icon: "fas fa-dumbbell" },
            { name: "Indoor Games & Recreation Rooms", icon: "fas fa-chess-board" },
            { name: "Multiple Sports Courts (Badminton, Basketball, Squash)", icon: "fas fa-basketball-ball" },
            { name: "Children’s Play Area + Kid’s Pool", icon: "fas fa-child" },
            { name: "Open‑air Theatre & Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Library, Lounge & Restaurant with Chef‑on‑call", icon: "fas fa-book" },
            { name: "Conference & Party Hall", icon: "fas fa-users" },
            { name: "Sky Villas – Single unit/floor", icon: "fas fa-city" },
            { name: "Private Lobbies & Elevator Access", icon: "fas fa-elevator" },
            { name: "24/7 Security & CCTV", icon: "fas fa-shield-alt" },
            { name: "Power Backup, Solar & STP", icon: "fas fa-water" },
            { name: "Car Wash / EV Charging", icon: "fas fa-car" },
            { name: "Rainwater Harvesting & Waste Mgmt.", icon: "fas fa-recycle" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Structure",
                content: "R.C.C. framed with AAC block superstructure"
            },
            {
                icon: "fas fa-file-invoice-dollar",
                title: "Flooring",
                content: "Italian marble in living; engineered wood in theatre"
            },
            {
                icon: "fas fa-door-closed",
                title: "Doors & Windows",
                content: "10′ teak main doors; anodised aluminum double‑glazed windows"
            },
            {
                icon: "fas fa-paint-roller",
                title: "Walls & Paint",
                content: "Acrylic emulsion interior; texture finish exterior"
            },
            {
                icon: "fas fa-bolt",
                title: "Electrical",
                content: "Concealed copper wiring, modular switches, 3‑phase supply"
            },
            {
                icon: "fas fa-shield-alt",
                title: "Safety",
                content: "24/7 CCTV, video‑door phone, gated access"
            }
        ],

        gallery: [
            require("../images/projects/Flats/SAS Crown/gallery-1.jpg"),
            require("../images/projects/Flats/SAS Crown/gallery-2.jpg"),
            require("../images/projects/Flats/SAS Crown/gallery-3.jpg"),
            require("../images/projects/Flats/SAS Crown/gallery-4.jpg"),
        ],

        google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.395!3d17.398"
    },
    {
        "id": "sas-soul-of-earth",
        "project_name": "SAS Soul of Earth",
        "category": "Flats",
        "title": "SAS Soul of Earth",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/SAS Soul of earth/main.png"),
        "description": "The fusion of a healthy lifestyle and state-of-the-art facilities in Kukatpally, quoted as the heart of the city, is an unprecedented experience—transforming the impossible into reality for the very first time.",
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Extent", "value": "10 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4 High-rise Towers" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "45 Floors" },
            { "icon": "fas fa-door-open", "title": "Units", "value": "600+ Apartments" },
            { "icon": "fas fa-home", "title": "Flats", "value": "3, 4 BHK & Sky Villas" }
        ],
        "amenities": [
            { "name": "Cycling Track", "icon": "fas fa-bicycle" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Box Cricket", "icon": "fas fa-baseball-ball" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Mini Golf", "icon": "fas fa-golf-ball" },
            { "name": "Party Lawn", "icon": "fas fa-tree" },
            { "name": "Water Feature", "icon": "fas fa-water" },
            { "name": "Gazebo", "icon": "fas fa-umbrella-beach" },
            { "name": "Table Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Squash Court", "icon": "fas fa-basketball-ball" },
            { "name": "Badminton Court", "icon": "fas fa-shuttlecock" },
            { "name": "Utility Space for Stores", "icon": "fas fa-store" },
            { "name": "Banquet Halls", "icon": "fas fa-glass-cheers" },
            { "name": "Conference Halls", "icon": "fas fa-chalkboard" },
            { "name": "Crèche", "icon": "fas fa-baby" },
            { "name": "Billiards & Pool Lounge", "icon": "fas fa-pool-table" },
            { "name": "Rock Climbing Wall", "icon": "fas fa-mountain" },
            { "name": "Party Lounge", "icon": "fas fa-cocktail" },
            { "name": "Futsal", "icon": "fas fa-futbol" }
        ],
        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure",
                "content": "RCC shear wall structure designed for wind and seismic loads."
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Doors",
                "content": "Teak main door, internal hardwood doors, UPVC doors/windows with mosquito mesh."
            },
            {
                "icon": "fas fa-paint-roller",
                "title": "Painting",
                "content": "Premium acrylic interior and textured exterior paints."
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "800x800 mm vitrified tiles; anti-skid tiles in bathrooms and balconies."
            },
            {
                "icon": "fas fa-utensils",
                "title": "Kitchen",
                "content": "Provision for purifier, chimney, washing machine, and dishwasher."
            },
            {
                "icon": "fas fa-bath",
                "title": "Bathrooms",
                "content": "Concealed flush tanks, single lever CP fittings, geyser points."
            },
            {
                "icon": "fas fa-bolt",
                "title": "Electrical",
                "content": "Power points for appliances, modular switches, LED lighting in common areas."
            },
            {
                "icon": "fas fa-th-large",
                "title": "Dadoing",
                "content": "Tiles up to 7' in toilets; 3' in utility."
            },
            {
                "icon": "fas fa-phone-alt",
                "title": "Telecom / Cable",
                "content": "Internet, cable TV, and telephone points in living and bedrooms."
            },
            {
                "icon": "fas fa-charging-station",
                "title": "Lifts",
                "content": "High-speed lifts with granite/tile finish and V3F tech."
            },
            {
                "icon": "fas fa-shield-alt",
                "title": "Security",
                "content": "24/7 CCTV, intercom, panic button, boom barrier."
            },
            {
                "icon": "fas fa-water",
                "title": "Water & STP",
                "content": "Softened water; treated sewage used for landscaping."
            },
            {
                "icon": "fas fa-bolt",
                "title": "Generator",
                "content": "100% power backup with acoustic DG sets."
            },
            {
                "icon": "fas fa-parking",
                "title": "Parking",
                "content": "2-car parking per flat; 3-level basement parking."
            },
            {
                "icon": "fas fa-wheelchair",
                "title": "Differently Abled",
                "content": "Ramps at entrances for easy access."
            },
            {
                "icon": "fas fa-fire-extinguisher",
                "title": "Fire Safety",
                "content": "Sprinklers, alarms & smoke detectors as per norms."
            },
            {
                "icon": "fas fa-gas-pump",
                "title": "LPG",
                "content": "Piped gas to all flats."
            },
            {
                "icon": "fas fa-tasks",
                "title": "Parking Management",
                "content": "Signage and safe turning zones included."
            }
        ],
        "gallery": [
            require("../images/projects/Flats/SAS Soul of earth/gallery-1.png"),
            require("../images/projects/Flats/SAS Soul of earth/gallery-2.png"),
            require("../images/projects/Flats/SAS Soul of earth/gallery-3.png"),
            require("../images/projects/Flats/SAS Soul of earth/gallery-4.png"),
        ]
    },
    {
        id: "sia-prospera",
        project_name: "Sia Prospera",
        category: "Flats",
        title: "Sia Prospera",
        location: "Hyderabad",
        image: require("../images/projects/Flats/sia prospera/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "3.5 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "2 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "Stilt + 17" },
            { icon: "fas fa-home", title: "Units", value: "340 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "2,388–3,434 sq ft" },
            { icon: "fas fa-clock", title: "Possession", value: "Jun 2028" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400007079" }
        ],

        description: "Exquisite business-class living offering 3 BHK (with WFH) & 4 BHK (with maid’s room) units (2,388–3,434 sq ft) in Miyapur, with private lift lobbies, rooftop pool and spa, a 36,000 sq ft clubhouse, and premium engineered-home construction.",

        amenities: [
            { name: "Double‑height lobby", icon: "fas fa-door-open" },
            { name: "36,000 sq ft Clubhouse", icon: "fas fa-building" },
            { name: "Rooftop Infinity Pool", icon: "fas fa-swimmer" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Spa/Salon", icon: "fas fa-spa" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Skating Rink", icon: "fas fa-skating" },
            { name: "Cricket Practice Net", icon: "fas fa-cricket" },
            { name: "Indoor Games Court", icon: "fas fa-chess-board" },
            { name: "Party Lawn", icon: "fas fa-glass-cheers" },
            { name: "Guest Rooms", icon: "fas fa-bed" },
            { name: "Supermarket Space", icon: "fas fa-shopping-cart" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Structure",
                content: "Stilt + 17 floors, RCC shear‑wall construction."
            },
            {
                icon: "fas fa-window-restore",
                title: "Units",
                content: "3 BHK + WFH & 4 BHK + maid’s room, private lift lobby."
            },
            {
                icon: "fas fa-phone-alt",
                title: "Connectivity",
                content: "3.3 km to Miyapur Metro; close to malls, hospitals & schools."
            },
            {
                icon: "fas fa-wifi",
                title: "Tech & Safety",
                content: "Engineered homes, CCTV, gated access."
            },
            {
                icon: "fas fa-water",
                title: "Utilities",
                content: "Terrace pool, clubhouse services, spa & fitness."
            }
        ],

        gallery: [
            require("../images/projects/Flats/sia prospera/gallery-1.jpg"),
            require("../images/projects/Flats/sia prospera/gallery-2.jpg"),
            require("../images/projects/Flats/sia prospera/gallery-3.jpg"),
            require("../images/projects/Flats/sia prospera/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.385!3d17.473"
    },
    {
        id: "ssi-surajbhan-grande",
        project_name: "SSI - Fortune Surajbhan Grande",
        category: "Flats",
        title: "SSI - Fortune Surajbhan Grande",
        location: "Hyderabad",
        image: require("../images/projects/Flats/SSI-fortune/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "12 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "6 Towers (A–F)" },
            { icon: "fas fa-layer-group", title: "Floors", value: "45 Floors" },
            { icon: "fas fa-home", title: "Units", value: "1350 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "2850–3850 sq ft" },
            { icon: "fas fa-clock", title: "Possession", value: "To be announced" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "To be announced" }
        ],

        description: "Live beyond the ordinary at SSI - Fortune Surajbhan Grande, an ultra-luxury gated community in Neopolis, Kokapet. Spanning 12 serene acres with 6 towers rising 45 floors, every home offers panoramic lake views, private lobbies, 11-ft ceilings, and over 75% open space. The project features a 1,00,000 sq ft clubhouse, a vehicular-free landscaped podium, premium specifications, and unmatched urban connectivity.",

        amenities: [
            { name: "1,00,000 sq ft Clubhouse", icon: "fas fa-building" },
            { name: "Double-height Entrance Lobbies", icon: "fas fa-door-open" },
            { name: "Private Lobbies", icon: "fas fa-user-shield" },
            { name: "Lake Views (Gandipet & Kokapet)", icon: "fas fa-water" },
            { name: "Vehicular-free Landscaped Podium", icon: "fas fa-tree" },
            { name: "11-ft Ceiling Height", icon: "fas fa-arrows-alt-v" },
            { name: "Central Landscape (7.5 Acres)", icon: "fas fa-leaf" },
            { name: "6 Passenger Lifts & 2 Service Lifts", icon: "fas fa-elevator" },
            { name: "High-end Premium Specifications", icon: "fas fa-gem" },
            { name: "Only 5 Units per Floor", icon: "fas fa-th-large" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Structure",
                content: "2 Cellars + 4 Podiums + Stilt; 45 floors; first residential floor begins 75 ft above ground."
            },
            {
                icon: "fas fa-window-restore",
                title: "Units",
                content: "3 BHK + Study + Maid Toilet and 4 BHK + P.Room + Maid Toilet; only 5 units per floor."
            },
            {
                icon: "fas fa-map-marker-alt",
                title: "Location",
                content: "Strategically located at Neopolis, opposite CBIT College, with serene lake views."
            },
            {
                icon: "fas fa-road",
                title: "Connectivity",
                content: "Quick access to Financial District, ORR, Gachibowli, and International Airport."
            },
            {
                icon: "fas fa-school",
                title: "Nearby",
                content: "Rockwell Intl. School, Phoenix Intl. School, Continental Hospital, Sheraton Hotel, Microsoft, Capgemini—all within 5–10 mins."
            }
        ],

        gallery: [
            require("../images/projects/Flats/SSI-fortune/gallery-1.jpg"),
            require("../images/projects/Flats/SSI-fortune/gallery-2.jpg"),
            require("../images/projects/Flats/SSI-fortune/gallery-3.jpg"),
            require("../images/projects/Flats/SSI-fortune/gallery-4.jpg"),
        ]

        // google_map: "https://www.google.com/maps/embed?pb=..."
    },
    {
        id: "ssi-water-front",
        project_name: "SSI Water Front",
        category: "Flats",
        title: "SSI Water Front",
        location: "Hyderabad",
        image: require("../images/projects/Flats/SSI - Water Front/main.png"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "12 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "9 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "Stilt + 5" },
            { icon: "fas fa-home", title: "Units", value: "546 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,670–2,800 sq ft" },
            { icon: "fas fa-clock", title: "Possession", value: "Dec 2026" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02200006608" }
        ],

        description: "SSI Water Front offers elegant 3 & 4 BHK flats in Kompally, Hyderabad across a 12-acre lake-facing site. The gated community features expansive green spaces, a lavish clubhouse, rooftop amenities, and a focus on sustainable, serene living—just minutes from ORR and major city hotspots.",

        amenities: [
            { name: "Clubhouse", icon: "fas fa-building" },
            { name: "Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Indoor Games", icon: "fas fa-chess-board" },
            { name: "Yoga & Meditation Hall", icon: "fas fa-spa" },
            { name: "Banquet Hall", icon: "fas fa-glass-cheers" },
            { name: "Guest Rooms", icon: "fas fa-bed" },
            { name: "Co-Working Space", icon: "fas fa-briefcase" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Walking/Jogging Track", icon: "fas fa-walking" },
            { name: "24x7 Security", icon: "fas fa-shield-alt" },
            { name: "Power Backup", icon: "fas fa-bolt" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Structure",
                content: "RCC framed structure with solid block masonry, stilt + 5 floors."
            },
            {
                icon: "fas fa-window-restore",
                title: "Flats",
                content: "3 & 4 BHK spacious flats with premium finishes and balconies."
            },
            {
                icon: "fas fa-phone-alt",
                title: "Connectivity",
                content: "Close to ORR Exit 6, schools, hospitals, and Kompally’s key hubs."
            },
            {
                icon: "fas fa-wifi",
                title: "Tech & Safety",
                content: "CCTV surveillance, gated access, fire safety systems."
            },
            {
                icon: "fas fa-water",
                title: "Utilities",
                content: "Rainwater harvesting, solar power, backup generators."
            }
        ],

        gallery: [
            require("../images/projects/Flats/SSI - Water Front/gallery-1.png"),
            require("../images/projects/Flats/SSI - Water Front/gallery-2.png"),
            require("../images/projects/Flats/SSI - Water Front/gallery-3.png"),
            require("../images/projects/Flats/SSI - Water Front/gallery-4.png"),
        ]

        // google_map: "https://www.google.com/maps/embed?pb=..." (add if needed)
    },
    {
        id: "fortune-sonthalia-sky-villas",
        project_name: "Sri Fortune Sonthalia Sky Villas",
        category: "Flats",
        title: "Sri Fortune Sonthalia Sky Villas – 4 BHK Sky Villas in Kokapet",
        location: "Hyderabad",
        image: require("../images/projects/Flats/SSI - Fortune Sonthalia/main.png"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "5.17 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "4 Blocks" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+28 Floors" },
            { icon: "fas fa-home", title: "Units", value: "232 Sky Villas" },
            { icon: "fas fa-ruler-combined", title: "Size Range", value: "6,333–7,333 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Dec 2026" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400002503" }
        ],

        description: [
            "Luxury 4 BHK sky villas in Kokapet offering spacious homes (6,333–7,333 sq.ft.), double-height balconies, private lobbies, and panoramic views of Gandipet Lake & IT corridor."
        ],

        amenities: [
            { name: "45,000 sq.ft Clubhouse", icon: "fas fa-building" },
            { name: "Indoor + Terrace Pool", icon: "fas fa-swimmer" },
            { name: "Mini Theater", icon: "fas fa-film" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Conference Room", icon: "fas fa-users" },
            { name: "Crèche", icon: "fas fa-baby" },
            { name: "Library", icon: "fas fa-book" },
            { name: "Yoga Deck", icon: "fas fa-spa" },
            { name: "Central Water Feature", icon: "fas fa-water" },
            { name: "Driveway & Seating Spaces", icon: "fas fa-road" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Jogging Track", icon: "fas fa-running" },
            { name: "Amphitheater", icon: "fas fa-theater-masks" },
            { name: "Cricket Practice Net", icon: "fas fa-cricket" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Structure", content: "G+28 RCC-framed blocks with 60 ft inter-block spacing." },
            { icon: "fas fa-door-closed", title: "Sky Villas", content: "Single unit per floor with private lobby and double-height balconies." },
            { icon: "fas fa-building", title: "Clubhouse", content: "6‑level, 45,000 sq.ft clubhouse with indoor/outdoor pools, mini theatre, library & spa." },
            { icon: "fas fa-water", title: "Water Supply", content: "Dual source (GMC + borewell) and 20‑ft waterfall feature." },
            { icon: "fas fa-shield-alt", title: "Security", content: "Gated community w/ CCTV, intercom & 24/7 security." }
        ],

        gallery: [
            require("../images/projects/Flats/SSI - Fortune Sonthalia/gallery-1.png"),
            require("../images/projects/Flats/SSI - Fortune Sonthalia/gallery-2.png"),
            require("../images/projects/Flats/SSI - Fortune Sonthalia/gallery-3.png"),
            require("../images/projects/Flats/SSI - Fortune Sonthalia/gallery-4.png"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.395!3d17.398"
    },
    {
        id: "srr-river-view",
        project_name: "SRR Sriram River View",
        category: "Flats",
        title: "SRR Sriram River View",
        location: "Hyderabad",
        image: require("../images/projects/Flats/SSR-River view/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "13.2 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "10 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "Ground + 11 Floors" },
            { icon: "fas fa-home", title: "Units", value: "902 Apartments" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,885–3,225 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "May 2025 / Dec 2026" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400004185" }
        ],

        description: "A gated community in Narsingi offering 902 spacious 3 & 4 BHK apartments across 10 towers on 13.2 acres, with staggered corner balconies, 65% open space, Vastu design, and full power backup — slated for possession between 2025–26.",

        amenities: [
            { name: "Family Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Kids’ Pool", icon: "fas fa-child" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Yoga / Meditation Hall", icon: "fas fa-spa" },
            { name: "Library", icon: "fas fa-book" },
            { name: "Multipurpose Hall", icon: "fas fa-building" },
            { name: "Banquet Hall", icon: "fas fa-glass-cheers" },
            { name: "Amphitheatre & Party Lawn", icon: "fas fa-theater-masks" },
            { name: "Coffee Shop", icon: "fas fa-coffee" },
            { name: "Tennis Court", icon: "fas fa-table-tennis" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Cricket Nets", icon: "fas fa-cricket" },
            { name: "Jogging & Walking Tracks", icon: "fas fa-running" },
            { name: "Outdoor Seating Decks", icon: "fas fa-chair" },
            { name: "Clinic & Pharmacy Provision", icon: "fas fa-clinic-medical" },
            { name: "Salon / Spa Provision", icon: "fas fa-spa" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Super Structure",
                content: "RCC structure, resistant to wind and earthquakes (Zone 2)."
            },
            {
                icon: "fas fa-paint-roller",
                title: "Walls & Finishes",
                content: "Internal: 4” thick solid bricks; External: 9” thick solid bricks; textured & plastic emulsion paint with weatherproof coating."
            },
            {
                icon: "fas fa-door-closed",
                title: "Doors & Windows",
                content: "Main door: Teak frame with designer shutter; UPVC windows with mosquito mesh; internal doors with premium hardware."
            },
            {
                icon: "fas fa-fill-drip",
                title: "Flooring",
                content: "Anti-skid tiles in bathrooms and utility; vitrified tiles in living, bedrooms, kitchen, corridors; granite for staircases."
            },
            {
                icon: "fas fa-bath",
                title: "Bathrooms",
                content: "Premium sanitary fixtures and CP fittings; exhaust fans in all bathrooms; hot & cold mixer with shower in master bath."
            },
            {
                icon: "fas fa-utensils",
                title: "Kitchen",
                content: "Soft water & borewell connection; provisions for water purifier, chimney, microwave, and dishwasher."
            },
            {
                icon: "fas fa-snowflake",
                title: "Air Conditioning",
                content: "Split AC provision for all bedrooms and living; dedicated AC shaft."
            },
            {
                icon: "fas fa-plug",
                title: "Electrical",
                content: "Legrand/Havells/Schneider switches; concealed copper wiring; adequate plug points; power backup for each unit."
            },
            {
                icon: "fas fa-wifi",
                title: "Telecom & Internet",
                content: "Intercom to security; cable & broadband connections to living and bedrooms."
            },
            {
                icon: "fas fa-car-battery",
                title: "Generator",
                content: "100% DG backup for common areas; metered backup for individual units."
            },
            {
                icon: "fas fa-wheelchair",
                title: "Accessibility",
                content: "Ramps for differently abled residents at all towers and clubhouses."
            },
            {
                icon: "fas fa-recycle",
                title: "Water & Waste",
                content: "Rainwater harvesting; STP for flushing & landscaping; centralized softened water system."
            },
            {
                icon: "fas fa-shield-alt",
                title: "Security",
                content: "CCTV surveillance; boom barriers; panic buttons; video door phone; intercom connected to security room."
            },
            {
                icon: "fas fa-door-open",
                title: "Lift & Lobbies",
                content: "Lifts from reputed brands like Kone or Thyssenkrupp; granite cladding in lift lobbies."
            },
            {
                icon: "fas fa-fire-extinguisher",
                title: "Fire Safety",
                content: "Fire hydrants & sprinklers as per Fire Department norms; basement sprinkler system."
            },
            {
                icon: "fas fa-parking",
                title: "Parking",
                content: "3-level basement parking; well-planned driveways with signage to ease traffic."
            },
            {
                icon: "fas fa-tree",
                title: "Landscaping",
                content: "Setback areas with trees and softscaping per architect’s design."
            }
        ],

        gallery: [
            require("../images/projects/Flats/SSR-River view/gallery-1.jpg"),
            require("../images/projects/Flats/SSR-River view/gallery-2.jpg"),
            require("../images/projects/Flats/SSR-River view/gallery-3.jpg"),
            require("../images/projects/Flats/SSR-River view/gallery-4.jpg")
        ]

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.39"
    },
    {
        id: "sukhii-ubuntu",
        project_name: "Sukhii Ubuntu",
        category: "Flats",
        title: "Sukhii Ubuntu",
        location: "Hyderabad",
        image: require("../images/projects/Flats/sukhii ubuntu/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "5.25 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "3 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "36 Floors" },
            { icon: "fas fa-home", title: "Units", value: "855 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,315–2,230 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Nov 2026" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400003677" }
        ],

        description: "A LEED/IGBC Platinum-rated gated community in Puppalaguda offering 2, 3 & 4 BHK high-rise apartments with all-corner units, Vaastu-compliant layouts, and world-class amenities. Spread over 5.25 acres with 3 majestic towers and 2 clubhouses, Ubuntu redefines sustainable, future-ready living in Hyderabad’s Financial District.",

        amenities: [
            { name: "Temperature-Controlled Pools", icon: "fas fa-swimmer" },
            { name: "50,000 sq.ft. Clubhouses", icon: "fas fa-building" },
            { name: "Co-working Lounge", icon: "fas fa-briefcase" },
            { name: "Gym & Yoga Studio", icon: "fas fa-dumbbell" },
            { name: "Bowling Alley", icon: "fas fa-bowling-ball" },
            { name: "Indoor Games Room", icon: "fas fa-chess-board" },
            { name: "Squash & Badminton Courts", icon: "fas fa-table-tennis" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Open-Air Café & Library", icon: "fas fa-coffee" },
            { name: "A/C Guest Rooms", icon: "fas fa-bed" },
            { name: "Supermarket Space", icon: "fas fa-shopping-cart" }
        ],

        specifications: [
            {
                icon: "fas fa-leaf",
                title: "Sustainability",
                content: "IGBC/LEED Platinum-rated green building with rainwater harvesting, solar lighting, STP reuse, composting, and EV charger provision."
            },
            {
                icon: "fas fa-wind",
                title: "Design",
                content: "All-corner flats with cross ventilation, natural light, and Vaastu-compliant layouts — no shared walls."
            },
            {
                icon: "fas fa-cogs",
                title: "Technology & Safety",
                content: "Smart access, CCTV surveillance, panic alarms, fire safety systems, and BMS-powered security management."
            },
            {
                icon: "fas fa-water",
                title: "Water & Waste",
                content: "Water-efficient fixtures, centralized softened water plant, STP for reuse in landscaping and flushing."
            },
            {
                icon: "fas fa-plug",
                title: "Power",
                content: "Solar-lit common areas, power backup for flats and lifts, EV charging infrastructure."
            }
        ],

        gallery: [
            require("../images/projects/Flats/sukhii ubuntu/gallery-1.png"),
            require("../images/projects/Flats/sukhii ubuntu/gallery-2.png"),
            require("../images/projects/Flats/sukhii ubuntu/gallery-3.png"),
            require("../images/projects/Flats/sukhii ubuntu/gallery-4.png"),
        ]

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.37!3d17.41" (replace with actual if available)
    }
    ,
    {
        id: "srias-iwa",
        project_name: "SRIAS iWA",
        category: "Flats",
        title: "SRIAS iWA",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Srias iWA/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "6.5 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "6 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "Stilt + 40 Floors" },
            { icon: "fas fa-home", title: "Units", value: "909 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "2,290–4,710 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Dec 2028 Onwards" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400007210" }
        ],

        description: "SRIAS iWA offers Japanese-inspired luxury apartments in Puppalaguda with 3 to 4.5 BHK units, private lobbies, premium amenities, and excellent connectivity.",

        amenities: [
            { name: "Infinity Pool", icon: "fas fa-swimmer" },
            { name: "Lavish Clubhouse", icon: "fas fa-building" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Basketball, Tennis & Cricket Courts", icon: "fas fa-basketball-ball" },
            { name: "Indoor Games Rooms", icon: "fas fa-chess-board" },
            { name: "Banquet Hall & Conference Room", icon: "fas fa-glass-cheers" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Jogging & Cycling Tracks", icon: "fas fa-running" },
            { name: "Creche", icon: "fas fa-baby" },
            { name: "Cafe & Retail Spaces", icon: "fas fa-coffee" },
            { name: "24×7 Security & CCTV", icon: "fas fa-shield-alt" },
            { name: "Power Backup", icon: "fas fa-bolt" },
            { name: "STP & Rainwater Harvesting", icon: "fas fa-water" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Structure", content: "Stilt + 40-storey RCC shear-wall towers" },
            { icon: "fas fa-window-restore", title: "Design", content: "Private lift lobbies; 3.3m floor height" },
            { icon: "fas fa-th-large", title: "Flooring", content: "Vitrified in living, anti-skid in wet areas" },
            { icon: "fas fa-phone-alt", title: "Connectivity", content: "Internet, cable/telephone provision" },
            { icon: "fas fa-shield-alt", title: "Safety", content: "Gated entry, CCTV, intercoms" },
            { icon: "fas fa-water", title: "Utilities", content: "Softened water, STP, power backup" }
        ],

        gallery: [
            require("../images/projects/Flats/Srias iWA/gallery-1.jpg"),
            require("../images/projects/Flats/Srias iWA/gallery-2.jpg"),
            require("../images/projects/Flats/Srias iWA/gallery-3.jpg"),
            require("../images/projects/Flats/Srias iWA/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.39"
    },
    {
        id: "srias-tiara",
        project_name: "SRIAS Tiara",
        category: "Flats",
        title: "SRIAS Tiara",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Srias Tiara/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "9.59 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "4 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+18 Floors" },
            { icon: "fas fa-home", title: "Units", value: "1,338 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,290–2,035 sq.ft." },
            { icon: "fas fa-clock", title: "Launch", value: "Sep 2023" },
            { icon: "fas fa-clock", title: "Possession", value: "Mar 2028" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02200006939" }
        ],

        description: "A luxe gated community in Bachupally offering 2, 3 & 3.5 BHK apartments across 9.6 acres, with 60,000 sq.ft clubhouse, private views, natural light, and wellness‑centric amenities.",

        amenities: [
            { name: "60,000 sq.ft Clubhouse", icon: "fas fa-building" },
            { name: "Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Jogging/Walking Track", icon: "fas fa-running" },
            { name: "Cricket Net", icon: "fas fa-cricket" },
            { name: "Badminton Court", icon: "fas fa-shuttlecock" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Pet Park", icon: "fas fa-paw" },
            { name: "Open‑Air Theatre", icon: "fas fa-theater-masks" },
            { name: "Skating Rink", icon: "fas fa-skating" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Multipurpose Courts", icon: "fas fa-volleyball-ball" },
            { name: "Sky Lounge", icon: "fas fa-grin-stars" },
            { name: "EV Charging", icon: "fas fa-charging-station" },
            { name: "Rainwater Harvesting", icon: "fas fa-water" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Structure",
                content: "RCC shear‑wall / framed structure (Zone‑2)"
            },
            {
                icon: "fas fa-window-restore",
                title: "Floors",
                content: "Vitrified in dry areas; anti‑skid in wet zones"
            },
            {
                icon: "fas fa-door-closed",
                title: "Doors & Windows",
                content: "Teak main doors; UPVC with mosquito mesh"
            },
            {
                icon: "fas fa-charging-station",
                title: "Lifts & Power",
                content: "Passenger/service lifts; 100% DG backup"
            },
            {
                icon: "fas fa-shield-alt",
                title: "Security",
                content: "Gated entry, CCTV, intercoms"
            },
            {
                icon: "fas fa-water",
                title: "Water & STP",
                content: "Softened water, STP, rainwater harvesting"
            }
        ],

        gallery: [
            require("../images/projects/Flats/Srias Tiara/gallery-1.jpg"),
            require("../images/projects/Flats/Srias Tiara/gallery-2.jpg"),
            require("../images/projects/Flats/Srias Tiara/gallery-3.jpg"),
            require("../images/projects/Flats/Srias Tiara/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.39"
    },
    {
        "id": "luxurio-75-residences",
        "project_name": "Shree Kamala Estates - Luxurio 75",
        "category": "Flats",
        "title": "Shree Kamala Estates - Luxurio 75",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Shree Kamala Estates - Luxurio 75/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "1.08 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1 Tower" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Stilt + 10 Floors" },
            { "icon": "fas fa-home", "title": "Units", "value": "75 Apartments" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "2,040 – 4,070 sq ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2024" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400004106" }
        ],

        "description": "A gated luxury community in Kondapur offering premium 3 BHK apartments (2,040–4,070 sq ft) with world‑class amenities, gated security, and excellent connectivity.",

        "amenities": [
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Children's Play Area", "icon": "fas fa-child" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Badminton Court", "icon": "fas fa-shuttlecock" },
            { "name": "Jogging / Cycling Track", "icon": "fas fa-running" },
            { "name": "Community Kitchen", "icon": "fas fa-utensils" },
            { "name": "Guest Lounge", "icon": "fas fa-couch" },
            { "name": "Gazebo & Pergola", "icon": "fas fa-umbrella-beach" },
            { "name": "Petanque / Mini Golf", "icon": "fas fa-golf-ball" },
            { "name": "EV Charging", "icon": "fas fa-charging-station" },
            { "name": "Rainwater Harvesting", "icon": "fas fa-water" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power & Water Backup", "icon": "fas fa-bolt" }
        ],

        "specifications": [
            {
                "icon": "fas fa-border-style",
                "title": "Construction",
                "content": "RCC framed tower with 11 floors"
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Layouts",
                "content": "Spacious 3 BHK units with balconies and bar provisions"
            },
            {
                "icon": "fas fa-bolt",
                "title": "Utilities",
                "content": "100% power & water backup, sewage treatment"
            },
            {
                "icon": "fas fa-window-restore",
                "title": "Flooring",
                "content": "Vitrified tiles in living; anti-skid in wet areas"
            },
            {
                "icon": "fas fa-shield-alt",
                "title": "Security",
                "content": "Gated entry with CCTV and intercom"
            },
            {
                "icon": "fas fa-parking",
                "title": "Parking",
                "content": "Covered parking with EV charging"
            }
        ],

        "gallery": [
            require("../images/projects/Flats/Shree Kamala Estates - Luxurio 75/gallery-1.jpg"),
            require("../images/projects/Flats/Shree Kamala Estates - Luxurio 75/gallery-2.jpg"),
            require("../images/projects/Flats/Shree Kamala Estates - Luxurio 75/gallery-3.jpg"),
            require("../images/projects/Flats/Shree Kamala Estates - Luxurio 75/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.386!3d17.442"
    },
    {
        id: "sumadhura-horizon",
        project_name: "Sumadhura Horizon",
        category: "Flats",
        title: "Sumadhura Horizon",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Sumadhura Horizon/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "5.04 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "4 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "Stilt + 18 Floors" },
            { icon: "fas fa-home", title: "Units", value: "486 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,325–2,710 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Jun 2025" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400001051" }
        ],

        description: "A ready-to-move gated community at Kondapur spread across 5 acres, offering 2, 3 & 3.5 BHK luxury apartments (1,325–2,710 sq.ft.) with 72% open area, Vastu‑compliant layouts, high-end finishes, and global amenities.",

        amenities: [
            { name: "Clubhouse (4 floors)", icon: "fas fa-building" },
            { name: "Adults + Kids Pool", icon: "fas fa-swimmer" },
            { name: "Indoor Badminton & Squash Courts", icon: "fas fa-shuttlecock" },
            { name: "Table Tennis & Billiards", icon: "fas fa-chess-board" },
            { name: "Mini Theater & Library", icon: "fas fa-film" },
            { name: "Gym & Aerobics Studio", icon: "fas fa-dumbbell" },
            { name: "Crèche & Guest Suites", icon: "fas fa-baby" },
            { name: "Spa/Salon & Party Lawn", icon: "fas fa-glass-cheers" },
            { name: "Jogging Track & Outdoor Gym", icon: "fas fa-running" },
            { name: "Skating Rink & Kids Zone", icon: "fas fa-skating" },
            { name: "Pet Park & Floral Garden", icon: "fas fa-paw" },
            { name: "Open-Air Theatre & Multi‑Purpose Hall", icon: "fas fa-theater-masks" },
            { name: "Reflexology Path & Seating Plaza", icon: "fas fa-walking" },
            { name: "Surface & Basement Parking", icon: "fas fa-parking" },
            { name: "Safe Jog Paths & Water Bodies", icon: "fas fa-water" }
        ],

        specifications: [
            {
                icon: "fas fa-border-style",
                title: "Structure",
                content: "RCC framed shear-wall structure with seismic/wind resistance."
            },
            {
                icon: "fas fa-door-closed",
                title: "Doors & Windows",
                content: "Teak main doors, engineered-hardwood internal doors, UPVC windows with grills."
            },
            {
                icon: "fas fa-window-restore",
                title: "Flooring",
                content: "Vitrified tiles in living; anti-skid tiles in wet areas."
            },
            {
                icon: "fas fa-paint-roller",
                title: "Painting",
                content: "Premium emulsion paint inside; textured finish outside."
            },
            {
                icon: "fas fa-phone-alt",
                title: "Telecom/Cable",
                content: "Provision for internet, DTH, telephone, intercom."
            },
            {
                icon: "fas fa-charging-station",
                title: "Lifts & DG Backup",
                content: "High‑speed lifts with rescue device; 100% DG backup."
            },
            {
                icon: "fas fa-water",
                title: "Water & STP",
                content: "Treated water, STP for landscaping/flushing, rainwater harvesting."
            },
            {
                icon: "fas fa-shield-alt",
                title: "Security",
                content: "24×7 CCTV, intercom, gated entry, panic button in lifts."
            },
            {
                icon: "fas fa-fire-extinguisher",
                title: "Fire Safety",
                content: "Hydrants, sprinklers, PA system in all areas."
            },
            {
                icon: "fas fa-gas-pump",
                title: "LPG",
                content: "Centralized piped gas with prepaid meters."
            },
            {
                icon: "fas fa-parking",
                title: "Parking Management",
                content: "Covered parking, EV charging provision, signage."
            }
        ],

        gallery: [
            require("../images/projects/Flats/Sumadhura Horizon/gallery-1.jpg"),
            require("../images/projects/Flats/Sumadhura Horizon/gallery-2.jpg"),
            require("../images/projects/Flats/Sumadhura Horizon/gallery-3.jpg"),
            require("../images/projects/Flats/Sumadhura Horizon/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.386!3d17.442"
    },
    {
        "id": "sumadhura-palais-royale",
        "project_name": "Sumadhura Palais Royale",
        "category": "Flats",
        "title": "Sumadhura Palais Royale",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Sumadhura - Palais Royale/main.jpg"),
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "7.35 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "3 Towers" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+52 Floors" },
            { "icon": "fas fa-home", "title": "Units", "value": "523 Residences" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "3,800–6,610 sq.ft." },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2028 / Apr 2030" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400008107" }
        ],
        "description": "An ultra-luxury residential project in Puppalaguda with 4 & 5 BHK homes and a world-class 85,000 sq.ft. clubhouse.",
        "amenities": [
            { "name": "85,000 sq.ft Floating Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium & Yoga", "icon": "fas fa-dumbbell" },
            { "name": "Badminton & Indoor Games", "icon": "fas fa-chess-board" },
            { "name": "Bowling Zone", "icon": "fas fa-bowling-ball" },
            { "name": "Business Lounge & Conference Room", "icon": "fas fa-briefcase" },
            { "name": "Cricket Practice Net", "icon": "fas fa-baseball-ball" },
            { "name": "Table Tennis", "icon": "fas fa-table-tennis" },
            { "name": "Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Reflexology Path", "icon": "fas fa-shoe-prints" },
            { "name": "Indoor Theatre", "icon": "fas fa-film" },
            { "name": "Restaurant & Café", "icon": "fas fa-coffee" }
        ],
        "specifications": [
            { "icon": "fas fa-border-style", "title": "Structure", "content": "G+52 RCC shear-wall towers with seismic resistance" },
            { "icon": "fas fa-window-restore", "title": "Design", "content": "Biophilic design with copper-accent balconies and sky lounges" },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Rainwater harvesting and softener plant with 24x7 water supply" },
            { "icon": "fas fa-charging-station", "title": "Lifts & Power", "content": "High-speed lifts with 100% DG backup for all areas" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated community with 24/7 CCTV surveillance and intercom" },
            { "icon": "fas fa-wifi", "title": "Smart Tech", "content": "Home automation and high-speed internet connectivity" }
        ],
        "gallery": [
            require("../images/projects/Flats/Sumadhura - Palais Royale/gallery-1.jpg"),
            require("../images/projects/Flats/Sumadhura - Palais Royale/gallery-2.jpg"),
            require("../images/projects/Flats/Sumadhura - Palais Royale/gallery-3.jpg"),
            require("../images/projects/Flats/Sumadhura - Palais Royale/gallery-4.jpg"),
        ],
        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.39"
    },
    {
        id: "vajra-west-city",
        project_name: "Vajra West City",
        category: "Flats",
        title: "Vajra West City",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Vajra West City/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "13 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "6 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+39 Floors" },
            { icon: "fas fa-home", title: "Configurations", value: "2.5, 3 & 4 BHK" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,420–4,400 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Q2 2029" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P01100009793" }
        ],

        description: "A posh gated community at Osman Nagar with six 39-storey towers, rooftop infinity pool, sky‑deck lounge, step‑way clubhouse (~1.35 L sq.ft), EV charging, preschool & temple in premises.",

        amenities: [
            { name: "Step‑way Clubhouse (1.35 L sq.ft)", icon: "fas fa-building" },
            { name: "Rooftop Infinity Pool", icon: "fas fa-swimmer" },
            { name: "Sky‑deck Lounge", icon: "fas fa-mountain" },
            { name: "Indoor Games & Wellness Zones", icon: "fas fa-chess-board" },
            { name: "Temple", icon: "fas fa-hands-pray" },
            { name: "Pre‑school (till Grade 5)", icon: "fas fa-school" },
            { name: "Elder’s Day‑Care", icon: "fas fa-blind" },
            { name: "EV Charging Points", icon: "fas fa-charging-station" },
            { name: "Dedicated Co‑working Space", icon: "fas fa-briefcase" },
            { name: "Kids’ Pool & Play Area", icon: "fas fa-child" },
            { name: "Pickleball, Cricket & Half Basketball Courts", icon: "fas fa-basketball-ball" },
            { name: "Skating Area", icon: "fas fa-skating" },
            { name: "Open Gym & Jogging Tracks", icon: "fas fa-running" },
            { name: "Premium Sanitaryware (Kohler)", icon: "fas fa-toilet" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Structure", content: "RCC framed 39-storey towers with panoramic ORR views." },
            { icon: "fas fa-door-closed", title: "Entrance", content: "Elegant 8 ft main doors; 11 ft ceiling for 4 BHK units." },
            { icon: "fas fa-bolt", title: "Utilities", content: "100% power & treated water backup; EV-ready parking." },
            { icon: "fas fa-shield-alt", title: "Security", content: "Gated entry, CCTV, intercom." },
            { icon: "fas fa-phone-alt", title: "Connectivity", content: "Intercom, telephone, co‑working & market area onsite." }
        ],

        gallery: [
            require("../images/projects/Flats/Vajra West City/gallery-1.jpg"),
            require("../images/projects/Flats/Vajra West City/gallery-2.jpg"),
            require("../images/projects/Flats/Vajra West City/gallery-3.jpg"),
            require("../images/projects/Flats/Vajra West City/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.39"
    },
    {
        "id": "vamsiram-the-niche",
        "project_name": "Vamsiram The Niche",
        "category": "Flats",
        "title": "Vamsiram Homes - The Niche",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Vamsiram Homes - The Niche/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "2 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "1 Tower" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "3 Stilts + 10 Floors" },
            { "icon": "fas fa-home", "title": "Units", "value": "96 Units" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "3,666–3,942 sq.ft." },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2028" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02500006592" }
        ],

        "description": "Resort‑style gated 4 BHK community in Shaikpet with spacious 3,666–3,942 sq.ft homes, 60% open space, and premium amenities like club, pool, courts & jog paths. Price starts ~₹4.03 Cr.",

        "amenities": [
            { "name": "15,325 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym & Yoga Room", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games & Crèche", "icon": "fas fa-chess-board" },
            { "name": "Basketball & Badminton Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Jogging & Cycling Tracks", "icon": "fas fa-running" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "BBQ Pavilion & Elder’s Seat", "icon": "fas fa-tree" },
            { "name": "Visitor & Car Parking", "icon": "fas fa-parking" },
            { "name": "Spa", "icon": "fas fa-spa" },
            { "name": "Power Backup & STP", "icon": "fas fa-bolt" },
            { "name": "CCTV Security", "icon": "fas fa-shield-alt" }
        ],

        "specifications": [
            { "icon": "fas fa-border-style", "title": "Structure", "content": "RCC frame with seismic safety, 3-stilt parking + 10 floors" },
            { "icon": "fas fa-window-restore", "title": "Open Space", "content": "60% landscaped area with ventilation" },
            { "icon": "fas fa-door-closed", "title": "Flooring", "content": "Vitrified tiles throughout" },
            { "icon": "fas fa-charging-station", "title": "Utilities", "content": "100% power backup, STP & treated water" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry, CCTV & intercom" },
            { "icon": "fas fa-parking", "title": "Parking", "content": "Dedicated visitor & covered car parks" }
        ],

        "gallery": [
            require("../images/projects/Flats/Vamsiram Homes - The Niche/gallery-1.jpg"),
            require("../images/projects/Flats/Vamsiram Homes - The Niche/gallery-2.jpg"),
            require("../images/projects/Flats/Vamsiram Homes - The Niche/gallery-3.jpg"),
            require("../images/projects/Flats/Vamsiram Homes - The Niche/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.44"
    },
    {
        id: "vamsiram-westwood",
        project_name: "Vamsiram Westwood",
        category: "Flats",
        title: "Vamsiram Westwood",
        location: "Shaikpet, Hyderabad",
        image: require("../images/projects/Flats/Vamsiram Homes - Westwood/main.png"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "2 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "1 Tower" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G + 9 Floors" },
            { icon: "fas fa-home", title: "Units", value: "134 Residences" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "2,060–2,720 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Ongoing" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "NA" }
        ],

        description: "Vamsiram Westwood is an upscale 3 BHK residential community in Shaikpet, Hyderabad, offering 134 luxurious residences with superior ventilation, modern interiors, 60% open space, and world-class amenities like a yoga studio, gym, party hall, mini-plex, and more — all within a nature-blended, serene environment.",

        amenities: [
            { name: "Club House", icon: "fas fa-building" },
            { name: "Health Club", icon: "fas fa-heartbeat" },
            { name: "Gym & Yoga Studio", icon: "fas fa-dumbbell" },
            { name: "Indoor Games", icon: "fas fa-chess-board" },
            { name: "Crèche Provision", icon: "fas fa-baby" },
            { name: "Mini-Plex Provision", icon: "fas fa-film" },
            { name: "Party Hall", icon: "fas fa-glass-cheers" },
            { name: "Guest Rooms", icon: "fas fa-bed" },
            { name: "Unisex Parlour", icon: "fas fa-cut" },
            { name: "All-round Landscaping", icon: "fas fa-tree" },
            { name: "Barbeque Corner", icon: "fas fa-fire" },
            { name: "Elderly Sitting Area", icon: "fas fa-chair" },
            { name: "Walking Path", icon: "fas fa-walking" },
            { name: "Excellent Ventilation", icon: "fas fa-wind" },
            { name: "Toddler Play Area", icon: "fas fa-child" },
            { name: "Swings for Kids", icon: "fas fa-campground" }
        ],

        specifications: [
            {
                icon: "fas fa-building",
                title: "Structure",
                content: "RCC framed structure with clay/flyash bricks, designed to withstand seismic loads (Zone II)."
            },
            {
                icon: "fas fa-paint-roller",
                title: "Finishes",
                content: "Internal: Premium emulsion over luppum. External: Sand-faced cement plaster with exterior paint."
            },
            {
                icon: "fas fa-door-closed",
                title: "Doors & Windows",
                content: "Main door: Teakwood frame & shutter with melamine polish. Internal: Veneered flush doors with PU finish. Windows: UPVC with sliding shutters (Fenesta or equivalent)."
            },
            {
                icon: "fas fa-fill-drip",
                title: "Flooring",
                content: "Imported marble in living/dining; laminated wooden flooring in master bedroom; vitrified tiles in other rooms."
            },
            {
                icon: "fas fa-bath",
                title: "Bathrooms",
                content: "Duravit/Catalano wash basins, Grohe CP fittings, designer anti-skid tiles, wall-mounted WC with flush tank."
            },
            {
                icon: "fas fa-plug",
                title: "Electrical",
                content: "Concealed copper wiring, Daikin or equivalent ACs in all rooms, power backup for ACs/geysers."
            },
            {
                icon: "fas fa-wifi",
                title: "Technology",
                content: "Video door phone, intercom connectivity to security, cable & broadband provision in living & bedrooms."
            },
            {
                icon: "fas fa-charging-station",
                title: "Power Backup",
                content: "100% DG backup for all flats including ACs and geysers."
            },
            {
                icon: "fas fa-elevator",
                title: "Lifts",
                content: "Johnson/Kone/Schindler make elevators with 8 & 16 passenger capacity and granite cladding."
            },
            {
                icon: "fas fa-water",
                title: "Utilities",
                content: "Water treatment plant, sewage treatment plant, rainwater harvesting, pest control systems."
            }
        ],

        gallery: [
            require("../images/projects/Flats/Vamsiram Homes - Westwood/gallery-1.png"),
            require("../images/projects/Flats/Vamsiram Homes - Westwood/gallery-2.png"),
            require("../images/projects/Flats/Vamsiram Homes - Westwood/gallery-3.png"),
            require("../images/projects/Flats/Vamsiram Homes - Westwood/gallery-4.png"),
        ]

        // google_map: "https://www.google.com/maps/embed?pb=..." (add if available)
    },
    {
        id: "vamsiram-manhattan",
        project_name: "Vamsiram Builders - Manhattan",
        category: "Flats",
        title: "Vamsiram Builders - Manhattan",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Vamsiram Builders - Manhattan/main.png"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "14–15 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "8 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+47–50 Floors" },
            { icon: "fas fa-home", title: "Units", value: "978–1,100 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "5,039–15,210 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Mar 2029 / Feb 2029" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400006064" },
            { icon: "fas fa-rupee-sign", title: "Price Range", value: "₹6.5–19 Cr" }
        ],

        description: "An ultra‑luxury vertical township in Khajaguda with 8 towers, private foyers, sky‑deck lounges & multiple clubhouses, offering spacious 4–5 BHK homes (5,039–15,210 sq.ft) with world‑class amenities.",

        amenities: [
            { name: "200,000 sq.ft Clubhouse (25 indoor, 40 outdoor)", icon: "fas fa-building" },
            { name: "Infinity & Terrace Pools", icon: "fas fa-swimmer" },
            { name: "Fine‑Dining Restaurants & Café", icon: "fas fa-utensils" },
            { name: "Guest Suites & Cigar Lounge", icon: "fas fa-bed" },
            { name: "Lounge Areas & Library", icon: "fas fa-book" },
            { name: "Gym, Yoga & Wellness Studios", icon: "fas fa-dumbbell" },
            { name: "Indoor Sports (Squash, Badminton, Boxing, Bowling)", icon: "fas fa-bowling-ball" },
            { name: "Outdoor Courts & Skating Rink", icon: "fas fa-basketball-ball" },
            { name: "Pet Spa & Lounge", icon: "fas fa-paw" },
            { name: "Child Care & Kids’ Zones", icon: "fas fa-child" },
            { name: "Pet Care / Kennels", icon: "fas fa-dog" },
            { name: "Co‑Working Business Lounges", icon: "fas fa-briefcase" },
            { name: "Private Office Cabins", icon: "fas fa-building" },
            { name: "Concierge, Housekeeping, Drivers’ Bay", icon: "fas fa-concierge-bell" },
            { name: "EV‑ready Parking", icon: "fas fa-charging-station" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Structure", content: "RCC shear‑wall towers, G+47–50 floors" },
            { icon: "fas fa-window-restore", title: "Flooring", content: "Imported marble in living/dining; anti‑skid in wet areas" },
            { icon: "fas fa-door-closed", title: "Doors & Windows", content: "8 ft main doors; UPVC/aarum framing" },
            { icon: "fas fa-charging-station", title: "Lifts & Power", content: "High‑speed lifts with rescue; 100% DG backup" },
            { icon: "fas fa-shield-alt", title: "Security & Smart Tech", content: "24/7 CCTV, intercom, biometric access, smart home provision" },
            { icon: "fas fa-water", title: "Utilities", content: "Water softening, STP, rainwater harvesting" }
        ],

        gallery: [
            require("../images/projects/Flats/Vamsiram Builders - Manhattan/gallery-1.png"),
            require("../images/projects/Flats/Vamsiram Builders - Manhattan/gallery-2.png"),
            require("../images/projects/Flats/Vamsiram Builders - Manhattan/gallery-3.png"),
            require("../images/projects/Flats/Vamsiram Builders - Manhattan/gallery-4.png"),
        ],

        google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.3675!3d17.4217"
    },
    {
        id: "vamsiram-newmark",
        project_name: "Vamsiram Newmark",
        category: "Flats",
        title: "Vamsiram Newmark",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Vamsiram Builders - Newmark/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "3.9 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "2 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "35 Floors" },
            { icon: "fas fa-home", title: "Units", value: "272 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "5,200–6,500 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Nov 2028" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400007343" }
        ],

        description: "A premium gated enclave in Narsingi featuring just 272 private‐lift 4 BHK homes (5,200–6,500 sq.ft.), 80% landscaped open space, infinity pools, sky lounges, and a 50,000 sq.ft clubhouse.",

        amenities: [
            { name: "50,000 sq.ft Clubhouse + Lounges", icon: "fas fa-building" },
            { name: "Infinity & Cabana Pools", icon: "fas fa-swimmer" },
            { name: "Gym with Boxing Corner", icon: "fas fa-dumbbell" },
            { name: "Indoor Games & Mini‑Theatre", icon: "fas fa-chess-board" },
            { name: "Spa & Salon", icon: "fas fa-spa" },
            { name: "Party & Poolside Lounge", icon: "fas fa-cocktail" },
            { name: "Rooftop Terrace Lounge", icon: "fas fa-mountain" },
            { name: "Pet Lounge", icon: "fas fa-paw" },
            { name: "Kids’ Play Area & Crèche", icon: "fas fa-child" },
            { name: "Sports Courts", icon: "fas fa-basketball-ball" },
            { name: "On‑Call Services", icon: "fas fa-concierge-bell" },
            { name: "Private Lift Lobby in Every Home", icon: "fas fa-door-closed" },
            { name: "Terrace Stargazing Lounge", icon: "fas fa-star" },
            { name: "80% Open/Lush Landscaped Area", icon: "fas fa-tree" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Structure", content: "RCC shear‑wall towers for wind & seismic resistance" },
            { icon: "fas fa-door-closed", title: "Privacy", content: "Private‑lift lobby; ample spacing between homes" },
            { icon: "fas fa-window-restore", title: "Ceiling Height", content: "12 ft floor-to-floor height" },
            { icon: "fas fa-water", title: "Water & Power", content: "24×7 water & treated water backup; 100% DG backup" },
            { icon: "fas fa-shield-alt", title: "Security", content: "Gated entry, CCTV, intercom, fire sprinklers" },
            { icon: "fas fa-elevator", title: "Lifts", content: "High‑speed lifts with rescue & private entry" }
        ],

        gallery: [
            require("../images/projects/Flats/Vamsiram Builders - Newmark/gallery-1.png"),
            require("../images/projects/Flats/Vamsiram Builders - Newmark/gallery-2.png"),
            require("../images/projects/Flats/Vamsiram Builders - Newmark/gallery-3.png"),
            require("../images/projects/Flats/Vamsiram Builders - Newmark/gallery-4.png"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.39"
    },
    {
        id: "vasavi-atlantis",
        project_name: "Vasavi Atlantis",
        category: "Flats",
        title: "Vasavi Atlantis",
        location: "Hyderabad",
        image: require("../images/projects/Flats/Vasavi Atlantis/main.jpg"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "12.24 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "8 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G+45 Floors" },
            { icon: "fas fa-home", title: "Units", value: "2,199 Apartments + 85 Sky‑Villas" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,250–3,330 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "Dec 2025 Onwards" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02400003398" }
        ],

        description: "An upscale gated community near Financial District, with high-rise towers, 70% open space, sky‑villas, 2 clubhouses, and 50+ lifestyle & wellness amenities.",

        amenities: [
            { name: "2 Clubhouses", icon: "fas fa-building" },
            { name: "Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Indoor Games Room", icon: "fas fa-chess-board" },
            { name: "Open‑Air Theatre", icon: "fas fa-theater-masks" },
            { name: "Walking & Jogging Track", icon: "fas fa-running" },
            { name: "Cycling Track", icon: "fas fa-bicycle" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Cricket Net", icon: "fas fa-cricket" },
            { name: "Banquet Hall", icon: "fas fa-glass-cheers" },
            { name: "Business Centre & Conference Hall", icon: "fas fa-briefcase" },
            { name: "Spa & Salon", icon: "fas fa-spa" },
            { name: "Kids’ Play Area", icon: "fas fa-child" },
            { name: "Restaurant & Food Court", icon: "fas fa-utensils" },
            { name: "Party Lawns & Multipurpose Hall", icon: "fas fa-tree" },
            { name: "Pet-friendly zones", icon: "fas fa-paw" },
            { name: "Supermarket", icon: "fas fa-shopping-basket" }
        ],

        specifications: [
            { icon: "fas fa-border-style", title: "Structure", content: "RCC framed 8 towers, G+45 floors" },
            { icon: "fas fa-window-restore", title: "Open Space", content: "70% landscaped green area" },
            { icon: "fas fa-bolt", title: "Power & Water", content: "100% DG backup & treated water (STP)" },
            { icon: "fas fa-shield-alt", title: "Security", content: "24/7 gated entry, CCTV, intercom" },
            { icon: "fas fa-elevator", title: "Lifts", content: "High-speed passenger & service lifts" },
            { icon: "fas fa-fire-extinguisher", title: "Fire Safety", content: "Sprinklers, hydrants & PA system" },
            { icon: "fas fa-gas-pump", title: "Piped Gas", content: "LPG/PNG in all homes" },
            { icon: "fas fa-charging-station", title: "EV Parking", content: "EV charging provision in basements" },
            { icon: "fas fa-water", title: "Rainwater Harvesting", content: "Eco-friendly water management" }
        ],

        gallery: [
            require("../images/projects/Flats/Vasavi Atlantis/gallery-1.jpg"),
            require("../images/projects/Flats/Vasavi Atlantis/gallery-2.jpg"),
            require("../images/projects/Flats/Vasavi Atlantis/gallery-3.jpg"),
            require("../images/projects/Flats/Vasavi Atlantis/gallery-4.jpg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.397!3d17.391"
    },
    {
        "id": "vertex-33-west",
        "project_name": "Vertex 33 West",
        "category": "Flats",
        "title": "Vertex 33 West",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Vertex 33 West/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "40 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "–" },
            { "icon": "fas fa-home", "title": "Units", "value": "250 Ultra‑Luxury Flats" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Feb 2027" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400002807" }
        ],

        "description": "An ultra‑luxury gated apartment community in Nallagandla spanning 40 acres, with 250 bespoke residences, premium clubhouse, pools, courts & business lounge.",

        "amenities": [
            { "name": "Business Lounge", "icon": "fas fa-briefcase" },
            { "name": "Gym", "icon": "fas fa-dumbbell" },
            { "name": "Clinic", "icon": "fas fa-clinic-medical" },
            { "name": "Library", "icon": "fas fa-book" },
            { "name": "Yoga/Aerobic Room", "icon": "fas fa-spa" },
            { "name": "Preview Theatre", "icon": "fas fa-film" },
            { "name": "Squash Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Supermarket", "icon": "fas fa-shopping-basket" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Open Amphitheater", "icon": "fas fa-theater-masks" },
            { "name": "Party Lawn", "icon": "fas fa-tree" },
            { "name": "Multipurpose Court", "icon": "fas fa-basketball-ball" }
        ],

        "specifications": [
            { "icon": "fas fa-border-style", "title": "Structure", "content": "Contemporary RCC frame with high‑end finishes" },
            { "icon": "fas fa-water", "title": "Water", "content": "24×7 supply with backup" },
            { "icon": "fas fa-bolt", "title": "Power", "content": "100% DG backup for all units & common areas" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry with CCTV & patrol" },
            { "icon": "fas fa-tree", "title": "Landscape", "content": "Lush green spaces & walkways" }
        ],

        "gallery": [
            require("../images/projects/Flats/Vertex 33 West/gallery-1.png"),
            require("../images/projects/Flats/Vertex 33 West/gallery-2.png"),
            require("../images/projects/Flats/Vertex 33 West/gallery-3.png"),
            require("../images/projects/Flats/Vertex 33 West/gallery-4.png"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.42"
    },
    {
        id: "vertex-viraat",
        project_name: "Vertex Viraat",
        category: "Flats",
        title: "Vertex Viraat",
        location: "Miyapur, Hyderabad",
        image: require("../images/projects/Flats/Vertex Viraat/main.png"),

        project_overview: [
            { icon: "fas fa-vector-square", title: "Land Area", value: "3.72 Acres" },
            { icon: "fas fa-building", title: "Towers", value: "2 Towers" },
            { icon: "fas fa-layer-group", title: "Floors", value: "G + 12 Floors" },
            { icon: "fas fa-home", title: "Units", value: "265 Units" },
            { icon: "fas fa-ruler-combined", title: "Sizes", value: "1,670–2,420 sq.ft." },
            { icon: "fas fa-clock", title: "Possession", value: "2026" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P02200006607" }
        ],

        description: "Vertex Viraat is a premium residential community in Miyapur offering spacious 3 & 4 BHK apartments spread across 3.72 acres with 265 units. Featuring upscale amenities, ample green spaces, and a location near Metro and major IT hubs, it’s a perfect blend of convenience and elevated living.",

        amenities: [
            { name: "Clubhouse", icon: "fas fa-building" },
            { name: "Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Indoor Games", icon: "fas fa-chess-board" },
            { name: "Multipurpose Hall", icon: "fas fa-glass-cheers" },
            { name: "Co-working Lounge", icon: "fas fa-briefcase" },
            { name: "Children’s Play Area", icon: "fas fa-child" },
            { name: "Jogging Track", icon: "fas fa-running" },
            { name: "Yoga Deck", icon: "fas fa-spa" },
            { name: "Guest Rooms", icon: "fas fa-bed" },
            { name: "Supermarket Space", icon: "fas fa-shopping-cart" },
            { name: "Elderly Sitting Area", icon: "fas fa-chair" }
        ],

        specifications: [
            {
                icon: "fas fa-building",
                title: "Structure",
                content: "RCC framed structure with block masonry, earthquake-resistant (Zone II compliant)."
            },
            {
                icon: "fas fa-door-closed",
                title: "Doors & Windows",
                content: "Main door in teakwood frame and shutter with melamine polish; UPVC windows with mosquito mesh."
            },
            {
                icon: "fas fa-fill-drip",
                title: "Flooring",
                content: "Vitrified tiles in living, dining, bedrooms & kitchen; anti-skid tiles in bathrooms & balconies."
            },
            {
                icon: "fas fa-bath",
                title: "Bathrooms",
                content: "Branded sanitaryware with premium CP fittings; provision for geysers and exhaust fans."
            },
            {
                icon: "fas fa-plug",
                title: "Electrical",
                content: "Concealed copper wiring, power backup for flats, AC & geyser points in all bedrooms and bathrooms."
            },
            {
                icon: "fas fa-wifi",
                title: "Communication",
                content: "Intercom and broadband provision to living and all bedrooms; cable TV point in living room."
            },
            {
                icon: "fas fa-bolt",
                title: "Power Backup",
                content: "100% DG power backup for lifts, common areas, and apartments."
            },
            {
                icon: "fas fa-elevator",
                title: "Lifts",
                content: "High-speed automatic lifts with V3F for energy efficiency."
            },
            {
                icon: "fas fa-water",
                title: "Utilities",
                content: "Water softener, rainwater harvesting system, sewage treatment plant (STP)."
            }
        ],

        gallery: [
            require("../images/projects/Flats/Vertex Viraat/gallery-1.png"),
            require("../images/projects/Flats/Vertex Viraat/gallery-2.png"),
            require("../images/projects/Flats/Vertex Viraat/gallery-3.png"),
            require("../images/projects/Flats/Vertex Viraat/gallery-4.png"),
        ]

        // google_map: "https://www.google.com/maps/embed?pb=..." (add if needed)
    },
    {
        "id": "vision-arsha",
        "project_name": "Vision Arsha",
        "category": "Flats",
        "title": "Vision Arsha",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Vision Arsha/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "11 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "7 Towers" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "DS + 28 Floors" },
            { "icon": "fas fa-home", "title": "Units", "value": "1,561 Apartments" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "1,390–2,700 sq.ft." },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2025 (Phase 1), Dec 2026 (Phase 2)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100005595" }
        ],

        "description": "A gated, 28‑storey community in Tellapur on 100 ft road with 90+ amenities including a 45,000 sq.ft clubhouse, 10,000 sq.ft sports complex & 3.5‑acre central park.",

        "amenities": [
            { "name": "45,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Games & Sports Complex", "icon": "fas fa-chess-board" },
            { "name": "Jogging, Cycling, Skating Tracks", "icon": "fas fa-running" },
            { "name": "Kids’ Play & Bouncing Den", "icon": "fas fa-child" },
            { "name": "Amphitheatre & Mini Theatre", "icon": "fas fa-theater-masks" },
            { "name": "Rooftop Restaurant & Lounge", "icon": "fas fa-utensils" },
            { "name": "Temple & Meditation Zone", "icon": "fas fa-praying-hands" },
            { "name": "Spa & Salon", "icon": "fas fa-spa" },
            { "name": "Conference Room & Business Lounge", "icon": "fas fa-briefcase" },
            { "name": "Supermarket & ATM", "icon": "fas fa-shopping-basket" },
            { "name": "Pet-Friendly Zones", "icon": "fas fa-paw" },
            { "name": "EV Charging & 24×7 Security", "icon": "fas fa-charging-station" }
        ],

        "specifications": [
            { "icon": "fas fa-border-style", "title": "Structure", "content": "RCC frame, double-height stilt, Mivan technology" },
            { "icon": "fas fa-window-restore", "title": "Flooring", "content": "Vitrified tiles in living; anti-skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak veneer doors; UPVC windows with mesh" },
            { "icon": "fas fa-bolt", "title": "Power & Water", "content": "100% DG backup; 24×7 treated water supply" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry with CCTV, intercom & fire systems" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Sprinklers, hydrants & public address system" }
        ],

        "gallery": [
            require("../images/projects/Flats/Vision Arsha/gallery-1.png"),
            require("../images/projects/Flats/Vision Arsha/gallery-2.png"),
            require("../images/projects/Flats/Vision Arsha/gallery-3.png"),
            require("../images/projects/Flats/Vision Arsha/gallery-4.png"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.40!3d17.43"
    },
    {
        "id": "western-springs",
        "project_name": "Western Springs",
        "title": "Western Springs",
        "category": "Flats",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Western Springs/main.jpg"),
        "description": "Western Springs is a premium residential project located in Hyderabad, designed with modern amenities and world-class specifications, offering a luxurious lifestyle for discerning homebuyers.",
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Type", "value": "High-rise Gated Community" },
            { "icon": "fas fa-building", "title": "Towers", "value": "Multiple Towers" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+35" },
            { "icon": "fas fa-home", "title": "Flats", "value": "2 & 3 BHK" }
        ],
        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure",
                "content": "RCC framed structure with RCC shear walls, resistant to wind and seismic loads."
            },
            {
                "icon": "fas fa-paint-roller",
                "title": "Finishes",
                "content": "Smooth putty and acrylic emulsion; gypsum ceiling in drawing, dining, living, bedrooms, and kitchen."
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "Vitrified tiles in main areas, anti-skid tiles in balconies & bathrooms, natural stone for stairs."
            },
            {
                "icon": "fas fa-door-closed",
                "title": "Doors",
                "content": "Main: Teak wood frame with veneered flush shutter; Internal: Hardwood frame with flush shutters; Bathroom: Granite frame with laminate shutter."
            },
            {
                "icon": "fas fa-window-maximize",
                "title": "Windows",
                "content": "Aluminum/UPVC glazed sliding with mosquito mesh; laminated glass railing for balconies."
            },
            {
                "icon": "fas fa-bath",
                "title": "Bathrooms",
                "content": "Tiled walls, EWC with flush tank, single lever bath fittings, provision for geysers in all bathrooms."
            },
            {
                "icon": "fas fa-bolt",
                "title": "Electrical",
                "content": "Copper wiring, modular switches, MCBs, AC, geyser, chimney, and other provisions in utility."
            },
            {
                "icon": "fas fa-wind",
                "title": "Air-Conditioning",
                "content": "Copper piping and drainage outlets for all AC points."
            },
            {
                "icon": "fas fa-tv",
                "title": "TV / Telephone",
                "content": "TV, telephone, and internet points in living and master bedroom."
            },
            {
                "icon": "fas fa-tint",
                "title": "Waterproofing",
                "content": "Waterproofing in all bathrooms, balconies, utility, and terrace."
            },
            {
                "icon": "fas fa-shield-alt",
                "title": "Security / BMS",
                "content": "CCTV, intercom, panic button, RFID boom barrier, solar fencing, and compound security."
            },
            {
                "icon": "fas fa-fire-extinguisher",
                "title": "Fire Safety",
                "content": "Fire alarms, sprinklers, wet risers as per norms."
            },
            {
                "icon": "fas fa-charging-station",
                "title": "Power Backup",
                "content": "100% metered DG backup with acoustic enclosure."
            },
            {
                "icon": "fas fa-gas-pump",
                "title": "LPG / PNG",
                "content": "Piped gas supply to all kitchens."
            },
            {
                "icon": "fas fa-elevator",
                "title": "Lifts",
                "content": "High-speed elevators with granite lobbies and V3F for efficiency."
            },
            {
                "icon": "fas fa-water",
                "title": "WTP & STP",
                "content": "Bore-well water plant, STP, and hydro-pneumatic system for pressure."
            },
            {
                "icon": "fas fa-parking",
                "title": "Parking",
                "content": "Well-marked basement parking with signage and visitor space."
            },
            {
                "icon": "fas fa-file-invoice-dollar",
                "title": "Billing System",
                "content": "Automated billing for utilities with remote display in each unit."
            },
            {
                "icon": "fas fa-charging-station",
                "title": "EV Charging",
                "content": "EV point provision for every flat."
            }
        ],
        "amenities": [
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Clubhouse", "icon": "fas fa-home" },
            { "name": "Children's Play Area", "icon": "fas fa-child" },
            { "name": "Indoor Games", "icon": "fas fa-gamepad" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Multipurpose Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Yoga/Meditation Zone", "icon": "fas fa-spa" }
        ],
        "gallery": [
            require("../images/projects/Flats/Western Springs/gallery-1.jpg"),
            require("../images/projects/Flats/Western Springs/gallery-2.jpg"),
            require("../images/projects/Flats/Western Springs/gallery-3.jpg"),
            require("../images/projects/Flats/Western Springs/gallery-4.jpg"),
        ],
        // "google_map": "https://www.google.com/maps/embed?pb=YOUR_EMBED_LINK_HERE"
    },
    {
        "id": "western-marina",
        "project_name": "Western Marina",
        "title": "Western Marina",
        "category": "Flats",
        "location": "Hyderabad",
        "image": require("../images/projects/Flats/Western Marina/main.jpg"),
        "description": "Ultra‑luxury gated 4 BHK residences in Puppalguda, Nanakramguda over 7.76 acres, featuring 450 expansive units (5,475–10,910 sq.ft) with top-tier amenities and premium specifications.",

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "7.76 Acres" },
            { "icon": "fas fa-building", "title": "Towers", "value": "4 Towers" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+45 Floors" },
            { "icon": "fas fa-home", "title": "Units", "value": "450 4 BHK Flats" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "5,475–10,910 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2027" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400005389" }
        ],

        "amenities": [
            { "name": "5‑storey Clubhouse (~53,000 sq.ft)", "icon": "fas fa-building" },
            { "name": "Gym & Fitness Centre", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Games", "icon": "fas fa-chess-board" },
            { "name": "Theatre / Mini‑Theatre", "icon": "fas fa-film" },
            { "name": "Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Jogging & Walking Paths", "icon": "fas fa-running" },
            { "name": "Kids’ Play Area & Sandpit", "icon": "fas fa-child" },
            { "name": "Cricket Practice Net", "icon": "fas fa-cricket" },
            { "name": "Sky‑Walk & Water Features", "icon": "fas fa-water" },
            { "name": "Covered + Visitor Parking", "icon": "fas fa-parking" },
            { "name": "Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "STP & Rainwater Harvesting", "icon": "fas fa-water" },
            { "name": "EV Charging Points", "icon": "fas fa-charging-station" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC shear‑wall structure resistant to wind & seismic loads." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble/large‑format tile in living; vitrified in bedrooms; anti‑skid in wet areas." },
            { "icon": "fas fa-window-restore", "title": "Finishes", "content": "Gypsum boxing + putty + premium low‑VOC emulsion paint on walls & ceilings." },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "High‑quality doors; UPVC glazed windows with mosquito mesh." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, MCB, ample power & AC points." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Tiled walls, EWC flush tank, single lever fittings; geyser provisions." },
            { "icon": "fas fa-tv", "title": "TV/Telephone", "content": "Points in living & master bedroom; internet provision." },
            { "icon": "fas fa-tint", "title": "Waterproofing", "content": "In bathrooms, balconies, utility & terrace." },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24/7 CCTV, boom barrier, intercom, panic buttons, solar fencing." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Alarms, sprinklers, wet risers per norms." },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% metered DG backup." },
            { "icon": "fas fa-elevator", "title": "Lifts", "content": "High‑speed automatic lifts with V3F & rescue operations." },
            { "icon": "fas fa-gas-pump", "title": "LPG/PNG", "content": "Piped gas to kitchens." },
            { "icon": "fas fa-water", "title": "WTP & STP", "content": "Borewell water plant, sewage treatment, hydro‑pneumatic system." },
            { "icon": "fas fa-parking", "title": "Parking", "content": "Well‑designed covered basement & visitor parking with signage." },
            { "icon": "fas fa-file-invoice-dollar", "title": "Automated Billing", "content": "For utilities with in‑unit display." },
            { "icon": "fas fa-charging-station", "title": "EV Charging", "content": "Point provision in every flat." }
        ],

        "gallery": [
            require("../images/projects/Flats/Western Marina/gallery-1.jpg"),
            require("../images/projects/Flats/Western Marina/gallery-2.jpg"),
            require("../images/projects/Flats/Western Marina/gallery-3.jpg"),
            require("../images/projects/Flats/Western Marina/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.34872!3d17.410215"
    }
    ,
    // //// Jaggu /////////

    // Villas

    {
        "id": "casagrand-hanford",
        "project_name": "Casagrand Hanford",
        "title": "Casagrand Hanford",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Casagrand Hanford/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "10.1 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "140 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "2,800–2,804 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Sep 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400006229" },
            { "icon": "fas fa-rupee-sign", "title": "Price", "value": "₹2.9 Cr onwards" }
        ],

        "description": "A gated community of 140 British-styled 4 BHK villas with private home theatres and tree-lined lanes, backed by 60+ lifestyle amenities and a 15,000 sq.ft clubhouse within ORR.",

        "amenities": [
            { "name": "15,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Rooftop Swimming Pool + Kid’s Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym & Yoga Studio", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games & AV Room", "icon": "fas fa-chess-board" },
            { "name": "Amphitheatre & Party Lawn", "icon": "fas fa-theater-masks" },
            { "name": "Golf Lawn & BBQ Corner", "icon": "fas fa-golf-ball" },
            { "name": "Kids’ Play Area + Sandpit + Skating Rink", "icon": "fas fa-child" },
            { "name": "Rock Climbing Wall", "icon": "fas fa-mountain" },
            { "name": "Jogging Track & Exercise Plaza", "icon": "fas fa-running" },
            { "name": "Creche & Daycare", "icon": "fas fa-baby" },
            { "name": "Café & Convenience Store", "icon": "fas fa-utensils" },
            { "name": "Pet Zone", "icon": "fas fa-paw" },
            { "name": "Indoor & Outdoor Sports Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Visitor Parking", "icon": "fas fa-parking" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC frame & shear walls; G+2 villa design." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Italian marble living/dining; anti‑skid/bath; natural stone stairs." },
            { "icon": "fas fa-window-maximize", "title": "Windows & Cladding", "content": "Brick facade, French-glass windows, glass railings." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Teak/laminate flush shutters with designer architraves & digital locks." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, ample AC & appliance points." },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup with acoustic enclosures." },
            { "icon": "fas fa-water", "title": "Water", "content": "Treated/harvested water and STP." },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry, CCTV, intercom, panic buttons." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Alarms, sprinklers & wet risers." },
            { "icon": "fas fa-tv", "title": "TV/Internet", "content": "Provision in living/master bedrooms." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium fittings, rain showers, geyser points." },
            { "icon": "fas fa-file-invoice-dollar", "title": "Billing & EV", "content": "Automated billing; EV charging provision." }
        ],

        "gallery": [
            require("../images/projects/Villas/Casagrand Hanford/gallery-1.jpg"),
            require("../images/projects/Villas/Casagrand Hanford/gallery-2.jpg"),
            require("../images/projects/Villas/Casagrand Hanford/gallery-3.jpg"),
            require("../images/projects/Villas/Casagrand Hanford/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.4505!3d17.2694"
    }
    ,
    {
        "id": "dukes-aika",
        "project_name": "Dukes Aika",
        "title": "Dukes Aika",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/dukes aika/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "37 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "147 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "8,220–8,432 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Jun 2030" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400008538" },
            { "icon": "fas fa-rupee-sign", "title": "Price", "value": "₹19.7–21 Cr" }
        ],

        "description": "A premier gated villa community at Gandipet featuring ultra‑luxury 5 BHK villas (8,220–8,432 sq.ft), over 100 curated amenities, top‑tier security, and sustainable infrastructure.",

        "amenities": [
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Community Hall", "icon": "fas fa-building" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "Badminton Court", "icon": "fas fa-shuttlecock" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "CCTV & Security", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "Rainwater Harvesting", "icon": "fas fa-water" },
            { "name": "Sewage Treatment Plant", "icon": "fas fa-tint" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed, designed to resist wind & seismic loads." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified/marble in main areas; anti‑skid in wet zones." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "High-quality glazed windows with mosquito mesh." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Premium flush shutters with durable hardware." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Tiled walls, EWC flush tank, geyser provision." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, MCB." },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "24×7 surveillance, intercom, boom barrier." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire alarms, sprinklers, PA system." },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup in acoustic enclosures." },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Rainwater harvesting, STP & borewell supply." }
        ],

        "gallery": [
            require("../images/projects/Villas/dukes aika/gallery-1.jpg"),
            require("../images/projects/Villas/dukes aika/gallery-2.jpg"),
            require("../images/projects/Villas/dukes aika/gallery-3.jpg"),
            require("../images/projects/Villas/dukes aika/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.42!3d17.365"
    }
    ,
    {
        "id": "elegans-emperia",
        "project_name": "Elegans Emperia Homes",
        "title": "Elegans Emperia Homes",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Elegans Emperia Homes/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "10.44 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "123 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Flats", "value": "3, 4 & 5 BHK Villas" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "2,925–4,025 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Oct 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100002447" },
            { "icon": "fas fa-rupee-sign", "title": "Price", "value": "₹3.43–5.23 Cr" }
        ],

        "description": "A gated villa community in Velimela spanning 10.44 acres, offering 3‑5 BHK villas (2,925–4,025 sq.ft), premium amenities, treated water, STP, indoor games and sports courts.",

        "amenities": [
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Badminton Court", "icon": "fas fa-shuttlecock" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Indoor Games Room", "icon": "fas fa-chess-board" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Clubhouse / Community Hall", "icon": "fas fa-building" },
            { "name": "Storm Water Drains", "icon": "fas fa-water" },
            { "name": "Sewage Treatment Plant", "icon": "fas fa-tint" },
            { "name": "Closed Car Parking", "icon": "fas fa-parking" },
            { "name": "24×7 Water Supply", "icon": "fas fa-water" },
            { "name": "Multipurpose Hall", "icon": "fas fa-glass-cheers" }
        ],

        "specifications": [
            { "icon": "fas fa-border-style", "title": "Structure", "content": "RCC framed villas designed with G+2 floors" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified/marble in living; anti‑skid in wet areas" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Premium flush doors; glazed UPVC/French windows with mesh" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Tiled walls, EWC, geyser points, premium fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, MCBs" },
            { "icon": "fas fa-tv", "title": "TV/Internet", "content": "Provision in living and master bedroom" },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Treated water supply, STP & rainwater harvesting" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry, CCTV, intercom, emergency systems" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire alarms, sprinklers, compliance with fire norms" },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "100% DG backup for common areas" }
        ],

        "gallery": [
            require("../images/projects/Villas/Elegans Emperia Homes/gallery-1.jpg"),
            require("../images/projects/Villas/Elegans Emperia Homes/gallery-2.jpg"),
            require("../images/projects/Villas/Elegans Emperia Homes/gallery-3.jpg"),
            require("../images/projects/Villas/Elegans Emperia Homes/gallery-4.jpg"),
        ],

        //   "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.398!3d17.382"
    }
    ,
    {
        "id": "elegans-sreyan",
        "project_name": "Elegans Sreyan",
        "title": "Elegans Sreyan",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Elegans Sreyan/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "9 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "82 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "4,586–4,675 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Sep 2029" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02200007108" },
            { "icon": "fas fa-rupee-sign", "title": "Price", "value": "₹5.49–5.60 Cr" }
        ],

        "description": "A gated community of 82 premium 4 BHK villas on 9 acres in Gundlapochampally, with a 20,000 sq.ft clubhouse, sports courts, pool, and top‑tier civic conveniences.",

        "amenities": [
            { "name": "20,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gym", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games", "icon": "fas fa-chess-board" },
            { "name": "Banquet / Conference Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Aerobics / Yoga Hall", "icon": "fas fa-spa" },
            { "name": "Indoor Badminton Court", "icon": "fas fa-shuttlecock" },
            { "name": "Volleyball / Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Sewage Treatment Plant", "icon": "fas fa-tint" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with shear walls; IS‑code compliance" },
            { "icon": "fas fa-floor-plan", "title": "Flooring", "content": "Imported marble in living; vitrified/wood in bedrooms; anti‑skid in wet areas" },
            { "icon": "fas fa-window-maximize", "title": "Doors & Windows", "content": "Teak main door; engineered flush internal; aluminum windows; veneer shutters" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium tile cladding, Grohe fittings, geyser provisions" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; MCBs; ample AC & appliance points; 3‑phase supply" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire alarms, sprinklers, wet risers per norms" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Solar fencing, boom barrier, CCTV, intercom, panic buttons" },
            { "icon": "fas fa-bolt", "title": "Power Backup", "content": "100% DG backup with acoustic enclosures" },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Softened & treated water, borewell & STP reuse for landscaping" },
            { "icon": "fas fa-tv", "title": "Communication", "content": "EPABX, telephone & internet points in living & bedrooms" }
        ],

        "gallery": [
            require("../images/projects/Villas/Elegans Sreyan/gallery-1.jpg"),
            require("../images/projects/Villas/Elegans Sreyan/gallery-2.jpg"),
            require("../images/projects/Villas/Elegans Sreyan/gallery-3.jpg"),
            require("../images/projects/Villas/Elegans Sreyan/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.513!3d17.501"
    }
    ,
    {
        "id": "eipl-la-paloma",
        "project_name": "EIPL La Paloma",
        "title": "EIPL La Paloma Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/EIPL La'Paloma Villas/main.jpg"),
        "description": "An ultra‑luxury gated enclave of 212 ready‑to‑move 3 BHK duplex villas across 33 acres, offering premium amenities, sports facilities, and stellar connectivity along Shankarpalli Road.",

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "33 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "212 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Duplex (G+1)" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "3,890–3,910 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Jun 2020 (Ready)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400000895" },
            { "icon": "fas fa-rupee-sign", "title": "Price", "value": "₹4.08–5.33 Cr" }
        ],

        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games", "icon": "fas fa-chess-board" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Badminton Court", "icon": "fas fa-shuttlecock" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Volley & Cricket Nets", "icon": "fas fa-cricket" },
            { "name": "Jogging Track", "icon": "fas fa-running" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "Library & Multi‑Hall", "icon": "fas fa-book" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-tint" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "EV Charging", "icon": "fas fa-charging-station" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with shear walls; wind and seismic resistant" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified in dry areas; premium tiles in wet zones; Italian marble on stairs" },
            { "icon": "fas fa-paint-roller", "title": "Walls", "content": "Acrylic emulsion inside; texture paint outside" },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak/aluminum frames, glazed French windows with mesh" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Tiled walls/floors, EWC flush tank, geyser points, Grohe fittings" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, MCB, AC/utility provisions" },
            { "icon": "fas fa-window-maximize", "title": "Ventilation", "content": "Natural cross‑ventilation via large openings" },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry, boom barrier, CCTV, intercom, panic buttons" },
            { "icon": "fas fa-water", "title": "Water", "content": "Borewell supply, treated water, rainwater harvesting, STP" },
            { "icon": "fas fa-charging-station", "title": "Backup & EV", "content": "100 % DG power & EV charging provision" },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Alarms, sprinklers & dry risers per norms" }
        ],

        "gallery": [
            require("../images/projects/Villas/EIPL La'Paloma Villas/gallery-1.jpg"),
            require("../images/projects/Villas/EIPL La'Paloma Villas/gallery-2.jpg"),
            require("../images/projects/Villas/EIPL La'Paloma Villas/gallery-3.jpg"),
            require("../images/projects/Villas/EIPL La'Paloma Villas/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.410!3d17.257"
    }
    ,
    {
        "id": "greenmark-mayfair-sunrise",
        "project_name": "Greenmark Mayfair Sunrise",
        "title": "Greenmark Mayfair Sunrise",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Greenmark Mayfair Sunrise/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "63 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "558 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Configurations", "value": "4 & 5 BHK Villas" },
            { "icon": "fas fa-ruler-combined", "title": "Sizes", "value": "3,888–6,111 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2026 (ongoing)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100005727" },
            { "icon": "fas fa-rupee-sign", "title": "Price", "value": "₹4.08–6.41 Cr" }
        ],

        "description": "A gated villa community spread over 63 acres in Kollur with 558 Vastu‑compliant 4 & 5 BHK villas, world‑class clubhouse, sports courts, green spaces & eco‑friendly features.",

        "amenities": [
            { "name": "100,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool + Jacuzzi", "icon": "fas fa-swimmer" },
            { "name": "Gym & Yoga", "icon": "fas fa-dumbbell" },
            { "name": "3 Indoor Badminton Courts", "icon": "fas fa-shuttlecock" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Box Cricket / Football Zone", "icon": "fas fa-cricket" },
            { "name": "Gazebos & Rachabandas", "icon": "fas fa-umbrella-beach" },
            { "name": "Jogging Track (5.5 km)", "icon": "fas fa-running" },
            { "name": "Amphitheatre & Party Lawn (38,000 sq.ft)", "icon": "fas fa-theater-masks" },
            { "name": "Café & Creche", "icon": "fas fa-utensils" },
            { "name": "EV Charging Points", "icon": "fas fa-charging-station" },
            { "name": "Solar Panels & Heat Pumps", "icon": "fas fa-solar-panel" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-tint" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Covered Guest Parking", "icon": "fas fa-parking" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC frame with shear walls; wind & seismic resistant." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified/marble in main areas; anti‑skid in wet zones." },
            { "icon": "fas fa-paint-roller", "title": "Finishes", "content": "Acrylic emulsion interiors; textured exteriors." },
            { "icon": "fas fa-door-closed", "title": "Doors & Windows", "content": "Teak internal/frame, glazed French windows with mesh." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Tiled walls, EWC flush tank, geyser & Grohe fittings." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, MCB; ample power & AC points." },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Borewell + treated water, STP, rainwater harvesting." },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "Gated entry, CCTV, intercom, boom barriers & panic buttons." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Alarms, sprinklers, wet risers as per norms." },
            { "icon": "fas fa-charging-station", "title": "Power & EV", "content": "100% DG backup plus EV charging provision." },
            { "icon": "fas fa-tint", "title": "Eco Tech", "content": "Solar panels, heat pumps & Vastu-compliant design." }
        ],

        "gallery": [
            require("../images/projects/Villas/Greenmark Mayfair Sunrise/gallery-1.jpg"),
            require("../images/projects/Villas/Greenmark Mayfair Sunrise/gallery-2.jpg"),
            require("../images/projects/Villas/Greenmark Mayfair Sunrise/gallery-3.jpg"),
            require("../images/projects/Villas/Greenmark Mayfair Sunrise/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.41!3d17.26"
    }
    ,
    {
        "id": "honer-richmont",
        "project_name": "Honer Richmont",
        "title": "Honer Richmont",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Honor Richmont/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "28.4 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "142 Mansions" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "475–950 sq.yds" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "6,787–10,287 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400004513" }
        ],

        "description": "A gated enclave of 142 designer 5 BHK mansions on 28.4 acres at Green Hills Road, near HITEC City, featuring double-height living rooms, private theatres, luxe clubhouse, elevators & central park.",

        "amenities": [
            { "name": "50,000 sq.ft Luxe Club", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Jacuzzi", "icon": "fas fa-swimmer" },
            { "name": "Gym, Steam & Sauna", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Fitness", "icon": "fas fa-running" },
            { "name": "Banquet & Party Lawns", "icon": "fas fa-glass-cheers" },
            { "name": "Squash, Tennis & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Practice Pitch", "icon": "fas fa-cricket" },
            { "name": "Skating Rink & Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Maze & Water Gardens", "icon": "fas fa-tree" },
            { "name": "Private Theatre", "icon": "fas fa-film" },
            { "name": "Spa, Salon & Reflexology", "icon": "fas fa-spa" },
            { "name": "Creche", "icon": "fas fa-baby" },
            { "name": "Open Cafeteria", "icon": "fas fa-coffee" },
            { "name": "Jogging Track & Youth Plaza", "icon": "fas fa-running" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & EV Charging", "icon": "fas fa-bolt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with shear walls; premium G+2 design." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Italian marble‑vitrified in living; anti‑skid in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "9 ft main entrance; 8 ft internal flush doors." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Glazed aluminium windows with mesh; double‑height living." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium fittings, tiled walls, geyser points." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; MCB; AC points." },
            { "icon": "fas fa-elevator", "title": "Elevators", "content": "6‑person capacity elevator in every mansion." },
            { "icon": "fas fa-tv", "title": "Home Theatre", "content": "Private mini‑theatre provided in each mansion." },
            { "icon": "fas fa-water", "title": "Water", "content": "Borewell + treated water, STP, rain harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire alarms, sprinklers & wet risers." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup & EV charging ready." }
        ],

        "gallery": [
            require("../images/projects/Villas/Honor Richmont/gallery-1.jpg"),
            require("../images/projects/Villas/Honor Richmont/gallery-2.jpg"),
            require("../images/projects/Villas/Honor Richmont/gallery-3.jpg"),
            require("../images/projects/Villas/Honor Richmont/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.433!3d17.486"
    }
    ,
    {
        "id": "hallmark-5a",
        "project_name": "Hallmark 5A",
        "title": "Hallmark 5A Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Hallmark 5A/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "5.35 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "Luxury Triplex Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "185–343 sq.yds" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "2,410–4,305 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "2026 (Expected)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100004115" }
        ],

        "description": "Hallmark 5A is a premium gated community of G+2 ultra-luxury triplex villas in Hyderabad. Located near Kollur and Tellapur, this boutique development offers elegant architecture, expansive layouts, a modern clubhouse, and all premium amenities for high-end living.",

        "amenities": [
            { "name": "Grand Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Multipurpose Hall", "icon": "fas fa-chess-board" },
            { "name": "Indoor Games Room", "icon": "fas fa-gamepad" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Yoga & Meditation Hall", "icon": "fas fa-spa" },
            { "name": "Guest Room", "icon": "fas fa-bed" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Reception & Lounge", "icon": "fas fa-couch" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "Water Treatment & STP", "icon": "fas fa-water" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with brick masonry and seismic compliance." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in all rooms, anti-skid tiles in bathrooms." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Engineered wooden doors with designer finishes." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "UPVC windows with mosquito mesh and safety grills." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings with wall-mounted commodes and geyser provision." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with modular switches; 3-phase power." },
            { "icon": "fas fa-elevator", "title": "Elevators", "content": "Provision for home lift (optional)." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Borewell with water purification and STP for reuse." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Fire-resistant materials, alarms, and extinguishers." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup for common areas; EV charging provision." }
        ],

        "gallery": [
            require("../images/projects/Villas/Hallmark 5A/gallery-1.jpg"),
            require("../images/projects/Villas/Hallmark 5A/gallery-2.jpg"),
            require("../images/projects/Villas/Hallmark 5A/gallery-3.jpg"),
            require("../images/projects/Villas/Hallmark 5A/gallery-4.jpg"),
        ]

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.33!3d17.45"
    }
    ,
    {
        "id": "hallmark-nature-nest",
        "project_name": "Hallmark Nature Nest",
        "title": "Hallmark Nature Nest Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Hallmark Nature Nest/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "45 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "447 Triplex Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Unit Sizes", "value": "2745–6435 sq.ft" },
            { "icon": "fas fa-ruler-combined", "title": "Configurations", "value": "3 & 4 BHK" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Mar 2028 (Expected)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100008243" }
        ],

        "description": "A gated enclave of 447 ultra‑luxury G+2 triplex villas set amidst 45 acres of verdant landscape in Kollur, Hyderabad. Offering 3 & 4 BHK layouts from 2745–6435 sq.ft, this development features a multi‑level 50,000 sq.ft clubhouse, modern amenities, and strategic connectivity to ORR and the Financial District.",

        "amenities": [
            { "name": "50,000 sq.ft Multi‑level Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Tennis & Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Practice Net", "icon": "fas fa-cricket" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Badminton Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Landscaped Gardens & Parking", "icon": "fas fa-tree" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with shear walls; seismic compliance." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium vitrified in living/bedrooms, anti‑skid in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Engineered/wooden main & internal doors, designer finishes." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium/glazed with mesh; glass railings on terraces." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings (Delta/Duravit); acid‑resistant tiles." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; MCB; AC & geyser points." },
            { "icon": "fas fa-elevator", "title": "Elevators", "content": "High‑speed lift provision." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Borewell + treated water; STP & rain harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Alarms, sprinklers, extinguishers & risers." },
            { "icon": "fas fa-charging-station", "title": "Power & EV", "content": "100% DG backup; EV charging infrastructure." },
            { "icon": "fas fa-shield-alt", "title": "Security & BMS", "content": "Biometric access, CCTV, gated security with boom barriers." },
            { "icon": "fas fa-wi-fi", "title": "Connectivity", "content": "Intercom, DTH/Cable & wired internet provision." }
        ],

        "gallery": [
            require("../images/projects/Villas/Hallmark Nature Nest/gallery-1.jpg"),
            require("../images/projects/Villas/Hallmark Nature Nest/gallery-2.jpg"),
            require("../images/projects/Villas/Hallmark Nature Nest/gallery-3.jpg"),
            require("../images/projects/Villas/Hallmark Nature Nest/gallery-4.jpg"),
        ]

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d...Kollur+Hyderabad"
    }
    ,
    {
        "id": "hallmark-floresta",
        "project_name": "Hallmark Floresta",
        "title": "Hallmark Floresta Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Hallmark Nature Floresta/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "13.46 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "166 Triplex Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Unit Sizes", "value": "2,705–4,605 sq.ft" },
            { "icon": "fas fa-ruler-combined", "title": "Configurations", "value": "3 & 4 BHK" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Oct 2026" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100007551" }
        ],

        "description": "Hallmark Floresta is a gated enclave of ultra‑luxury G+2 triplex villas in Patighanpur, Hyderabad. Spread over 13.46 acres, it offers spacious 3 & 4 BHK homes (2,705–4,605 sq.ft), a 22,820 sq.ft multi-level clubhouse, and high-end amenities, while being surrounded by lush ICRISAT greens and close to ORR, IT & Financial hubs.",

        "amenities": [
            { "name": "22,820 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Games", "icon": "fas fa-gamepad" },
            { "name": "Cricket & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Jogging & Cycle Track", "icon": "fas fa-running" },
            { "name": "Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & Water Supply", "icon": "fas fa-bolt" },
            { "name": "Yoga & Meditation Zones", "icon": "fas fa-spa" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with 8\" external & 4\" internal block walls; seismic resistant." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium vitrified tiles in living/bedrooms; anti‑skid in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Engineered/wooden main doors; designer internal shutters." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium glazed windows & French doors with mosquito mesh." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Hansgrohe/V&B/Legrand fittings; acid‑resistant wall tiles." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; MCBs; AC points." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 treated water, borewell, STP & rain harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Fire Safety", "content": "Alarms, sprinklers, wet risers in communal spaces." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100% DG backup; EV charging provision in common area." },
            { "icon": "fas fa-shield-alt", "title": "Security & BMS", "content": "Biometric access, CCTV, gated entry with boom barriers." }
        ],

        "gallery": [
            require("../images/projects/Villas/Hallmark Nature Floresta/gallery-1.jpg"),
            require("../images/projects/Villas/Hallmark Nature Floresta/gallery-2.jpg"),
            require("../images/projects/Villas/Hallmark Nature Floresta/gallery-3.jpg"),
            require("../images/projects/Villas/Hallmark Nature Floresta/gallery-4.jpg"),
        ]

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14! … Patighanpur, Hyderabad"
    }
    ,
    {
        "id": "kgr-anandam-villas",
        "project_name": "KGR Anandam Villas",
        "title": "KGR Fortune Anandam Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/KGR Anandam Villas/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "—" },
            { "icon": "fas fa-home", "title": "Units", "value": "Vaastu-Compliant Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+1 Triplex Villas" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "—" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "—" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Ongoing" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "—" }
        ],

        "description": "KGR Fortune Anandam Villas is a premium gated community project located in Sardarnagar, Thukkguda – Hyderabad. It offers thoughtfully planned Vaastu-compliant triplex villas with spacious design, modern construction, and serene green surroundings — ideal for peaceful living near the city’s growth corridors.",

        "amenities": [
            { "name": "Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Table Tennis", "icon": "fas fa-table-tennis" },
            { "name": "Shuttle Court", "icon": "fas fa-bolt" },
            { "name": "Gazebos", "icon": "fas fa-umbrella-beach" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Maintenance Office", "icon": "fas fa-tools" },
            { "name": "Sand Pit", "icon": "fas fa-mountain" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Interactive Seating Zone", "icon": "fas fa-couch" },
            { "name": "Pet Area", "icon": "fas fa-dog" },
            { "name": "Creche", "icon": "fas fa-baby" },
            { "name": "Guest Lounge", "icon": "fas fa-chair" },
            { "name": "Banquet Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Kids Activity Zone", "icon": "fas fa-chess" },
            { "name": "Children Waiting Bay / Amphitheater", "icon": "fas fa-theater-masks" },
            { "name": "Outdoor Seating Lounge", "icon": "fas fa-chair" },
            { "name": "Indoor Games", "icon": "fas fa-dice" },
            { "name": "CCTV Surveillance", "icon": "fas fa-video" },
            { "name": "Congregation Area", "icon": "fas fa-users" },
            { "name": "Reception & Waiting Lounge", "icon": "fas fa-concierge-bell" },
            { "name": "Common Wi-Fi Zones", "icon": "fas fa-wifi" },
            { "name": "Adult Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Beautifully Planned Landscapes", "icon": "fas fa-tree" },
            { "name": "State-of-the-art Clubhouse With Modern Facilities", "icon": "fas fa-building" },
            { "name": "SPA", "icon": "fas fa-spa" },
            { "name": "Walking / Jogging Track", "icon": "fas fa-running" },
            { "name": "Grand Entrance Plaza", "icon": "fas fa-archway" },
            { "name": "GYM", "icon": "fas fa-dumbbell" },
            { "name": "Coffee Shop", "icon": "fas fa-coffee" },
            { "name": "24×7 Security", "icon": "fas fa-shield-alt" }
        ]
        ,

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with seismic zone compliance." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living and bedrooms; anti-skid in bathrooms." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Main door with veneer finish; designer internal doors." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium/glazed windows with safety grills and mesh." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings and ceramic sanitaryware." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, AC and geyser points." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 borewell water; rainwater harvesting system." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "DG backup for common areas; EV charging provision." }
        ],

        "gallery": [
            require("../images/projects/Villas/KGR Anandam Villas/gallery-1.png"),
            require("../images/projects/Villas/KGR Anandam Villas/gallery-2.png"),
            require("../images/projects/Villas/KGR Anandam Villas/gallery-3.png"),
            require("../images/projects/Villas/KGR Anandam Villas/gallery-4.png"),
        ]

        // "google_map": "https://www.google.com/maps/embed?...Thukkguda+Hyderabad"
    }
    ,
    {
        "id": "northstar-allura",
        "project_name": "Northstar Allura",
        "category": "Villas",
        "title": "Northstar Allura",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/northstar-allur/northstar-allura.jpg"),
        "description": "Northstar Allura is a luxury gated villa community located in Tellapur, Hyderabad. Spread across 33 acres with 119 exclusive villas, the project offers a blend of contemporary design, premium amenities, and serene surroundings for elevated living."
        ,
        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "6.3 Acres" },
            { "icon": "fas fa-home", "title": "No. of Villas", "value": "54" },
            { "icon": "fas fa-ruler-combined", "title": "Plot Size", "value": "267–375 sq.yards" },
            { "icon": "fas fa-layer-group", "title": "Built-up Area", "value": "4,019–4,910 sq.ft." },
            { "icon": "fas fa-road", "title": "Two‑Road Access", "value": "Yes" },
            { "icon": "fas fa-chalkboard-teacher", "title": "Clubhouse Area", "value": "17,000 sq.ft." }
        ],

        "amenities": [
            { "name": "Indoor Badminton Court", "icon": "fas fa-basketball-ball" },
            { "name": "Gym", "icon": "fas fa-dumbbell" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Party Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Meditation Area", "icon": "fas fa-praying-hands" },
            { "name": "Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "Cricket Net", "icon": "fas fa-baseball-ball" },
            { "name": "Zen & Herbal Garden", "icon": "fas fa-leaf" },
            { "name": "Reflexology Path", "icon": "fas fa-walking" },
            { "name": "Outdoor Gym", "icon": "fas fa-dumbbell" },
            { "name": "Half Basketball Court", "icon": "fas fa-basketball-ball" }
        ],

        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Structure",
                "content": "RCC framed structure with slabs & beams"
            },
            {
                "icon": "fas fa-th",
                "title": "Wall Work",
                "content": "9\" external & 4½\" internal AAC / fly‑ash block masonry"
            },
            {
                "icon": "fas fa-paint-roller",
                "title": "Wall Finish",
                "content": "2-coat emulsion internal, textured/weatherproof external"
            },
            {
                "icon": "fas fa-border-style",
                "title": "Flooring",
                "content": "Vitrified in living/kitchen; anti-skid in wet areas"
            },
            {
                "icon": "fas fa-window-restore",
                "title": "Windows",
                "content": "UPVC / Aluminium anodized sliding windows"
            }
        ],

        "gallery": [
            require("../images/projects/Villas/northstar-allur/gallery-1.jpg"),
            require("../images/projects/Villas/northstar-allur/gallery-2.png"),
            require("../images/projects/Villas/northstar-allur/gallery-3.jpg"),
            require("../images/projects/Villas/northstar-allur/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.571211204348!2d78.36008407432843!3d17.432166501312113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93b94a9fb28f%3A0xe13b0b28fa5c12f2!2sKokapet%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v1625669098301!5m2!1sen!2sin"
    },
    {
        "id": "northstar-hillside",
        "project_name": "Northstar Hillside",
        "title": "Northstar Hillside Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Northstar Hillside/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "5.5 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "37 Handcrafted Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "Triplex G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "385–447 sq.yds" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "5,300–6,667 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2020 (Ready)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400001212" }
        ],

        "description": "Northstar Hillside is a gated enclave of 37 luxury 4 BHK triplex villas in Gandipet, Hyderabad. Built over 5.5 acres, it offers spacious layouts (5,300–6,667 sq.ft), central park-facing units, vehicle-free zones, and resort‑style living close to Osman Sagar and Financial District.",

        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor & Outdoor Games", "icon": "fas fa-gamepad" },
            { "name": "Squash Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Party / Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Business Centre", "icon": "fas fa-briefcase" },
            { "name": "Library", "icon": "fas fa-book" },
            { "name": "Mini Theatre", "icon": "fas fa-film" },
            { "name": "Indoor Kids’ Play Area", "icon": "fas fa-child" },
            { "name": "CCTV & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with brick masonry; seismic‑resistant." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium marble/vitrified tiles; anti‑skid in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Teak wood frames, teak‑veneer/shuttered internal doors." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium/glazed windows with mesh." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Glazed ceramic dado, granite counters, premium fittings." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, MCB, AC points." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24/7 borewell + treated water; STP & rainwater harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting systems & alarms in clubhouse." }
        ],

        "gallery": [
            require("../images/projects/Villas/Northstar Hillside/gallery-1.jpg"),
            require("../images/projects/Villas/Northstar Hillside/gallery-2.jpg"),
            require("../images/projects/Villas/Northstar Hillside/gallery-3.jpg"),
            require("../images/projects/Villas/Northstar Hillside/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Gandipet+Hyderabad"
    }
    ,
    {
        "id": "magna-ananda-villas",
        "project_name": "Magna Ananda",
        "title": "Magna Ananda Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Magna Meadows - Ananda Villas\/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "6 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "44 Quadruplex Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Floors" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "370–520 sq.yds" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "6,000–8,500 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Apr 2027 (Under Construction)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100004487" }
        ],

        "description": "Magna Ananda Villas is a gated community of 44 high-end quadruplex 4 BHK villas in Kollur/Osman Nagar, Hyderabad. Spread across 6 acres, it features sprawling layouts (6,000–8,500 sq.ft), private elevators, wet & dry kitchens, home theatres, landscaped corridors, pedestrian‑friendly roads, and resort‑style facilities—designed for luxurious, family-focused living. :contentReference[oaicite:2]{index=2}",

        "amenities": [
            { "name": "Clubhouse (10,000 sq.ft)", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Kids Play Zone", "icon": "fas fa-child" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Walking/Jogging Track", "icon": "fas fa-running" },
            { "name": "Relaxation Zone", "icon": "fas fa-spa" },
            { "name": "Pedestrian‑Friendly Roads", "icon": "fas fa-road" },
            { "name": "24×7 Security & Solar Fencing", "icon": "fas fa-shield-alt" },
            { "name": "Transportation Hub", "icon": "fas fa-bus" },
            { "name": "Special Landscaping", "icon": "fas fa-tree" },
            { "name": "Estate‑style Landscape", "icon": "fas fa-leaf" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with 9\" external & 4\" internal walls; seismic‑resistant. :contentReference[oaicite:3]{index=3}" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living/dining; vitrified tiles elsewhere. :contentReference[oaicite:4]{index=4}" },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Teakwood main door (8′9″) with veneer; 8′ internal flush shutters. :contentReference[oaicite:5]{index=5}" },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Large slim aluminium frames with mosquito mesh. :contentReference[oaicite:6]{index=6}" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Kohler/Jaguar fittings; provisions for geysers. :contentReference[oaicite:7]{index=7}" },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 borewell + treated water; STP & rain harvesting. :contentReference[oaicite:8]{index=8}" },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Solar fencing, CCTV, 24×7 security. :contentReference[oaicite:9]{index=9}" },
            { "icon": "fas fa-bolt", "title": "Power Backup", "content": "DG backup for common areas. :contentReference[oaicite:10]{index=10}" },
            { "icon": "fas fa-car", "title": "Parking", "content": "Closed car parking for residents. :contentReference[oaicite:11]{index=11}" }
        ],

        "gallery": [
            require("../images/projects/Villas/Magna Meadows - Ananda Villas/gallery-6.png"),
            require("../images/projects/Villas/Magna Meadows - Ananda Villas/gallery-5.png"),
            require("../images/projects/Villas/Magna Meadows - Ananda Villas/gallery-4.png"),
            require("../images/projects/Villas/Magna Meadows - Ananda Villas/gallery-3.png"),
            require("../images/projects/Villas/Magna Meadows - Ananda Villas/gallery-2.png"),
            require("../images/projects/Villas/Magna Meadows - Ananda Villas/gallery-1.png"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.42!3d17.38"
    }
    ,
    {
        "id": "mankhal-villas",
        "project_name": "Mankhal Villas",
        "title": "Mankhal Villas by Future Trends",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Mankhal Villas/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "15.97 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "68 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Triplex" },
            { "icon": "fas fa-door-open", "title": "Built-up Area", "value": "6,397–10,813 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Jul 2028" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400007021" }
        ],

        "description": "Mankhal Villas is a premium gated villa community offering 4 & 5 BHK triplex homes, thoughtfully laid out on nearly 16 acres in Mankhal, Hyderabad. These ultra-luxury villas come with expansive built-up spaces, panoramic valley views, Dornbracht fittings, limestone exteriors, a grand clubhouse, rooftop dining, and a semi-Olympic pool — combining serenity with sophisticated living.",

        "amenities": [
            { "name": "30,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Semi-Olympic Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Sauna & Spa", "icon": "fas fa-spa" },
            { "name": "Rooftop Lounge", "icon": "fas fa-wine-glass-alt" },
            { "name": "Poolside Dining", "icon": "fas fa-utensils" },
            { "name": "Business Centre & Meeting Rooms", "icon": "fas fa-briefcase" },
            { "name": "Indoor Games Room", "icon": "fas fa-gamepad" },
            { "name": "Kids’ Pool", "icon": "fas fa-child" },
            { "name": "Creche", "icon": "fas fa-baby" },
            { "name": "Badminton, Squash, Volleyball Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Tennis & Basketball Courts", "icon": "fas fa-basketball-ball" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Cricket Nets", "icon": "fas fa-cricket" },
            { "name": "Meditation Centre & Yoga Deck", "icon": "fas fa-pray" },
            { "name": "Changing Rooms", "icon": "fas fa-user-circle" },
            { "name": "EV-compatible Covered Parking", "icon": "fas fa-charging-station" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Eco Landscaping & Waterbody", "icon": "fas fa-tree" }
        ],

        "specifications": [
            { "icon": "fas fa-window-restore", "title": "Architecture", "content": "4–5 BHK triplex villas with floor-to-ceiling glass facades, limestone exteriors, high-end sanitary fittings, air-conditioned kitchens & bathrooms." },
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure compliant with seismic standards." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium marble and vitrified tiles; anti-skid tiles in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Designer wooden doors with premium handles and fixtures." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Full-height glazed windows for panoramic views with mesh shutters." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, and AC/geyser points in all rooms." },
            { "icon": "fas fa-water", "title": "Water", "content": "24×7 borewell and treated water supply; STP and rainwater harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire-fighting system, fire alarms, and gated security with CCTV surveillance." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "Full DG backup for common areas; EV charging-ready parking spaces." }
        ],

        "gallery": [
            require("../images/projects/Villas/Mankhal Villas/gallery-1.jpg"),
            require("../images/projects/Villas/Mankhal Villas/gallery-2.jpg"),
            require("../images/projects/Villas/Mankhal Villas/gallery-3.jpg"),
            require("../images/projects/Villas/Mankhal Villas/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.4!2d78.437!3d17.385"
    }
    ,
    {
        "id": "sage-by-raghava",
        "project_name": "Sage by Raghava",
        "title": "Sage by Raghava Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Raghava Sage/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "20.85 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "169 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 / G+3 Triplex" },
            { "icon": "fas fa-door-open", "title": "Built-up Area", "value": "5,647–6,370 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Starts Aug 2029" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100008686" }
        ],

        "description": "Sage by Raghava is an ultra‑premium villa community in Kollur (Hyderabad) spread over ~20.85 acres, featuring 169 spacious 4 BHK triplex homes with private pools. Launched in Dec 2024, possession begins Aug 2029—with top‑tier finishes, high ceilings and resort‑style clubhouse facilities.",

        "amenities": [
            { "name": "Clubhouse (28,500 sq.ft, G+3)", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Spa & Sauna", "icon": "fas fa-spa" },
            { "name": "Indoor & Outdoor Games", "icon": "fas fa-gamepad" },
            { "name": "Badminton Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Cricket Pitch / Nets", "icon": "fas fa-cricket" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Business Lounge & Meeting Rooms", "icon": "fas fa-briefcase" },
            { "name": "Library & Mini‑Theatre", "icon": "fas fa-book" },
            { "name": "Pet Area", "icon": "fas fa-dog" },
            { "name": "Kids’ Play Area & Sand Pit", "icon": "fas fa-child" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Walking / Jogging Track", "icon": "fas fa-running" },
            { "name": "Reception & Waiting Lounge", "icon": "fas fa-concierge-bell" },
            { "name": "CCTV & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "Water Supply & Rainwater Harvesting", "icon": "fas fa-water" },
            { "name": "Fire Fighting System", "icon": "fas fa-fire-extinguisher" },
            { "name": "Gated Community with Boom Barrier", "icon": "fas fa-gate" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with brick masonry; seismic‑resistant." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living/bedrooms; anti‑skid in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Teak‑veneer laminated main door; laminated internal flush shutters." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium/glazed windows with mesh." },
            { "icon": "fas fa-window-restore", "title": "Private Pool", "content": "Each villa includes a private plunge pool." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Anti‑skid ceramic tiles; premium CP fittings." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; MCB protection." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 borewell + treated water, STP & rainwater harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting systems installed in clubhouse & common areas." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "DG backup for common spaces; EV charging provision." }
        ],

        "gallery": [
            require("../images/projects/Villas/Raghava Sage/gallery-1.png"),
            require("../images/projects/Villas/Raghava Sage/gallery-2.png"),
            require("../images/projects/Villas/Raghava Sage/gallery-3.png"),
            require("../images/projects/Villas/Raghava Sage/gallery-4.png"),
            require("../images/projects/Villas/Raghava Sage/gallery-5.png"),
            require("../images/projects/Villas/Raghava Sage/gallery-6.png"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15282!2d78.33!3d17.48"
    }
    ,
    {
        "id": "promenade-boutique",
        "project_name": "The Promenade Boutique",
        "title": "The Promenade Boutique Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/The Promenade Boutique/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "14 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "121 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 + Terrace / Court Homes" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "295 sq.yds (Terrace/Court Homes)" },
            { "icon": "fas fa-ruler-combined", "title": "Built-up Area", "value": "3,996–4,086 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "June 2027" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100003619" }
        ],

        "description": "The Promenade Boutique is a curated collection of 4 BHK luxury villas in a Scandinavian-inspired layout set over 14 acres in Kollur/Tellapur, Hyderabad. Featuring two villa typologies—Terrace Homes and Court Homes—with double-height spaces, servant room, lift provision, private terraces, lush landscaping, and a vibrant 15,000 sq.ft clubhouse.",

        "amenities": [
            { "name": "15,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Indoor Games Room", "icon": "fas fa-gamepad" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Spa & Salon", "icon": "fas fa-spa" },
            { "name": "Badminton Court (Indoor)", "icon": "fas fa-volleyball-ball" },
            { "name": "Billiards Room", "icon": "fas fa-dice" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Tennis Court", "icon": "fas fa-table-tennis" },
            { "name": "Volleyball Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Nets", "icon": "fas fa-cricket" },
            { "name": "Jogging/Cycling Track", "icon": "fas fa-running" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Pet Park", "icon": "fas fa-dog" },
            { "name": "Reception & Waiting Lounge", "icon": "fas fa-concierge-bell" },
            { "name": "CCTV & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Power Backup & Solar Fencing", "icon": "fas fa-bolt" },
            { "name": "Lift in Villas (provision)", "icon": "fas fa-elevator" },
            { "name": "WTP & STP", "icon": "fas fa-water" },
            { "name": "High-speed Wi‑Fi", "icon": "fas fa-wifi" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with solid cement block walls." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "8 ft main & internal designer wooden doors." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium/glazed windows and French doors." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Vitrified/anti‑skid tiles with premium CP fittings." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Premium large-format tiles; upgradeable to marble." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, video door phone." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 treated water; rainwater harvesting & STP." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting, CCTV, solar fencing on compound walls." },
            { "icon": "fas fa-charging-station", "title": "Power Backup", "content": "DG backup for clubhouse & common areas." }
        ],

        "gallery": [
            require("../images/projects/Villas/The Promenade Boutique/gallery-1.jpg"),
            require("../images/projects/Villas/The Promenade Boutique/gallery-2.jpg"),
            require("../images/projects/Villas/The Promenade Boutique/gallery-3.jpg"),
            require("../images/projects/Villas/The Promenade Boutique/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Kollur+Tellapur+Hyderabad"
    }
    ,
    {
        "id": "ssi-som-boulevard",
        "project_name": "SSI Som Boulevard",
        "title": "SSI Som Boulevard Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/SSI Som Boulevard/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "40 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "270 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Triplex" },
            { "icon": "fas fa-door-open", "title": "Built-up Area", "value": "3,931–5,200 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Sep 2027" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400003701" }
        ],

        "description": "SSI Som Boulevard, by SSI KC Developers, is a premium gated villa community set on 40 acres in Mokila, Hyderabad. It offers 270 spacious 4 BHK triplex villas (3,931–5,956 sq.ft) featuring high ceilings, home theatres, dual-car parking, expansive greenery, and a grand 48,000 sq.ft clubhouse — blending nature and luxury within the city. :contentReference[oaicite:2]{index=2}",

        "amenities": [
            { "name": "48,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Outdoor & Indoor Swimming Pools (incl. kids’ pool)", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Spa & Jacuzzi", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games (billiards, table tennis)", "icon": "fas fa-dice" },
            { "name": "Mini Theatre & Conference Room", "icon": "fas fa-film" },
            { "name": "Library & Business Centre", "icon": "fas fa-book" },
            { "name": "Badminton, Squash & Tennis Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Pitch", "icon": "fas fa-cricket" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Amphitheatre", "icon": "fas fa-theater-masks" },
            { "name": "Pet Garden", "icon": "fas fa-dog" },
            { "name": "Senior Citizen Area", "icon": "fas fa-wheelchair" },
            { "name": "Kids’ Play Area & Sand Pit", "icon": "fas fa-child" },
            { "name": "Half Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Pergola Seating Areas & Water Features", "icon": "fas fa-umbrella-beach" },
            { "name": "Central Park & Private Green Decks", "icon": "fas fa-tree" },
            { "name": "24×7 Water & Power Backup", "icon": "fas fa-bolt" },
            { "name": "Gated Community with Security Cabin", "icon": "fas fa-shield-alt" },
            { "name": "CCTV, Video Door Phone & Boom Barriers", "icon": "fas fa-video" },
            { "name": "WTP & STP and Rainwater Harvesting", "icon": "fas fa-water" },
            { "name": "Central Gas Bank & BMS", "icon": "fas fa-cogs" }
        ],

        "specifications": [
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "800×800 mm Kajaria/Nitco/Johnson vitrified in living; anti‑skid in wet areas; ceramic dado up to 7 ft." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Veneered main doors, laminated internal shutters; fittings by Hafele/Dorma." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Powder-coated aluminium with mosquito/PVC mesh; MS railings." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Jaquar/Cera/Kohler fittings; anti‑skid tiles; SS hob & chimney in kitchen." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; Schneider/Vinay modular switches; AC & TV points." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 hydro-pneumatic treated borewell supply; individual meters." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Video door-phone, fire‑fighting systems, CCTV, solar fencing." },
            { "icon": "fas fa-charging-station", "title": "Power Backup & EV", "content": "100 % DG backup with AMF panel; EV-ready parking." }
        ],

        "gallery": [
            require("../images/projects/Villas/SSI Som Boulevard/gallery-1.jpg"),
            require("../images/projects/Villas/SSI Som Boulevard/gallery-2.jpg"),
            require("../images/projects/Villas/SSI Som Boulevard/gallery-3.jpg"),
            require("../images/projects/Villas/SSI Som Boulevard/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.35!3d17.45"
    }
    ,
    {
        "id": "srsm-luxury-villas",
        "project_name": "SRSM Villas",
        "title": "SRSM Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/SRSM Villas/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "20 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "171 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "4 BHK Triplex (G+2)" },
            { "icon": "fas fa-door-open", "title": "Built‑up Area", "value": "3,500–4,800 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2026 (Starts)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "Not Applicable" }
        ],

        "description": "SRSM Villas is a gated community of premium 4 BHK triplex homes in Kollur, Hyderabad. Spread across 20 acres, it features 171 villas ranging from 3,500 to 4,800 sq.ft with possession beginning in December 2026. Prices currently range from ₹2.45 Cr to ₹3.36 Cr, delivering upscale living close to IT corridors.",

        "amenities": [
            { "name": "24×7 Water Supply", "icon": "fas fa-water" },
            { "name": "Full Power Backup", "icon": "fas fa-bolt" },
            { "name": "Fire Sprinklers", "icon": "fas fa-fire-extinguisher" },
            { "name": "Children's Play Area", "icon": "fas fa-child" },
            { "name": "Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games", "icon": "fas fa-gamepad" },
            { "name": "CCTV Surveillance", "icon": "fas fa-video" },
            { "name": "Intercom Facility", "icon": "fas fa-phone" },
            { "name": "Rainwater Harvesting", "icon": "fas fa-cloud-rain" },
            { "name": "Sewage Treatment Plant (STP)", "icon": "fas fa-recycle" },
            { "name": "Multipurpose Hall", "icon": "fas fa-chess-board" },
            { "name": "Walking & Jogging Track", "icon": "fas fa-shoe-prints" },
            { "name": "Visitor Parking", "icon": "fas fa-car" },
            { "name": "Security Cabin", "icon": "fas fa-shield-alt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure designed for seismic resistance." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified tiles in living, dining, and bedrooms; anti-skid tiles in bathrooms and balconies." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Teak wood frame for main door; flush doors with laminate finish for internal rooms." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "UPVC sliding windows with mosquito mesh and safety grills." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Branded CP fittings and sanitary ware with wall-mounted EWC; provision for geysers." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring with modular switches (Anchor/Legrand); 3-phase power supply with MCB." },
            { "icon": "fas fa-paint-roller", "title": "Painting", "content": "Internal: Smooth putty with acrylic emulsion; External: Weatherproof paint." },
            { "icon": "fas fa-kitchen-set", "title": "Kitchen", "content": "Granite platform with SS sink, 2' ceramic tile dado; provision for chimney and hob." },
            { "icon": "fas fa-shield-alt", "title": "Security", "content": "CCTV surveillance, intercom facility, boom barriers at entrance/exit." },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Rainwater harvesting system; borewell with sump and overhead tank." },
            { "icon": "fas fa-drafting-compass", "title": "Floor Plans & Pricing", "content": "4 BHK + 4T: 3,500 sq.ft – ₹2.45 Cr, 4,200 sq.ft – ₹2.94 Cr, 4,800 sq.ft – ₹3.36 Cr." }
        ]
        ,

        "gallery": [
            require("../images/projects/Villas/SRSM Villas/gallery-1.png"),
            require("../images/projects/Villas/SRSM Villas/gallery-2.png"),
            require("../images/projects/Villas/SRSM Villas/gallery-3.png"),
            require("../images/projects/Villas/SRSM Villas/gallery-4.png"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.35!3d17.45"
    }
    ,
    {
        "id": "aikaa-villas",
        "project_name": "Sri Aditya Aikaa",
        "title": "Aikaa Villas by Sri Aditya",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Sri Aditya Aikaa/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "33.45 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "146 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 / Triplex" },
            { "icon": "fas fa-door-open", "title": "Built-up Area", "value": "8,220–8,432 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "June 2030" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400008538" }
        ],

        "description": "Aikaa is an ultra-luxury gated community by Sri Aditya Homes in Kokapet, Hyderabad. Spread over 33.45 acres with only 146 high-end 5 BHK villas (8,220–8,432 sq.ft), it combines exclusive architecture, no surrounding high‑rises, a 50,000 sq.ft clubhouse, scenic lake and forest environs—designed for a rarefied lifestyle.",

        "amenities": [
            { "name": "50,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Two-tier Water Body / Lake Views", "icon": "fas fa-water" },
            { "name": "Landscaped Gardens & Green Pockets", "icon": "fas fa-tree" },
            { "name": "Children’s Play Area & Kids’ Pool", "icon": "fas fa-child" },
            { "name": "Gated Community with 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "CCTV Surveillance", "icon": "fas fa-video" },
            { "name": "Full Power Backup", "icon": "fas fa-bolt" },
            { "name": "Lift Provision", "icon": "fas fa-elevator" },
            { "name": "Internal Road Lighting", "icon": "fas fa-lightbulb" },
            { "name": "Sewage Treatment Plant & Rainwater Harvesting", "icon": "fas fa-recycle" },
            { "name": "Two‑Wheeler & Four‑Wheeler Parking", "icon": "fas fa-car" },
            { "name": "Multipurpose Hall / Event Space", "icon": "fas fa-glass-cheers" },
            { "name": "Gymnasium & Spa", "icon": "fas fa-dumbbell" },
            { "name": "Internet Connectivity", "icon": "fas fa-wifi" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed, premium-grade finishes, designed for longevity and stability." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble/vitrified in living & bedrooms; anti‑skid tiles in wet zones." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Designer wooden main door; polished internal doors." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Floor–to–ceiling glazed windows with mosquito mesh and panoramic views." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings; wall-mounted EWC; provision for geysers." },
            { "icon": "fas fa-kitchen-set", "title": "Kitchen", "content": "Granite platform with SS sink and high-end cabinet space." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed Copper wiring, modular switches, 3-phase backup with MCBs." },
            { "icon": "fas fa-water", "title": "Water & Sewage", "content": "24×7 borewell & treated water; STP and rain‑water harvesting." },
            { "icon": "fas fa-elevator", "title": "Lift", "content": "Lift provision in each villa." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "CCTV, fire alarms and gated entry with boom barriers." },
            { "icon": "fas fa-drafting-compass", "title": "Variants & Sizes", "content": "East‑facing (8,432 sq.ft) & West‑facing (8,220 sq.ft), both 5 BHK." }
        ],

        "gallery": [
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-1.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-2.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-3.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-4.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-5.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-6.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-7.jpg"),
            require("../images/projects/Villas/Sri Aditya Aikaa/gallery-8.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?...Kokapet+Hyderabad"
    }
    ,
    {
        "id": "srias-the-boat-club",
        "project_name": "SRIAS The Boat Club",
        "title": "SRIAS The Boat Club Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/SRIAS The Boat Club/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "25 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "190 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Triplex" },
            { "icon": "fas fa-door-open", "title": "Built‑up Area", "value": "2,700–6,800 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Aug 2028" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02200005072" }
        ],

        "description": "Nestled by Medchal Lake, SRIAS The Boat Club is a lake‑front luxury gated villa community spanning 25 acres. Launched in Oct 2022, it offers 190 spacious 4 & 5 BHK triplex homes (2,700–6,800 sq.ft) with resort‑like amenities, eco‑features, and high‑end finishes — all within 20–30 minutes of Hyderabad’s key IT and financial hubs.",

        "amenities": [
            { "name": "60,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Sauna & Spa", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games (Table Tennis, Billiards)", "icon": "fas fa-gamepad" },
            { "name": "Mini Theatre & Banquet Hall", "icon": "fas fa-film" },
            { "name": "Business Centre & Library", "icon": "fas fa-briefcase" },
            { "name": "Tennis, Squash & Badminton Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Pitch & Nets", "icon": "fas fa-cricket" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Pet Park", "icon": "fas fa-dog" },
            { "name": "Senior Citizen Area & Meditation/Yoga Deck", "icon": "fas fa-pray" },
            { "name": "Children’s Play Area & Sand Pit", "icon": "fas fa-child" },
            { "name": "Snooker/Billiards Room", "icon": "fas fa-dice" },
            { "name": "Visitor Parking & Valet Service", "icon": "fas fa-car" },
            { "name": "Grocery Shop & Cafeteria", "icon": "fas fa-coffee" },
            { "name": "CCTV, Video Door‑Phone & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Full Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "Rainwater Harvesting, WTP & STP", "icon": "fas fa-water" },
            { "name": "Green Landscaping & Natural Pond", "icon": "fas fa-tree" },
            { "name": "Eco‑friendly Solar Street Lighting", "icon": "fas fa-solar-panel" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with seismic compliance." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble/vitrified in living; anti‑skid in wet zones." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Designer main doors with veneer; polished internal shutters." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Floor‑to‑ceiling glazing with mesh & aluminium frames." },
            { "icon": "fas fa-window-restore", "title": "Private Pool", "content": "Select villas include private plunge pools." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings; wall‑mounted EWCs; geyser provision." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, 3‑phase MCB." },
            { "icon": "fas fa-water", "title": "Water & Sewage", "content": "24×7 borewell + treated water; STP and rain‑water harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting systems, CCTV, security cabin and gated entry." },
            { "icon": "fas fa-spa", "title": "Smart Features", "content": "Video door‑phone; intercom; solar street lights." },
            { "icon": "fas fa-drafting-compass", "title": "Floor Plans & Price", "content": "4 BHK (2,700–5,404 sq.ft) starting ₹4.2 Cr; 5 BHK (4,302–6,800 sq.ft) ₹6.69–10.58 Cr." }
        ],

        "gallery": [
            require("../images/projects/Villas/SRIAS The Boat Club/gallery-1.jpg"),
            require("../images/projects/Villas/SRIAS The Boat Club/gallery-2.jpg"),
            require("../images/projects/Villas/SRIAS The Boat Club/gallery-3.jpg"),
            require("../images/projects/Villas/SRIAS The Boat Club/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Medchal+Hyderabad"
    }
    ,
    {
        "id": "sriven-iris-villas",
        "project_name": "Sriven Iris Villas",
        "title": "Sriven Iris Villas by Sriven Avenues",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Sriven Iris/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "5.9 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "47 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Triplex (4 BHK + study/family lounge)" },
            { "icon": "fas fa-door-open", "title": "Built‑up Area", "value": "4,799–5,259 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Apr 2024 (Ready)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400001517" }
        ],

        "description": "Sriven Iris is a gated community of 47 designer 4 BHK triplex villas in Narsingi, Hyderabad, spread over ~5.9 acres. With super‑built spaces of 4,799–5,259 sq.ft, it includes family lounges, private terraces, high‑end finishes, smart home features, and a resort‑style clubhouse for abundant family living.",

        "amenities": [
            { "name": "Clubhouse ( ≈15,000 sq.ft )", "icon": "fas fa-building" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Spa, Sauna & Jacuzzi", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room (Table Tennis, Carrom)", "icon": "fas fa-gamepad" },
            { "name": "Library & Multipurpose Hall", "icon": "fas fa-book" },
            { "name": "Badminton, Squash & Tennis Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Pitch & Nets", "icon": "fas fa-cricket" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Children’s Play Area & Sand Pit", "icon": "fas fa-child" },
            { "name": "Mini Golf Course", "icon": "fas fa-golf-ball" },
            { "name": "Amphitheatre & Garden Seating", "icon": "fas fa-theater-masks" },
            { "name": "Avenue Tree Plantation & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Piped Gas Connection", "icon": "fas fa-fire" },
            { "name": "Visitor Parking & Valet", "icon": "fas fa-car" },
            { "name": "24×7 Water & Power Backup", "icon": "fas fa-bolt" },
            { "name": "CCTV, Video Door-Phone & Security Personnel", "icon": "fas fa-shield-alt" },
            { "name": "Rainwater Harvesting & Sewage Treatment Plant", "icon": "fas fa-water" },
            { "name": "Yoga Deck & Reflexology Path", "icon": "fas fa-pray" },
            { "name": "Energy-efficient Street & Clubhouse Lighting", "icon": "fas fa-solar-panel" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Earthquake‑resistant RCC framed structure with cement block masonry." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Italian marble in drawing, living, dining & dry kitchen; engineered wood in master; vitrified/anti‑skid tiles in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Polished seasoned hard wood main door; Hafele/Yale internal shutters." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Powder-coated aluminium sliding/fixed glazing with mosquito mesh." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Wall-mounted EWCs (Catalano/GEBERIT); Hansgrohe thermostatic faucets; granite wash counters." },
            { "icon": "fas fa-kitchen-set", "title": "Kitchen", "content": "Italian marble/anti-skid vitrified flooring; granite platform with SS sink and cabinets." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring (Finolex), Schneider switches; 3-phase MCB; VRV-ready AC points." },
            { "icon": "fas fa-water", "title": "Water Management", "content": "24×7 borewell + treated water; STP, rainwater harvesting, organic waste converter." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "CCTV, video door-phone, fire-fighting systems, boom barrier gated entry." },
            { "icon": "fas fa-spa", "title": "Home Automation", "content": "Yale digital lock with fingerprint/pad; Legrand video door-phone intercom." },
            { "icon": "fas fa-drafting-compass", "title": "Floor Plans", "content": "East Villa: 5,200 sq.ft; West Villa: 5,090 sq.ft (both with study, family lounge & multiple balconies/terraces)." }
        ],

        "gallery": [
            require("../images/projects/Villas/Sriven Iris/gallery-1.jpg"),
            require("../images/projects/Villas/Sriven Iris/gallery-2.jpg"),
            require("../images/projects/Villas/Sriven Iris/gallery-3.jpg"),
            require("../images/projects/Villas/Sriven Iris/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Narsingi+Hyderabad"
    },
    {
        "id": "riverscape-villas",
        "project_name": "Riverscape Villas",
        "title": "Urrban League – Riverscape Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Riverscape/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "22.5 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "226 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Triplex" },
            { "icon": "fas fa-door-open", "title": "Built‑up Area", "value": "3,256–4,850 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Mar 2028" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400004424" }
        ],

        "description": "Riverscape is an IGBC‑Gold eco‑certified, river‑front gated villa community of 3 & 4 BHK homes set over 22.5 acres in Bandlaguda Jagir, Hyderabad. It blends resort‑style amenities, smart home features, lush landscaping, and waterfront trails, all within a 20–30 minute drive to key city hubs.",

        "amenities": [
            { "name": "47,000 sq.ft Clubhouse", "icon": "fas fa-building" },
            { "name": "Infinity Pool", "icon": "fas fa-swimmer" },
            { "name": "Swimming Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games Room", "icon": "fas fa-gamepad" },
            { "name": "Business Centre & Taproom", "icon": "fas fa-briefcase" },
            { "name": "Banquet Hall", "icon": "fas fa-glass-cheers" },
            { "name": "Guest Rooms", "icon": "fas fa-bed" },
            { "name": "Tennis, Badminton, Squash Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Beach Volleyball Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Cricket Nets", "icon": "fas fa-cricket" },
            { "name": "Rooftop Astro Football Turf", "icon": "fas fa-futbol" },
            { "name": "Jogging & Riverside Walk Track", "icon": "fas fa-running" },
            { "name": "Spa & Yoga Deck", "icon": "fas fa-spa" },
            { "name": "Outdoor Gazebo Sit‑outs", "icon": "fas fa-umbrella-beach" },
            { "name": "Dog Park", "icon": "fas fa-dog" },
            { "name": "Temple", "icon": "fas fa-pray" },
            { "name": "Mini Garden & Party Lawns", "icon": "fas fa-tree" },
            { "name": "Convenience Store", "icon": "fas fa-shopping-basket" },
            { "name": "Crèche", "icon": "fas fa-baby" },
            { "name": "CCTV Surveillance & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Rainwater Harvesting & WTP/STP", "icon": "fas fa-water" },
            { "name": "Intercom & Smart Home Features", "icon": "fas fa-wifi" },
            { "name": "Full Power Backup & Solar Street Lights", "icon": "fas fa-bolt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed with seismic resistance; 9\" external & 4\" internal block walls." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble/vitrified flooring in living; anti‑skid in wet areas." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Seasoned timber main door; laminate flush shutters inside." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Powder‑coated aluminium frames with large glazed panels and mosquito mesh." },
            { "icon": "fas fa-elevator", "title": "Elevator Provision", "content": "Structural provision & wiring for elevator in every villa." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings; wall‑mounted EWCs; provision for geysers." },
            { "icon": "fas fa-kitchen-set", "title": "Kitchen", "content": "Granite countertop, SS sink, ceramic tile dado; hob/chimney provision." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches (Schneider/Vinay); 3‑phase MCB." },
            { "icon": "fas fa-water", "title": "Water & Sewage", "content": "24×7 borewell + treated water, STP & rainwater harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting systems, CCTV, boom barriers, security cabin." },
            { "icon": "fas fa-spa", "title": "Smart Features", "content": "Video door phone, intercom, extra parking, smart lighting." },
            { "icon": "fas fa-drafting-compass", "title": "Floor Plans", "content": "3 BHK: 3,256 sq.ft; 4 BHK: 4,850 sq.ft." }
        ],

        "gallery": [
            require("../images/projects/Villas/Riverscape/gallery-1.jpg"),
            require("../images/projects/Villas/Riverscape/gallery-2.jpg"),
            require("../images/projects/Villas/Riverscape/gallery-3.jpg"),
            require("../images/projects/Villas/Riverscape/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.4!2d78.38!3d17.35"
    },
    {
        "id": "vertex-kingston-park",
        "project_name": "Vertex Kingston Park",
        "title": "Vertex Kingston Park Villas",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Vertex Kingston Park/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "40 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "250 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+2 Triplex" },
            { "icon": "fas fa-door-open", "title": "Built-up Area", "value": "4,020–5,720 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Feb 2027" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400002807" }
        ],

        "description": "Vertex Kingston Park is the largest ultra‑luxury gated villa community in West Hyderabad (Nallagandla), spanning 40 acres with 250 4 & 5 BHK triplex villas. Abutting 2,400 acres of green space near Hyderabad Central University, it offers urban connectivity alongside timeless architecture and green living. It's just minutes from Gachibowli, Hitech City & Wipro junction.",

        "amenities": [
            { "name": "50,000 sq.ft Clubhouse (Club Royale)", "icon": "fas fa-building" },
            { "name": "Putting Green", "icon": "fas fa-golf-ball" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Clinic", "icon": "fas fa-clinic-medical" },
            { "name": "Library", "icon": "fas fa-book" },
            { "name": "Yoga/Aerobic Room", "icon": "fas fa-spa" },
            { "name": "Preview Theatre", "icon": "fas fa-film" },
            { "name": "Squash Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Supermarket", "icon": "fas fa-shopping-basket" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Open Amphitheater", "icon": "fas fa-theater-masks" },
            { "name": "Poolside Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Multi-purpose Court (Tennis & Futsal)", "icon": "fas fa-volleyball-ball" },
            { "name": "Crèche", "icon": "fas fa-baby" },
            { "name": "Spa & Salon", "icon": "fas fa-cut" },
            { "name": "Senior Citizen Space", "icon": "fas fa-wheelchair" },
            { "name": "Indoor Games (Billiards, Table Tennis, Carrom)", "icon": "fas fa-gamepad" },
            { "name": "CCTV Surveillance & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Fire Sprinklers", "icon": "fas fa-fire-extinguisher" },
            { "name": "Lift Provision", "icon": "fas fa-elevator" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Landscaped Garden", "icon": "fas fa-tree" },
            { "name": "Rainwater Harvesting", "icon": "fas fa-water" },
            { "name": "Video Door Phone / Intercom", "icon": "fas fa-phone" },
            { "name": "Power Backup", "icon": "fas fa-bolt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed structure with seismic‑resistant design." },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Imported marble in living/dining; wooden flooring in master; anti-skid tiles in wet zones." },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Polished main doors; designer internal flush/shuttered doors." },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "Aluminium / glazed windows with mosquito mesh." },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Premium CP fittings, wall-mounted WCs, granite counters; geyser provisions." },
            { "icon": "fas fa-kitchen-set", "title": "Kitchen", "content": "Granite countertop, SS sink, ceramic tile dado, provision for hob/chimney." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring; modular switches; 3-phase MCBs & AC points." },
            { "icon": "fas fa-water", "title": "Water & Drainage", "content": "24×7 treated borewell water, STP & rainwater harvesting." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting systems, CCTV, boom barriers & security cabin." },
            { "icon": "fas fa-elevator", "title": "Elevator Provision", "content": "Structure & wiring provision in all villas." },
            { "icon": "fas fa-drafting-compass", "title": "Floor Plans", "content": "4 BHK: 4,020–4,397 sq.ft • 5 BHK: 5,471–5,720 sq.ft." }
        ],

        "gallery": [
            require("../images/projects/Villas/Vertex Kingston Park/gallery-8.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-7.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-6.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-5.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-4.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-3.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-2.jpg"),
            require("../images/projects/Villas/Vertex Kingston Park/gallery-1.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?...Nallagandla+Hyderabad"
    }
    ,
    {
        "id": "vision-urjith-villas",
        "project_name": "Vision Urjith Villas",
        "title": "Vision Urjith Villas by Vision Avenues",
        "category": "Villas",
        "location": "Hyderabad",
        "image": require("../images/projects/Villas/Vision Urjith/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "40 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "274 Villas" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+1 (2 floors)" },
            { "icon": "fas fa-door-open", "title": "Built‑up Area", "value": "2,800–4,535 sq.ft" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Ready to Move (2022)" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P01100000521" }
        ],

        "description": "Vision Urjith is a gated villa community in Tellapur (Osman Nagar), Hyderabad. Launched in Nov 2015 across 40 acres and completed in 2022, it offers 274 luxurious 3, 3.5, and 4 BHK villas (2,800–4,535 sq.ft) featuring private lifts, lap-pools, and smart home integration, all within a well-connected locale..",

        "amenities": [
            { "name": "Clubhouse (~36,000 sq.ft)", "icon": "fas fa-building" },
            { "name": "Swimming Pool, Lap Pool & Kids’ Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium, Spa, Sauna & Jacuzzi", "icon": "fas fa-dumbbell" },
            { "name": "Indoor Games (Squash, Badminton, Table Tennis, Billiards)", "icon": "fas fa-gamepad" },
            { "name": "Tennis, Basketball & Volleyball Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Cricket Pitch & Nets", "icon": "fas fa-cricket" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Amphitheatre & Party Lawn", "icon": "fas fa-glass-cheers" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Library & Business Centre", "icon": "fas fa-book" },
            { "name": "Meditation/Yoga Deck", "icon": "fas fa-pray" },
            { "name": "CCTV, Video Door Phone & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Fire Sprinklers", "icon": "fas fa-fire-extinguisher" },
            { "name": "Full Power & Water Backup", "icon": "fas fa-bolt" },
            { "name": "Rainwater Harvesting & Sewage Treatment Plant", "icon": "fas fa-water" },
            { "name": "Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Covered & Visitor Parking", "icon": "fas fa-car" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "RCC framed (M20), seismic‑resistant; 9″ external & 4½″ internal walls. :contentReference[oaicite:2]{index=2}" },
            { "icon": "fas fa-border-style", "title": "Flooring", "content": "Vitrified / agglomerate marble in living; ceramic/anti‑skid tiles in wet areas. :contentReference[oaicite:3]{index=3}" },
            { "icon": "fas fa-door-closed", "title": "Doors", "content": "Teak wood main doors; teak‑frame moulded-panel internal shutters. :contentReference[oaicite:4]{index=4}" },
            { "icon": "fas fa-window-maximize", "title": "Windows", "content": "UPVC or aluminium sliding windows with mosquito mesh. :contentReference[oaicite:5]{index=5}" },
            { "icon": "fas fa-elevator", "title": "Lift Provision", "content": "Structural and wiring provision for private elevator in each villa. :contentReference[oaicite:6]{index=6}" },
            { "icon": "fas fa-bath", "title": "Bathrooms", "content": "Wall-mounted EWC, glazed ceramic tiles, hot & cold mixer, geyser provisions. :contentReference[oaicite:7]{index=7}" },
            { "icon": "fas fa-kitchen-set", "title": "Kitchen", "content": "Granite platform, SS sink, ceramic tile dado; utility & hob/chimney provisions. :contentReference[oaicite:8]{index=8}" },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "Concealed copper wiring, modular switches, 3-phase MCB & AC points. :contentReference[oaicite:9]{index=9}" },
            { "icon": "fas fa-water", "title": "Water & Sewage", "content": "24×7 treated water, rainwater harvesting & STP facilities. :contentReference[oaicite:10]{index=10}" },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Fire‑fighting system, CCTV, gated community with boom barriers. :contentReference[oaicite:11]{index=11}" },
            { "icon": "fas fa-spa", "title": "Smart & Security Features", "content": "Video door phone, biometric lock, DTH/property intercom. :contentReference[oaicite:12]{index=12}" },
            { "icon": "fas fa-drafting-compass", "title": "Floor Plans", "content": "3 BHK: 2,800–2,860 sq.ft; 4 BHK: 3,505–4,535 sq.ft (East/West-facing variants). :contentReference[oaicite:13]{index=13}" }
        ],

        "gallery": [
            require("../images/projects/Villas/Vision Urjith/gallery-1.jpg"),
            require("../images/projects/Villas/Vision Urjith/gallery-2.jpg"),
            require("../images/projects/Villas/Vision Urjith/gallery-3.jpg"),
            require("../images/projects/Villas/Vision Urjith/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Tellapur+Hyderabad"
    }
    ,
    // Plots
    {
        id: "aurorealty-auroland",
        project_name: "Aurorealty Auroland",
        category: "Plots",
        title: "Aurorealty Auroland",
        location: "Hyderabad",
        image: require("../images/projects/Plots/auroreality-auroland/auroreality-auroland.jpeg"),
        "description": "Aurorealty Auroland offers premium open plots in a well-planned gated community at Patancheru, Hyderabad. Spanning 23+ acres with modern infrastructure, this HMDA-approved project is ideal for residential investment with excellent connectivity and green surroundings."
        ,
        project_overview: [
            { icon: "fas fa-vector-square", title: "Total Area", value: "32.18 Acres" },
            { icon: "fas fa-home", title: "Number of Plots", value: "422" },
            { icon: "fas fa-ruler-combined", title: "Plot Size", value: "200–300 sq. yards" },
            { icon: "fas fa-id-card", title: "RERA ID", value: "P01100007349" },
            { icon: "fas fa-hourglass-half", title: "Possession", value: "October 2024" },
            { icon: "fas fa-map-marker-alt", title: "Location", value: "Patancheru, Hyderabad" }
        ],

        amenities: [
            { name: "24×7 Water Supply", icon: "fas fa-tint" },
            { name: "24×7 Security & CCTV", icon: "fas fa-shield-alt" },
            { name: "Kids' Play Area / Sandpit", icon: "fas fa-child" },
            { name: "Gymnasium", icon: "fas fa-dumbbell" },
            { name: "Swimming Pool", icon: "fas fa-swimmer" },
            { name: "Jogging / Cycle Track", icon: "fas fa-running" },
            { name: "Yoga / Meditation Area", icon: "fas fa-spa" },
            { name: "Badminton Court", icon: "fas fa-table-tennis" },
            { name: "Basketball Court", icon: "fas fa-basketball-ball" },
            { name: "Amphitheatre", icon: "fas fa-theater-masks" },
            { name: "Sewage Treatment Plant", icon: "fas fa-recycle" },
            { name: "Rainwater Harvesting", icon: "fas fa-water" },
            { name: "Street Lighting", icon: "fas fa-lightbulb" },
            { name: "Landscape Gardens", icon: "fas fa-tree" },
            { name: "Gated Community", icon: "fas fa-gate" },
            { name: "Blacktop Roads", icon: "fas fa-road" }
        ],

        specifications: [
            { icon: "fas fa-map", title: "Development Type", content: "Villa Plot Community" },
            { icon: "fas fa-certificate", title: "Approvals", content: "HMDA & RERA Approved" },
            { icon: "fas fa-id-card", title: "RERA", content: "P01100007349" },
            { icon: "fas fa-clock", title: "Possession", content: "Ready by October 2024" },
            { icon: "fas fa-wallet", title: "Price Range", content: "₹63.99 L – ₹95.98 L" }
        ],

        gallery: [
            require("../images/projects/Plots/auroreality-auroland/gallery-1.jpeg"),
            require("../images/projects/Plots/auroreality-auroland/gallery-2.jpeg"),
            require("../images/projects/Plots/auroreality-auroland/gallery-3.jpeg"),
            require("../images/projects/Plots/auroreality-auroland/gallery-4.jpeg"),
        ],

        // google_map: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15228!2d78.25!3d17.45"
    },
    {
        "id": "prestige-nirvana-plots",
        "project_name": "Prestige Nirvana",
        "title": "Prestige Nirvana Plots",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Prestige Nirvana/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "30 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "248 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "267 – 2,077 sq.yds (40×60, 60×60, 55×80)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Ongoing" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400000393" }
        ],

        "description": "Prestige Nirvana is a premium gated plot community spread over 30 acres in Budvel (Rajendranagar), West Hyderabad. It offers 248 Vaastu-compliant plots (40×60, 60×60, 55×80) with wide internal roads, underground utilities, green landscaping, and a full suite of clubhouse and lifestyle amenities.",

        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Badminton Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Senior Citizen Zone", "icon": "fas fa-wheelchair" },
            { "name": "Pet Park", "icon": "fas fa-dog" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "CCTV & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Visitor Parking", "icon": "fas fa-car" },
            { "name": "Underground Power & Fibre Optic", "icon": "fas fa-plug" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground electric, water pipelines & sewage system; 60' & 40' wide bitumen roads." },
            { "icon": "fas fa-border-style", "title": "Land Preparation", "content": "Levelled plots with compound walls on periphery; natural landscaping retained." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Dual water supply (borewell & municipal), overhead and sump reservoirs." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Boom barriers, security cabins & CCTV surveillance at main entrance." },
            { "icon": "fas fa-tree", "title": "Greenery", "content": "Avenue plantation with flowering trees along all roads." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Variants", "content": "40×60 (2,400 sq.ft), 60×60 (3,600 sq.ft), 55×80 (4,400 sq.ft)." }
        ],

        "gallery": [
            require("../images/projects/Plots/Prestige Nirvana/gallery-1.jpg"),
            require("../images/projects/Plots/Prestige Nirvana/gallery-2.jpg"),
            require("../images/projects/Plots/Prestige Nirvana/gallery-3.jpg"),
            require("../images/projects/Plots/Prestige Nirvana/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Rajendranagar+Hyderabad"
    }
    ,
    {
        "id": "prestige-orchards-plots",
        "project_name": "Prestige Orchards",
        "title": "Prestige Orchards Plots",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Prestige Orchards/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "43.16 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "322 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "2,400–5,720 sq.ft (approx. 45×60 to 50×90)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Sep 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400005132" }
        ],

        "description": "Prestige Orchards is a gated plotted community in Shamshabad (Mamidipally), Hyderabad, spread over 43 acres with 322 premium plots (approx. 2,400–5,720 sq.ft) approved by RERA. It's designed with extensive green open spaces, underground utilities, and convenience living near the airport.",

        "amenities": [
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Tennis & Basketball Courts", "icon": "fas fa-volleyball-ball" },
            { "name": "Cricket Court", "icon": "fas fa-cricket" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Jogging & Cycling Track", "icon": "fas fa-running" },
            { "name": "Gazebos & Seating Lawns", "icon": "fas fa-tree" },
            { "name": "Rock Climbing Wall", "icon": "fas fa-mountain" },
            { "name": "Acupressure Walkway", "icon": "fas fa-walking" },
            { "name": "Open-air Theatre", "icon": "fas fa-theater-masks" },
            { "name": "Barbecue Area", "icon": "fas fa-fire" },
            { "name": "Organic/Fruit Orchard", "icon": "fas fa-leaf" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "24×7 Water & Power Backup", "icon": "fas fa-bolt" },
            { "name": "CCTV & 24×7 Security", "icon": "fas fa-shield-alt" },
            { "name": "Underground Utilities", "icon": "fas fa-plug" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground electric, telecom & water pipelines; 60'/40' wide bitumen roads." },
            { "icon": "fas fa-border-style", "title": "Land Preparation", "content": "Plots leveled with piped water & sewage, landscaped avenue plantation." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Dual supply: borewell + municipal; overhead & sump tanks." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Boom barriers, security cabins & CCTV monitored gates." },
            { "icon": "fas fa-tree", "title": "Greenery", "content": "Extensive landscaping with sports & recreational greens." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Variants", "content": "45×60, 60×60, 50×80 & 50×90 (2,400–5,720 sq.ft)." }
        ],

        "gallery": [
            require("../images/projects/Plots/Prestige Orchards/gallery-1.jpg"),
            require("../images/projects/Plots/Prestige Orchards/gallery-2.jpg"),
            require("../images/projects/Plots/Prestige Orchards/gallery-3.jpg"),
            require("../images/projects/Plots/Prestige Orchards/gallery-4.jpg"),
            require("../images/projects/Plots/Prestige Orchards/gallery-5.jpg"),
            require("../images/projects/Plots/Prestige Orchards/gallery-6.jpg")
        ],


        // "google_map": "https://www.google.com/maps/embed?...Mamidipally+Hyderabad"
    }
    ,
    {
        "id": "fortune-retreat-plots",
        "project_name": "Fortune Retreat",
        "title": "Fortune Retreat Resort‑themed Plots",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Fortune Retreat/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "5 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "250 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "1,350–5,400 sq.ft (183–600 sq.yd)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Jul 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02100007505" }
        ],

        "description": "Fortune Retreat is a resort‑themed, gated plot community located on Shankarpalli–Mominpet Road, Hyderabad. Spread across 5 acres, the development features 250 villa plots ranging from 1,350–5,400 sq.ft, with DTCP/HMDA approvals and residential finance support for ICICI & HDFC buyers. It's designed for wellness‑centric living, with rich natural landscaping and leisure spaces.",

        "amenities": [
            { "name": "Gated Entry with Boom Barrier & Security Cabin", "icon": "fas fa-shield-alt" },
            { "name": "24×7 Water Supply via Borewell & Municipal", "icon": "fas fa-water" },
            { "name": "Stormwater Drainage & Underground Utilities", "icon": "fas fa-plug" },
            { "name": "Internal Bitumen Roads & Footpaths", "icon": "fas fa-running" },
            { "name": "Basketball Court", "icon": "fas fa-basketball-ball" },
            { "name": "Mini Theatre", "icon": "fas fa-film" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Landscaped Gardens & Tree Plantation", "icon": "fas fa-tree" },
            { "name": "Street Lighting", "icon": "fas fa-lightbulb" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Visitor Parking", "icon": "fas fa-car" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground electric, telecom & water lines; 40′–60′ wide bitumen roads with kerbs and footpaths. :contentReference[oaicite:3]{index=3}" },
            { "icon": "fas fa-border-style", "title": "Land Prep & Landscaping", "content": "Plots levelled with peripheral compound wall; avenue plantation with flowering trees." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "Dual supply from borewell and municipal, sump & overhead tank." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Boom barrier entry, security cabin, CCTV surveillance." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Sizes", "content": "Plots range from 1,350 sq.ft (183 sq.yd) to 5,400 sq.ft (600 sq.yd)." }
        ],

        "gallery": [
            require("../images/projects/Plots/Fortune Retreat/gallery-1.png"),
            require("../images/projects/Plots/Fortune Retreat/gallery-2.png"),
            require("../images/projects/Plots/Fortune Retreat/gallery-3.png"),
            require("../images/projects/Plots/Fortune Retreat/gallery-4.png"),
            require("../images/projects/Plots/Fortune Retreat/gallery-5.png"),
            require("../images/projects/Plots/Fortune Retreat/gallery-6.png"),
        ],

        // "google_map": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3800!2d78.39!3d17.18"
    }
    ,
    {
        "id": "highgarden-plots",
        "project_name": "Highgarden",
        "title": "Highgarden Residential Plots",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Highgarden/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "30.86 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "174 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "320–978 sq.yd (3,200–9,000 sq.ft)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Starts Sep 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400005531" }
        ],

        "description": "Highgarden is a gated residential plot community by Urban Spaces in Aloor (Chevella), Hyderabad. Launched Nov 2022, it spans ~30.9 acres with 174 varied-sized plots (3,200–9,000 sq.ft), and amenities like a pool, courts, clubhouse, and 24×7 security — all backed by HMDA and RERA approvals.",

        "amenities": [
            { "name": "Gated Community with 24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "24×7 Water Supply", "icon": "fas fa-water" },
            { "name": "Swimming Pool", "icon": "fas fa-swimmer" },
            { "name": "Tennis Court", "icon": "fas fa-volleyball-ball" },
            { "name": "Cricket Pitch", "icon": "fas fa-cricket" },
            { "name": "Children’s Play Area", "icon": "fas fa-child" },
            { "name": "Amphitheatre", "icon": "fas fa-glass-cheers" },
            { "name": "Banquet Hall", "icon": "fas fa-building" },
            { "name": "Gymnasium", "icon": "fas fa-dumbbell" },
            { "name": "Skating Rink", "icon": "fas fa-skating" },
            { "name": "Senior Citizen Area", "icon": "fas fa-wheelchair" },
            { "name": "Yoga Deck", "icon": "fas fa-pray" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Landscaped Gardens & Tree Planting", "icon": "fas fa-tree" },
            { "name": "Internet / Wi‑Fi Provisions", "icon": "fas fa-wifi" },
            { "name": "Covered Visitor Parking", "icon": "fas fa-car" },
            { "name": "Internal Bitumen Roads & Footpaths", "icon": "fas fa-running" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground utilities (electric, water, telecom); 60′/40′ wide bitumen roads; peripheral compound walls." },
            { "icon": "fas fa-water", "title": "Water & Drainage", "content": "24×7 borewell + municipal water; overhead & sump tanks; rainwater harvesting; STP." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Boom-barrier entry, security cabin, CCTV surveillance." },
            { "icon": "fas fa-tree", "title": "Landscaping", "content": "Avenue plantation, green buffers, amphitheatre paddocks." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Variants", "content": "320 sq.yd (3,200 sq.ft) to 978 sq.yd (9,000 sq.ft)." }
        ],

        "floor_plans": [
            { "plot_area": "320 sq.yd", "availability": "Yes" },
            { "plot_area": "450 sq.yd", "availability": "Yes" },
            { "plot_area": "978 sq.yd", "availability": "Yes" }
        ],

        "gallery": [
            require("../images/projects/Plots/Highgarden/gallery-1.jpg"),
            require("../images/projects/Plots/Highgarden/gallery-2.jpg"),
            require("../images/projects/Plots/Highgarden/gallery-3.jpg"),
            require("../images/projects/Plots/Highgarden/gallery-4.jpg"),
            require("../images/projects/Plots/Highgarden/gallery-4.jpg"),
            require("../images/projects/Plots/Highgarden/gallery-4.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?...Aloor+Hyderabad"
    }
    ,
    {
        "id": "vertex-klr-giga-citi",
        "project_name": "KLR Giga Citi",
        "title": "Vertex KLR Giga Citi",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Vertex KLR Giga Citi/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "120 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "1,645 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "2,700–5,000 sq.ft (≈200–555 sq.yd)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Completed Jun 2025" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400002792, P02400004986" }
        ],

        "description": "Vertex KLR Giga Citi is an expansive integrated township at Tukkuguda, Hyderabad. Spread over 120 acres with 1,645 plots (2,700–5,000 sq.ft), it combines ultra-luxury and self-sufficiency: 6-hole executive golf course, education & health facilities, retail mall, sports academy, and eco-conscious infrastructure—all with excellent connectivity to airport, ORR, GACHIBOWLI & Financial District.",

        "amenities": [
            { "name": "6‑Hole Executive Golf Course", "icon": "fas fa-golf-ball" },
            { "name": "Multispecialty Hospital", "icon": "fas fa-clinic-medical" },
            { "name": "International School & Education Campus", "icon": "fas fa-school" },
            { "name": "Sports Academy", "icon": "fas fa-dumbbell" },
            { "name": "Retail Mall & Commercial Zone", "icon": "fas fa-shopping-basket" },
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "Restaurant", "icon": "fas fa-utensils" },
            { "name": "Lush Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Well‑connected Internal Roads", "icon": "fas fa-road" },
            { "name": "Storm‑water Drainage & STP", "icon": "fas fa-water" },
            { "name": "24×7 Water & Power Backup", "icon": "fas fa-bolt" },
            { "name": "CCTV Security & Boom‑barrier Entry", "icon": "fas fa-shield-alt" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground electric, water & telecom pipelines; 100‑150 ft wide ORR‑standard roads; stormwater & sewage systems with STP." },
            { "icon": "fas fa-border-style", "title": "Land & Layout", "content": "Vaastu‑aligned plots 200–555 sq.yd; peripheral tree plantation & central park zones." },
            { "icon": "fas fa-water", "title": "Water Supply", "content": "24×7 borewell + treated municipal water with sump & overhead tanks." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Boom‑barrier gated entry, CCTV perimeter surveillance, security cabin & street lighting." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Variants", "content": "Approx. 2,700, 4,500, 5,000 sq.ft plot typologies; vertical lot options up to 1,200 sq.yd." },
            { "icon": "fas fa-road", "title": "Connectivity", "content": "4 km to ORR, 10 min to Financial District, 25 min to Gachibowli, adjacent to RGIA‑view road." }
        ],

        "floor_plans": [
            { "plot_area": "2,700 sq.ft (≈200 sq.yd)", "availability": "Yes" },
            { "plot_area": "4,500 sq.ft (≈333 sq.yd)", "availability": "Yes" },
            { "plot_area": "5,000 sq.ft (≈400 sq.yd)", "availability": "Yes" }
        ],

        "gallery": [
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-1.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-2.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-3.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-4.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-5.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-6.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-7.jpg"),
            require("../images/projects/Plots/Vertex KLR Giga Citi/gallery-8.jpg"),
        ],

        // "google_map": "https://www.google.com/maps/embed?...Tukkuguda+Hyderabad"
    }
    ,
    {
        "id": "vertex-district-plots",
        "project_name": "Vertex District",
        "title": "Vertex District Villa Plots",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Vertex District/main.jpeg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "15.10 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "119 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "1,800 – 9,000 sq.ft (≈167 – 836 sq.yd)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Sep 2027" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400008942" }
        ],

        "description": "Vertex District is a futuristic gated plot community in Tukkuguda, Hyderabad. Located just 5 mins from ORR Exit 14 and 15 mins from RGI Airport, the project spans 15.1 acres with 119 villa plots, HMDA‑approved and bank‑financed. It offers connectivity to AI‑Fourth City, metro access, educational, healthcare and entertainment hubs — ideal for investment and lifestyle.",

        "amenities": [
            { "name": "Gated Entry with Security Cabin & Boom Barrier", "icon": "fas fa-shield-alt" },
            { "name": "24×7 Water Supply (borewell + municipal)", "icon": "fas fa-water" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "CCTV Surveillance & Solar‑panelled Street Lights", "icon": "fas fa-camera" },
            { "name": "Children’s Play Area & Aroma Garden", "icon": "fas fa-child" },
            { "name": "Avenue Tree Plantation & Landscaped Gardens", "icon": "fas fa-tree" },
            { "name": "Tennis Court & Box Cricket Net", "icon": "fas fa-volleyball-ball" },
            { "name": "Walking / Jogging / Cycling Paths", "icon": "fas fa-running" },
            { "name": "Vastu/Feng‑Shui compliant layout", "icon": "fas fa-chart-area" },
            { "name": "Compound Wall Around Perimeter", "icon": "fas fa-border-all" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground water, electricity, telecom; internal roads 150/100/80 ft wide; storm‑water drains." },
            { "icon": "fas fa-water", "title": "Water & Drainage", "content": "Continuous borewell + municipal water; sump & overhead tanks; STP & RWH systems." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Gated entry, boom barriers, CCTV, security cabin & street lighting." },
            { "icon": "fas fa-tree", "title": "Landscaping", "content": "Avenue tree plantation, aroma garden, landscaped central greens & play areas." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Variants", "content": "From 1,800 to ~9,000 sq.ft (167–836 sq.yd) to suit custom villa development." }
        ],

        "floor_plans": [
            { "plot_area": "1,800 sq.ft (~167 sq.yd)", "availability": "Yes" },
            { "plot_area": "2,500 sq.ft (~278 sq.yd)", "availability": "Yes" },
            { "plot_area": "9,000 sq.ft (~836 sq.yd)", "availability": "Yes" }
        ],

        "gallery": [
            require("../images/projects/Plots/Vertex District/gallery-1.jpg"),
            require("../images/projects/Plots/Vertex District/gallery-2.jpg"),
            require("../images/projects/Plots/Vertex District/gallery-3.jpg"),
            require("../images/projects/Plots/Vertex District/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Tukkuguda+Hyderabad"
    }
    ,
    {
        "id": "vivanta-green-meadows",
        "project_name": "VV Vivanta Green Meadows",
        "title": "VV Vivanta Green Meadows Plots",
        "category": "Plots",
        "location": "Hyderabad",
        "image": require("../images/projects/Plots/Vivanta Green Meadows/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "43.28 Acres" },
            { "icon": "fas fa-home", "title": "Units", "value": "343 Plots" },
            { "icon": "fas fa-door-open", "title": "Plot Sizes", "value": "924–5,400 sq.ft (≈85–502 sq.m)" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Dec 2026" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400008418" }
        ],

        "description": "VV Vivanta Green Meadows is an HMDA/RERA‑approved gated plot community at Shankarpally, Hyderabad. Spread across 43.28 acres, it offers 343 plots ranging from 924 to 5,400 sq.ft, with eco‑friendly infrastructure, underground utilities, and completion scheduled for December 2026.",

        "amenities": [
            { "name": "Gated Entrance & Boom Barriers", "icon": "fas fa-shield-alt" },
            { "name": "24×7 Water Supply (Borewell & Municipal)", "icon": "fas fa-water" },
            { "name": "Street Lighting & Avenue Plantation", "icon": "fas fa-lightbulb" },
            { "name": "Underground Electricity & Drainage", "icon": "fas fa-plug" },
            { "name": "Storm Water Drains", "icon": "fas fa-water" },
            { "name": "Landscaped Garden", "icon": "fas fa-tree" },
            { "name": "Compound Walls & Footpaths", "icon": "fas fa-border-all" },
            { "name": "Clubhouse", "icon": "fas fa-building" },
            { "name": "CCTV Surveillance", "icon": "fas fa-video" },
            { "name": "Sewage Treatment Plant", "icon": "fas fa-recycle" },
            { "name": "Fire-Fighting Systems", "icon": "fas fa-fire-extinguisher" },
            { "name": "Vaastu‑compliant Layout", "icon": "fas fa-chart-area" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Infrastructure", "content": "Underground electric, water, telecom; internal roads (60′/40′/30′); stormwater drains." },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Borewell + municipal water, sump & overhead reservoirs, rainwater harvesting, STP." },
            { "icon": "fas fa-lightbulb", "title": "Lighting & Electrical", "content": "Street lights, energy‑efficient systems; underground supply with meter rooms." },
            { "icon": "fas fa-tree", "title": "Greenscape", "content": "Avenue plantation, landscaped central greens, peripheral compound wall." },
            { "icon": "fas fa-drafting-compass", "title": "Plot Variants", "content": "924 – 5,400 sq.ft (85–502 sq.m) with corner & Vaastu‑aligned options." }
        ],

        "floor_plans": [
            { "plot_area": "924 sq.ft", "availability": "Yes" },
            { "plot_area": "1,677 sq.ft", "availability": "Yes" },
            { "plot_area": "5,400 sq.ft", "availability": "Yes" }
        ],

        "gallery": [
            require("../images/projects/Plots/Vivanta Green Meadows/gallery-1.jpg"),
            require("../images/projects/Plots/Vivanta Green Meadows/gallery-2.jpg"),
            require("../images/projects/Plots/Vivanta Green Meadows/gallery-3.jpg"),
            require("../images/projects/Plots/Vivanta Green Meadows/gallery-4.jpg")
        ],

        // "google_map": "https://www.google.com/maps/embed?...Shankarpally+Hyderabad"
    }
    ,
    // Commercials
    {
        id: "abinandana-emerald",
        project_name: "Abinandana Emerald",
        category: "Commercial",
        title: "Abinandana Emerald – Commercial Office & Retail Space",
        location: "Hyderabad",
        image: require("../images/projects/commercials/abhinandan-emirald/abhinandan-emirald.png"),
        "description": " Abinandana Emerald is a premium commercial project in Manikonda, Hyderabad, offering well-planned retail and office spaces. Spread over 1.45 acres with 100 units, it features modern design, excellent connectivity, and essential business amenities — ideal for startups, brands, and investors."
        ,
        project_overview: [
            { icon: "fas fa-vector-square", title: "Project Size", value: "1–1.45 Acres" },
            { icon: "fas fa-home", title: "Units", value: "100" },
            { icon: "fas fa-building", title: "Towers", value: "1" },
            { icon: "fas fa-layer-group", title: "Launch Date", value: "Jun 2023" },
            { icon: "fas fa-hourglass-end", title: "Possession", value: "Dec 2025" }
        ],

        amenities: [
            { name: "Reserved Parking", icon: "fas fa-parking" },
            { name: "24/7 Security", icon: "fas fa-shield-alt" },
            { name: "Wet Pantry / Cafeteria", icon: "fas fa-coffee" },
            { name: "Covered Parking", icon: "fas fa-car-side" },
            { name: "High Visibility Location", icon: "fas fa-map-marker-alt" }
        ],

        specifications: [
            { icon: "fas fa-building", title: "Type", content: "Commercial Office & Retail Spaces" },
            { icon: "fas fa-city", title: "Location", content: "Manikonda, Hyderabad" },
            { icon: "fas fa-id-card", title: "Developer", content: "Abinandana Infra Realty LLP" },
            { icon: "fas fa-calendar", title: "Possession", content: "Expected Dec 2025" },
            { icon: "fas fa-expand-arrows-alt", title: "Unit Size", content: "From 4,000 sq.ft" }
        ],

        gallery: [
            require("../images/projects/commercials/abhinandan-emirald/gallery-1.jpg"),
            require("../images/projects/commercials/abhinandan-emirald/gallery-2.jpg"),
            require("../images/projects/commercials/abhinandan-emirald/gallery-3.jpg"),
            require("../images/projects/commercials/abhinandan-emirald/gallery-4.jpg"),
        ],

        google_map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.571211204348!2d78.36008407432843!3d17.432166501312113!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb951cc98404bb%3A0x17bd70f88466519d!2sManikonda%2C%20Hyderabad!5e0!3m2!1sen!2sin!4v0000000000000"
    },
    {
        "id": "poulomi-infinity",
        "project_name": "Poulomi Infinity",
        "title": "Poulomi Infinity IT/Commercial Tower",
        "category": "Commercial",
        "location": "Hyderabad",
        "image": require("../images/projects/commercials/Poulomi Infinity/main.jpg"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "4.6 Acres" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "22 Floors" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Mar 2028" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "P02400004425" }
        ],

        "description": "Poulomi Infinity is a Grade‑A IT/ITES commercial tower located at the Golden Mile junction of Kokapet’s Outer Ring Road in Hyderabad. Spread over 4.6 acres, this gated, high‑rise workspace is designed with modern offices, retail offerings, and smart-building infrastructure to support businesses seeking premium office space.",

        "amenities": [
            { "name": "High‑Speed Elevators", "icon": "fas fa-elevator" },
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Fire‑Fighting Systems", "icon": "fas fa-fire-extinguisher" },
            { "name": "Rainwater Harvesting & STP", "icon": "fas fa-water" },
            { "name": "Sewage Treatment Plant", "icon": "fas fa-recycle" },
            { "name": "Lift Access & Video Door‑Phone", "icon": "fas fa-door-closed" },
            { "name": "Waste Management", "icon": "fas fa-trash-alt" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "Water Softener Plant", "icon": "fas fa-water" },
            { "name": "Green Building Features", "icon": "fas fa-leaf" }
        ],

        "specifications": [
            { "icon": "fas fa-building", "title": "Structure", "content": "Earthquake‑resistant RCC frame with modern façade and smart infrastructure." },
            { "icon": "fas fa-border-style", "title": "Flooring & Lobby", "content": "Marble-clad lobby with premium tiling in common areas." },
            { "icon": "fas fa-bolt", "title": "Electrical", "content": "3‑phase power, concealed wiring, modular switches, high-speed lifts." },
            { "icon": "fas fa-water", "title": "Water Management", "content": "Borewell + municipal supply; rainwater harvesting; STP." },
            { "icon": "fas fa-fire-extinguisher", "title": "Safety", "content": "Advanced fire-fighting systems, CCTV surveillance, gated entry." },
            { "icon": "fas fa-video", "title": "Smart Features", "content": "Video door phones, automated energy systems, intercom." },
            { "icon": "fas fa-drafting-compass", "title": "Unit Sizes", "content": "Flexible office spaces: 1,393–10,000 sq.ft." }
        ],

        "gallery": [
            require("../images/projects/commercials/Poulomi Infinity/gallery-1.jpg"),
            require("../images/projects/commercials/Poulomi Infinity/gallery-2.jpg"),
            require("../images/projects/commercials/Poulomi Infinity/gallery-3.jpg"),
            require("../images/projects/commercials/Poulomi Infinity/gallery-4.jpg"),
        ],

        "floor_plans": [
            { "unit_size": "1,393 sq.ft", "availability": "Yes" },
            { "unit_size": "5,000 sq.ft", "availability": "Yes" },
            { "unit_size": "10,000 sq.ft", "availability": "Yes" }
        ],

        // "google_map": "https://www.google.com/maps/embed?...Kokapet+Hyderabad"
    },
    {
        "id": "raichandani-hq",
        "project_name": "Raichandani HQ",
        "title": "Raichandani HQ – Premium Commercial Office Space",
        "category": "Commercial",
        "location": "Hyderabad",
        "image": require("../images/projects/commercials/Raichandani HQ/main.png"),

        "project_overview": [
            { "icon": "fas fa-vector-square", "title": "Land Area", "value": "Approx. 3 Acres" },
            { "icon": "fas fa-layer-group", "title": "Floors", "value": "G+15 Floors" },
            { "icon": "fas fa-clock", "title": "Possession", "value": "Under Construction" },
            { "icon": "fas fa-id-card", "title": "RERA ID", "value": "TBD" }
        ],

        "description": "Raichandani HQ is a premium-grade commercial tower situated in the heart of the financial district, offering state-of-the-art infrastructure and strategic connectivity to IT hubs, metro stations, and residential neighborhoods. With meticulously designed floor plans and best-in-class specifications, it's crafted for modern businesses.",

        "amenities": [
            { "name": "24×7 Security & CCTV", "icon": "fas fa-shield-alt" },
            { "name": "Fire‑Fighting Systems", "icon": "fas fa-fire-extinguisher" },
            { "name": "Centralized HVAC", "icon": "fas fa-wind" },
            { "name": "High-Speed Elevators", "icon": "fas fa-elevator" },
            { "name": "Landscaped Terrace", "icon": "fas fa-tree" },
            { "name": "Waterproofing & Drainage", "icon": "fas fa-water" },
            { "name": "Power Backup", "icon": "fas fa-bolt" },
            { "name": "Plumbing & Sanitation", "icon": "fas fa-faucet" },
            { "name": "Fitness & Wellness Zones", "icon": "fas fa-dumbbell" },
            { "name": "Multipurpose Hall", "icon": "fas fa-users" }
        ],

        "specifications": [
            {
                "icon": "fas fa-building",
                "title": "Foundation & Structure",
                "content": "RCC framed structure with post-tension slabs, designed without beams; basement parking for 3 levels; designed as per A-grade commercial standards."
            },
            {
                "icon": "fas fa-th",
                "title": "Super Structure",
                "content": "Table moulded concrete and fly ash blocks with first-class cement masonry."
            },
            {
                "icon": "fas fa-fill-drip",
                "title": "Plastering",
                "content": "20mm thick double coat plastering for a smooth finish."
            },
            {
                "icon": "fas fa-border-style",
                "title": "Facade",
                "content": "Unitized glazing with high-performance coated glass (low-E) and ACP for energy efficiency."
            },
            {
                "icon": "fas fa-paint-roller",
                "title": "Painting",
                "content": "Lappam finish with primer and acrylic emulsion paint."
            },
            {
                "icon": "fas fa-border-all",
                "title": "False Ceiling",
                "content": "Gypsum board or grid ceiling in all common areas as per design."
            },
            {
                "icon": "fas fa-columns",
                "title": "Flooring",
                "content": "Marble/vitrified in common areas; granite in staircases; VDF in parking; vitrified + granite in washrooms."
            },
            {
                "icon": "fas fa-bolt",
                "title": "Electrical",
                "content": "100% power backup with transformers and D.G. sets; modular switches; underground cabling."
            },
            {
                "icon": "fas fa-wind",
                "title": "HVAC",
                "content": "Centralized HVAC with 100% backup for shops, atrium, and common zones."
            },
            {
                "icon": "fas fa-faucet",
                "title": "Plumbing & Sanitation",
                "content": "Hydropneumatic pumps; underground sumps and overhead tanks; drainage and STP included."
            },
            {
                "icon": "fas fa-elevator",
                "title": "Lifts",
                "content": "12 high-speed lifts by Mitsubishi/Kone for office towers."
            },
            {
                "icon": "fas fa-fire-extinguisher",
                "title": "Fire Safety",
                "content": "Sprinklers, fire alarms, underground tanks, and refuge areas as per Grade-A fire standards."
            },
            {
                "icon": "fas fa-tree",
                "title": "Landscaping",
                "content": "Planned green zones and landscaped terrace with aesthetic enhancements."
            },
            {
                "icon": "fas fa-map-marker-alt",
                "title": "Nearby Residential Projects",
                "content": "My Home Avatar (5 mins), RajaPushpa (5 mins), Legend Chimes (7 mins), Eka One By Raichandani (10 mins)."
            },
            {
                "icon": "fas fa-briefcase",
                "title": "Nearby Commercial Projects",
                "content": "Kokapet One (6 mins), Multiplex Mall (1 min), Wipro Circle (18 mins)."
            },
            {
                "icon": "fas fa-road",
                "title": "Connectivity",
                "content": "Gachibowli (17 mins), Nehru ORR (5 mins), Raidurgam Metro (15 mins), RGIA Airport (25 mins)."
            },
            {
                "icon": "fas fa-landmark",
                "title": "Landmarks",
                "content": "Gandipet Park (11 mins), Gandipet Lake (12 mins), Ocean Park (7 mins), CBIT (10 mins), Rockwell International School (7 mins)."
            },
            {
                "icon": "fas fa-star",
                "title": "Key Highlights",
                "content": "Amazon Campus & WaveRock SPZ, Wipro Main Circle, Golkonda Fort, Financial District, My Home Avatar, Mehdipatnam."
            }
        ],

        "gallery": [
            require("../images/projects/commercials/Raichandani HQ/gallery-1.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-2.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-3.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-4.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-4.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-4.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-4.png"),
            require("../images/projects/commercials/Raichandani HQ/gallery-4.png"),
        ],

        "floor_plans": [
            { "unit_size": "2,000 sq.ft", "availability": "Yes" },
            { "unit_size": "5,500 sq.ft", "availability": "Yes" },
            { "unit_size": "12,000 sq.ft", "availability": "On Request" }
        ]

        // "google_map": "https://www.google.com/maps/embed?...Raichandani+HQ+Hyderabad"
    }





    ///////////////////////////

    // {
    //     "id": "abhinandan",
    //     "title": "Abhinandana Infra - Emerald Commercial",
    //     "image": require("../images/projects/abhinandan.jpeg"),
    //     "description": "A premium commercial space located in the bustling area of Manikonda with easy access to urban amenities.",
    //     "mapLink": "https://maps.google.com/?q=Manikonda,Hyderabad",
    //     "features": [
    //         "Prime commercial location",
    //         "Modern infrastructure",
    //         "Proximity to business hubs"
    //     ],
    //     "location": "Manikonda, Hyderabad, Telangana"
    // },
    // {
    //     "id": "anvita-ivana",
    //     "title": "Anvita Ivana",
    //     "image": require("../images/projects/Anvita-Ivana.jpg"),
    //     "description": "Anvita Ivana offers contemporary living spaces in Kollur with essential amenities for modern living.",
    //     "mapLink": "https://maps.google.com/?q=Kollur,Hyderabad",
    //     "features": [
    //         "Affordable luxury apartments",
    //         "Lush green surroundings",
    //         "Close to tech hubs"
    //     ],
    //     "location": "Kollur, Hyderabad, Telangana"
    // },
    // {
    //     "id": "anvita-high-9",
    //     "title": "Anvita High 9",
    //     "image": require("../images/projects/Anvita-High-9.jpg"),
    //     "description": "Anvita High 9 provides modern residential spaces in Tellapur with a peaceful environment.",
    //     "mapLink": "https://maps.google.com/?q=Tellapur,Hyderabad",
    //     "features": [
    //         "Modern residential units",
    //         "Green landscapes",
    //         "Proximity to IT hubs"
    //     ],
    //     "location": "Tellapur, Hyderabad, Telangana"
    // },
    // {
    //     "id": "aparna-one",
    //     "title": "Aparna One",
    //     "image": require("../images/projects/Aparna-One.png"),
    //     "description": "Aparna One is a luxury high-rise residential project in the prime area of Shaikpet, offering scenic views and exclusive amenities.",
    //     "mapLink": "https://maps.google.com/?q=Shaikpet,Hyderabad",
    //     "features": [
    //         "High-rise luxury apartments",
    //         "Exclusive amenities",
    //         "Scenic city views"
    //     ],
    //     "location": "Shaikpet, Hyderabad, Telangana"
    // },
    // {
    //     "id": "aparna-cyber-heights",
    //     "title": "Aparna Cyber Heights",
    //     "image": require("../images/projects/Aparna-CyberHeights.png"),
    //     "description": "Luxury residential project near Osman Sagar with eco-friendly features and spacious apartments.",
    //     "mapLink": "https://maps.google.com/?q=Osman+Sagar,Hyderabad",
    //     "features": [
    //         "Sustainable design",
    //         "Spacious apartments",
    //         "Nature proximity"
    //     ],
    //     "location": "Osman Sagar, Hyderabad, Telangana"
    // },
    // {
    //     "id": "aparna-zenon",
    //     "title": "Aparna Zenon",
    //     "image": require("../images/projects/Aparna-Zenon.jpg"),
    //     "description": "High-end apartments in Nanakramguda providing luxurious and secure living with easy access to business hubs.",
    //     "mapLink": "https://maps.google.com/?q=Nanakramguda,Hyderabad",
    //     "features": [
    //         "Proximity to IT hubs",
    //         "High-end amenities",
    //         "Secure environment"
    //     ],
    //     "location": "Nanakramguda, Hyderabad, Telangana"
    // },
    // {
    //     "id": "aspire-realty-advaith-prem",
    //     "title": "Aspire Realty - Advaith Prem",
    //     "image": require("../images/projects/AspireRealityAdvaithPrem.jpg"),
    //     "description": "Spacious residential plots on Srisailam Highway, ideal for investment and future development.",
    //     "mapLink": "https://maps.google.com/?q=Srisailam+Highway,Hyderabad",
    //     "features": [
    //         "Spacious plots",
    //         "Good connectivity",
    //         "Ideal for investment"
    //     ],
    //     "location": "Srisailam Highway, Hyderabad, Telangana"
    // },
    // {
    //     "id": "aspire-realty-arogya",
    //     "title": "Aspire Realty - Arogya",
    //     "image": require("../images/projects/Aspire Realty - Arogya.jpg"),
    //     "description": "Residential plots in Karkalpahad, designed for a peaceful and healthy living environment.",
    //     "mapLink": "https://maps.google.com/?q=Karkalpahad,Hyderabad",
    //     "features": [
    //         "Health-oriented design",
    //         "Spacious plots",
    //         "Green surroundings"
    //     ],
    //     "location": "Karkalpahad, Hyderabad, Telangana"
    // },
    // {
    //     "id": "aspire-realty-avatar-3d",
    //     "title": "Aspire Realty - Avatar 3D",
    //     "image": require("../images/projects/Aspire Realty - Avatar 3D.jpg"),
    //     "description": "Modern 3D-designed residential plots along the Srisailam Highway in Kadthal.",
    //     "mapLink": "https://maps.google.com/?q=Kadthal,Srisailam+Highway,Hyderabad",
    //     "features": [
    //         "3D architecture",
    //         "Modern amenities",
    //         "Connectivity to Hyderabad"
    //     ],
    //     "location": "Kadthal, Srisailam Highway, Hyderabad, Telangana"
    // },
    // {
    //     "id": "auro-realty-the-pearl",
    //     "title": "Auro Realty - The Pearl",
    //     "image": require("../images/projects/Auro Realty - The Pear.jpg"),
    //     "description": "Luxury residences in Hi-Tech City by Auro Realty, situated near major technology firms.",
    //     "mapLink": "https://maps.google.com/?q=Hi-Tech+City,Hyderabad",
    //     "features": [
    //         "Luxury residences",
    //         "Located in Hi-Tech City",
    //         "Proximity to tech companies"
    //     ],
    //     "location": "Hi-Tech City, Hyderabad, Telangana"
    // },
    // {
    //     "id": "auro-realty-the-regent",
    //     "title": "Auro Realty - The Regent",
    //     "location": "Kondapur, Hyderabad",
    //     "location": "Kondapur, Hyderabad, India",
    //     "description": "Premium apartments in Kondapur with upscale living spaces and modern amenities.",
    //     "features": [
    //         "Upscale apartments",
    //         "Close to schools and shopping centers",
    //         "Modern design"
    //     ],
    //     "image": require("../images/projects/Auro Realty - The Regent.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kondapur,Hyderabad"
    // },
    // {
    //     "id": "brigade-hyderabad-world-trade-center",
    //     "title": "Brigade - Hyderabad World Trade Center",
    //     "location": "Neopolis, Kokapet, Hyderabad",
    //     "location": "Neopolis, Kokapet, Hyderabad, India",
    //     "description": "World-class commercial space by Brigade, located in Neopolis, Kokapet.",
    //     "features": [
    //         "World Trade Center amenities",
    //         "Prime business location",
    //         "High-tech infrastructure"
    //     ],
    //     "image": require("../images/projects/Brigade - Hyderabad World Trade Center.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Neopolis,Kokapet,Hyderabad"
    // },
    // {
    //     "id": "candeur-crescent",
    //     "title": "Candeur Crescent",
    //     "location": "Lingampally, Hyderabad",
    //     "location": "Lingampally, Hyderabad, India",
    //     "description": "Residential project in Lingampally offering modern apartments and amenities.",
    //     "features": [
    //         "Affordable luxury",
    //         "Prime location",
    //         "Modern amenities"
    //     ],
    //     "image": require("../images/projects/Candeur Crescent.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Lingampally,Hyderabad"
    // },
    // {
    //     "id": "candeur-lakescape",
    //     "title": "Candeur Lakescape",
    //     "location": "Kondapur, Hyderabad",
    //     "location": "Kondapur, Hyderabad, India",
    //     "description": "Modern apartments at Candeur Lakescape, offering tranquil lakeside views.",
    //     "features": [
    //         "Lakeside views",
    //         "Modern architecture",
    //         "Prime location"
    //     ],
    //     "image": require("../images/projects/Candeur Lakescape.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kondapur,Hyderabad"
    // },
    // {
    //     "id": "candeur-skyline",
    //     "title": "Candeur Skyline",
    //     "location": "Financial District, Hyderabad",
    //     "location": "Financial District, Hyderabad, India",
    //     "description": "High-rise apartments in the Financial District with scenic city views.",
    //     "features": [
    //         "City views",
    //         "Proximity to business centers",
    //         "High-rise living"
    //     ],
    //     "image": require("../images/projects/Candeur Skyline.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Financial+District,Hyderabad"
    // },
    // {
    //     "id": "cybercity-westbrook",
    //     "title": "Cybercity Westbrook",
    //     "location": "Kokapet, Hyderabad",
    //     "location": "Kokapet, Hyderabad, India",
    //     "description": "Cybercity Westbrook offers luxury apartments with top-notch amenities.",
    //     "features": [
    //         "Luxury apartments",
    //         "Top-notch amenities",
    //         "Close to business hubs"
    //     ],
    //     "image": require("../images/projects/Cybercity Westbrook.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "the-blue-oak-trilight",
    //     "title": "The Blue OAK - The Trilight",
    //     "location": "Kokapet, Hyderabad",
    //     "location": "Kokapet, Hyderabad, India",
    //     "description": "A luxury residential project offering a blend of style and comfort with scenic views.",
    //     "features": [
    //         "Luxury residences",
    //         "Modern architecture",
    //         "Scenic views"
    //     ],
    //     "image": require("../images/projects/The Blue OAK - The Trilight.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "dsr-altitude",
    //     "title": "DSR Altitude",
    //     "location": "Osman Sagar, Hyderabad",
    //     "location": "Osman Sagar, Hyderabad, India",
    //     "description": "Luxurious high-rise apartments near Osman Sagar with scenic views.",
    //     "features": [
    //         "Scenic views",
    //         "High-rise buildings",
    //         "Luxurious amenities"
    //     ],
    //     "image": require("../images/projects/DSR Altitude.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Osman+Sagar,Hyderabad"
    // },
    // {
    //     "id": "dsr-gopanpally",
    //     "title": "DSR Gopanpally",
    //     "location": "Gopanpally, Hyderabad",
    //     "location": "Gopanpally, Hyderabad, India",
    //     "description": "DSR Gopanpally offers luxurious living spaces in the serene locality of Gopanpally.",
    //     "features": [
    //         "Tranquil surroundings",
    //         "Spacious homes",
    //         "Modern amenities"
    //     ],
    //     "image": require("../images/projects/DSR Gopanpally.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Gopanpally,Hyderabad"
    // },
    // {
    //     "id": "dsr-skymarq",
    //     "title": "DSR SkyMarq",
    //     "location": "Financial District, Hyderabad",
    //     "location": "Financial District, Hyderabad, India",
    //     "description": "A high-end residential project offering modern living in the heart of the Financial District.",
    //     "features": [
    //         "City views",
    //         "High-end living",
    //         "Close to major business centers"
    //     ],
    //     "image": require("../images/projects/DSR SkyMarq.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Financial+District,Hyderabad"
    // },
    // {
    //     "id": "dsr-the-classe",
    //     "title": "DSR - The Classe",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "DSR - The Classe offers high-end apartments with top-class amenities in Kokapet, Hyderabad.",
    //     "features": [
    //         "Luxury apartments",
    //         "Modern amenities",
    //         "Close to IT hubs"
    //     ],
    //     "image": require("../images/projects/DSR - The Classe.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "aika-super-luxe-villas",
    //     "title": "AIKA Super-Luxe Villas",
    //     "location": "Gandipet, Hyderabad",
    //     "description": "AIKA Super-Luxe Villas offer opulent living spaces in the serene surroundings of Gandipet.",
    //     "features": [
    //         "Super-luxury villas",
    //         "Lush green surroundings",
    //         "Private pools"
    //     ],
    //     "image": require("../images/projects/AIKA Super-Luxe Villas.jpeg"),
    //     "mapLink": "https://maps.google.com/?q=Gandipet,Hyderabad"
    // },
    // {
    //     "id": "frontline-seven",
    //     "title": "Frontline Seven",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "Frontline Seven offers modern residential spaces in Kokapet, an ideal location for professionals and families.",
    //     "features": [
    //         "Modern design",
    //         "Luxury amenities",
    //         "Prime location"
    //     ],
    //     "image": require("../images/projects/Frontline Seven.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "greenmark-mayfair-sunrise",
    //     "title": "Greenmark Developers - Mayfair Sunrise",
    //     "location": "Kollur, Hyderabad",
    //     "description": "Mayfair Sunrise by Greenmark Developers offers serene living spaces with modern amenities in Kollur.",
    //     "features": [
    //         "Modern amenities",
    //         "Spacious apartments",
    //         "Lush green surroundings"
    //     ],
    //     "image": require("../images/projects/Greenmark Developers - Mayfair Sunrise.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kollur,Hyderabad"
    // },
    // {
    //     "id": "hallmark-natures-nest",
    //     "title": "Hallmark - Nature's Nest",
    //     "location": "Kollur, Hyderabad",
    //     "description": "Nature's Nest offers spacious and eco-friendly living spaces in the tranquil area of Kollur.",
    //     "features": [
    //         "Eco-friendly design",
    //         "Ample green space",
    //         "Close to nature"
    //     ],
    //     "image": require("../images/projects/Hallmark - Nature's Nest.png"),
    //     "mapLink": "https://maps.google.com/?q=Kollur,Hyderabad"
    // },
    // {
    //     "id": "kgr-fortune-anandam-villas",
    //     "title": "KGR Fortune - Anandam Villas",
    //     "location": "Tukkuguda, Hyderabad",
    //     "description": "Anandam Villas offers luxurious living spaces with a blend of comfort and elegance in Tukkuguda.",
    //     "features": [
    //         "Luxury villas",
    //         "Spacious design",
    //         "Peaceful surroundings"
    //     ],
    //     "image": require("../images/projects/KGR Fortune - Anandam Villas.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Tukkuguda,Hyderabad"
    // },
    // {
    //     "id": "unknown-project-kukatpally",
    //     "title": "(Unknown Project)",
    //     "location": "Kukatpally, Hyderabad",
    //     "description": "This project in Kukatpally offers high-end residential living in one of Hyderabad’s most vibrant localities.",
    //     "features": [
    //         "High-end apartments",
    //         "Proximity to commercial areas",
    //         "Modern amenities"
    //     ],
    //     "image": require("../images/projects/Urbanspaces - HMDA Plotting.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kukatpally,Hyderabad"
    // },
    // {
    //     "id": "lansum-elena-residences",
    //     "title": "Lansum Elena Residences",
    //     "location": "Jubilee Hills, Hyderabad",
    //     "description": "Lansum Elena Residences offer luxurious living spaces in the posh locality of Jubilee Hills.",
    //     "features": [
    //         "Luxury apartments",
    //         "Prime location",
    //         "Modern amenities"
    //     ],
    //     "image": require("../images/projects/Lansum Elena Residences.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Jubilee+Hills,Hyderabad"
    // },
    // {
    //     "id": "lenovor-egeira",
    //     "title": "Lenovor Egeira",
    //     "location": "Kollur, Hyderabad",
    //     "description": "Lenovor Egeira provides premium residential living spaces in the rapidly developing area of Kollur.",
    //     "features": [
    //         "Premium apartments",
    //         "Proximity to tech hubs",
    //         "Spacious design"
    //     ],
    //     "image": require("../images/projects/Lenovor Egeira.png"),
    //     "mapLink": "https://maps.google.com/?q=Kollur,Hyderabad"
    // },
    // {
    //     "id": "my-home-apas",
    //     "title": "My Home APAS",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "My Home APAS offers modern living spaces in Kokapet, providing easy access to commercial hubs.",
    //     "features": [
    //         "Luxury apartments",
    //         "Proximity to major business centers",
    //         "Modern amenities"
    //     ],
    //     "image": require("../images/projects/My Home APAS.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "my-home-grava",
    //     "title": "My Home Grava",
    //     "location": "Neopolis, Kokapet, Hyderabad",
    //     "description": "My Home Grava offers a premium lifestyle with high-rise apartments in Neopolis, Kokapet.",
    //     "features": [
    //         "High-rise living",
    //         "Luxury amenities",
    //         "Proximity to commercial hubs"
    //     ],
    //     "image": require("../images/projects/My Home Grava.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Neopolis,Kokapet,Hyderabad"
    // },
    // {
    //     "id": "my-home-nishada",
    //     "title": "My Home Nishada",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "My Home Nishada offers an exceptional living experience with luxury homes and modern amenities.",
    //     "features": [
    //         "Spacious apartments",
    //         "Modern design",
    //         "Prime location"
    //     ],
    //     "image": require("../images/projects/My Home Nishada.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "myscape-songs-of-the-sun",
    //     "title": "Myscape - Songs of the Sun",
    //     "location": "Financial District, Hyderabad",
    //     "description": "Myscape - Songs of the Sun offers luxury apartments with scenic views in the Financial District.",
    //     "features": [
    //         "Luxury apartments",
    //         "City views",
    //         "Close to business hubs"
    //     ],
    //     "image": require("../images/projects/Myscape - Songs of the Sun.jpeg"),
    //     "mapLink": "https://maps.google.com/?q=Financial+District,Hyderabad"
    // },
    // {
    //     "id": "navanaami-megaleio",
    //     "title": "Navanaami Megaleio",
    //     "location": "Appa Junction, Kokapet, Hyderabad",
    //     "description": "Navanaami Megaleio offers modern living spaces with a unique design and lifestyle amenities.",
    //     "features": [
    //         "Modern design",
    //         "Luxury amenities",
    //         "Proximity to tech hubs"
    //     ],
    //     "image": require("../images/projects/Navanaami Megaleio.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Appa+Junction,Kokapet,Hyderabad"
    // },
    // {
    //     "id": "poulomi-palazzo",
    //     "title": "Poulomi Palazzo",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "Poulomi Palazzo offers high-end luxury apartments with state-of-the-art amenities in Kokapet.",
    //     "features": [
    //         "Luxury apartments",
    //         "Modern amenities",
    //         "Prime location"
    //     ],
    //     "image": require("../images/projects/Poulomi Palazzo.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "praera-rnp-stellar",
    //     "title": "Praera RNP Stellar #1",
    //     "location": "Kondapur, Hyderabad",
    //     "description": "Praera RNP Stellar #1 offers premium apartments in the Kondapur area, close to major business hubs.",
    //     "features": [
    //         "Luxury apartments",
    //         "Modern design",
    //         "Prime location"
    //     ],
    //     "image": require("../images/projects/Praera RNP Stellar.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kondapur,Hyderabad"
    // },
    // {
    //     "id": "prestige-beverly-hills-kokapet",
    //     "title": "Prestige Beverly Hills",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "Prestige Beverly Hills offers luxurious living spaces in the prime area of Kokapet, with modern amenities.",
    //     "features": [
    //         "Luxury apartments",
    //         "Prime location",
    //         "Modern amenities"
    //     ],
    //     "image": require("../images/projects/Prestige Beverly Hills.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "prestige-clairemont-kokapet",
    //     "title": "Prestige Clairemont",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "Prestige Clairemont offers high-end residences in Kokapet with exceptional design and amenities.",
    //     "features": [
    //         "High-end residences",
    //         "Exclusive design",
    //         "Top-tier amenities"
    //     ],
    //     "image": require("../images/projects/Prestige Clairemont.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "raghava-iris-raidurgam",
    //     "title": "Raghava Iris",
    //     "location": "Raidurgam, Hyderabad",
    //     "description": "Raghava Iris offers a premium lifestyle in the heart of Raidurgam with modern facilities.",
    //     "features": [
    //         "Premium lifestyle",
    //         "Central location",
    //         "Modern facilities"
    //     ],
    //     "image": require("../images/projects/Raghava Iris.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Raidurgam,Hyderabad"
    // },
    // {
    //     "id": "raghava-sage-kollur",
    //     "title": "Raghava Sage",
    //     "location": "Kollur, Hyderabad",
    //     "description": "Raghava Sage provides luxurious residences in the tranquil locality of Kollur.",
    //     "features": [
    //         "Luxurious residences",
    //         "Tranquil environment",
    //         "Top amenities"
    //     ],
    //     "image": require("../images/projects/Raghava Sage.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kollur,Hyderabad"
    // },
    // {
    //     "id": "raghava-wave-tellapur",
    //     "title": "Raghava Wave",
    //     "location": "Tellapur, Hyderabad",
    //     "description": "Raghava Wave is a premium residential complex offering a blend of modern amenities and serene surroundings in Tellapur.",
    //     "features": [
    //         "Premium residential complex",
    //         "Modern amenities",
    //         "Serene surroundings"
    //     ],
    //     "image": require("../images/projects/Raghava Wave.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Tellapur,Hyderabad"
    // },
    // {
    //     "id": "raha-tattva-vanya-koyyalagudem",
    //     "title": "Raha Tattva - VANYA",
    //     "location": "Koyyalagudem, Hyderabad",
    //     "description": "Raha Tattva - Vanya offers high-end residential units in Koyyalagudem, blending luxury and tranquility.",
    //     "features": [
    //         "High-end units",
    //         "Tranquil location",
    //         "Luxury living"
    //     ],
    //     "image": require("../images/projects/Raha Tattva - VANYA.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Koyyalagudem,Hyderabad"
    // },
    // {
    //     "id": "rajapushpa-casa-luxura-neopolis-kokapet",
    //     "title": "Rajapushpa Casa Luxura",
    //     "location": "Neopolis, Kokapet, Hyderabad",
    //     "description": "Rajapushpa Casa Luxura offers luxurious living with premium amenities in Neopolis, Kokapet.",
    //     "features": [
    //         "Luxurious living",
    //         "Premium amenities",
    //         "Exclusive location"
    //     ],
    //     "image": require("../images/projects/Rajapushpa Casa Luxura.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Neopolis,Kokapet,Hyderabad"
    // },
    // {
    //     "id": "rajapushpa-infina-manchirevula",
    //     "title": "Rajapushpa Infina",
    //     "location": "Manchirevula, Hyderabad",
    //     "description": "Rajapushpa Infina offers upscale residences in the peaceful locality of Manchirevula.",
    //     "features": [
    //         "Upscale residences",
    //         "Peaceful locality",
    //         "Modern features"
    //     ],
    //     "image": require("../images/projects/Rajapushpa Infina.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Manchirevula,Hyderabad"
    // },
    // {
    //     "id": "rajapushpa-pristinia-financial-district",
    //     "title": "Rajapushpa Pristinia",
    //     "location": "Financial District, Hyderabad",
    //     "description": "Rajapushpa Pristinia offers exclusive apartments in the Financial District with unmatched amenities.",
    //     "features": [
    //         "Exclusive apartments",
    //         "Unmatched amenities",
    //         "Prime business district"
    //     ],
    //     "image": require("../images/projects/Rajapushpa Pristinia.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Financial District,Hyderabad"
    // },
    // {
    //     "id": "rajapushpa-provincia-nanakramguda",
    //     "title": "Rajapushpa Provincia",
    //     "location": "Nanakramguda, Hyderabad",
    //     "description": "Rajapushpa Provincia offers premium living in Nanakramguda with all modern amenities.",
    //     "features": [
    //         "Premium living",
    //         "Modern amenities",
    //         "Exclusive location"
    //     ],
    //     "image": require("../images/projects/Rajapushpa Provincia.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Nanakramguda,Hyderabad"
    // },
    // {
    //     "id": "sas-crown-kokapet",
    //     "title": "SAS Crown",
    //     "location": "Kokapet, Hyderabad",
    //     "description": "SAS Crown is a luxurious project in Kokapet offering world-class amenities and modern living.",
    //     "features": [
    //         "Luxurious project",
    //         "World-class amenities",
    //         "Modern living"
    //     ],
    //     "image": require("../images/projects/SAS Crown.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     "id": "sattva-lakeridge-neopolis-kokapet",
    //     "title": "Sattva Lakeridge",
    //     "location": "Neopolis, Kokapet, Hyderabad",
    //     "description": "Sattva Lakeridge offers stylish and comfortable homes in the Neopolis area of Kokapet.",
    //     "features": [
    //         "Stylish homes",
    //         "Comfortable living",
    //         "Prime location"
    //     ],
    //     "image": require("../images/projects/Sattva Lakeridge.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Neopolis,Kokapet,Hyderabad"
    // },
    // {
    //     "id": "sr-villas-kollur",
    //     "title": "SR Villas",
    //     "location": "Kollur, Hyderabad",
    //     "description": "SR Villas provides independent villas with premium designs and features in the serene location of Kollur.",
    //     "features": [
    //         "Independent villas",
    //         "Premium designs",
    //         "Serene location"
    //     ],
    //     "image": require("../images/projects/SR Villas.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Kollur,Hyderabad"
    // },
    // {
    //     "id": "sri-aditya-aikaa",
    //     "title": "Sri Aditya - Aikaa",
    //     "location": "Hyderabad",
    //     "description": "Sri Aditya - Aikaa offers spacious and modern apartments designed for comfort and luxury.",
    //     "features": [
    //         "Spacious apartments",
    //         "Comfort and luxury",
    //         "Modern design"
    //     ],
    //     "image": require("../images/projects/Sri Aditya - Aikaa.jpg"),
    //     "mapLink": "https://maps.google.com/?q=Hyderabad"
    // },
    // {
    //     id: "sri-srinivasa-infra-fortune-one-banjara-hills",
    //     title: "Sri Srinivasa Infra - Fortune One",
    //     location: "Road No. 12, Banjara Hills, Hyderabad",
    //     description: "Sri Srinivasa Infra - Fortune One offers premium apartments in the heart of Banjara Hills.",
    //     features: ["Premium apartments", "Heart of Banjara Hills", "Luxury living"],
    //     image: require("../images/projects/Sri Srinivasa Infra - Fortune One.jpg"),
    //     mapLink: "https://maps.google.com/?q=Road No. 12, Banjara Hills, Hyderabad"
    // },
    // {
    //     id: "ssi-fortune-retreat-mominpet-shankarpally",
    //     title: "SSI - Fortune Retreat",
    //     location: "Mominpet, Shankarpally, Hyderabad",
    //     description: "SSI - Fortune Retreat offers peaceful and luxurious living in the picturesque Mominpet area.",
    //     features: ["Peaceful living", "Luxurious features", "Picturesque location"],
    //     image: require("../images/projects/SSI - Fortune Retreat.jpg"),
    //     mapLink: "https://maps.google.com/?q=Mominpet, Shankarpally, Hyderabad"
    // },
    // {
    //     id: "ssi-12-acres-neopolis-kokapet",
    //     title: "SSI - 12 Acres Neopolis",
    //     location: "Neopolis, Kokapet, Hyderabad",
    //     description: "SSI - 12 Acres Neopolis offers spacious and luxurious living in a prime location in Kokapet.",
    //     features: ["Spacious living", "Luxurious design", "Prime location"],
    //     image: require("../images/projects/SSI - 12 Acres Neopolis.jpg"),
    //     mapLink: "https://maps.google.com/?q=Neopolis, Kokapet, Hyderabad"
    // },
    // {
    //     id: "ssi-the-marquise-kokapet",
    //     title: "SSI - The Marquise",
    //     location: "Kokapet, Hyderabad",
    //     description: "SSI - The Marquise offers luxurious living spaces with top-notch amenities in Kokapet, Hyderabad.",
    //     features: ["Luxurious living", "Top-notch amenities", "Prime location"],
    //     image: require("../images/projects/SSI - The Marquise.jpg"),
    //     mapLink: "https://maps.google.com/?q=Kokapet,Hyderabad"
    // },
    // {
    //     id: "ssi-water-front-kukatpally",
    //     title: "SSI - Water Front",
    //     location: "Kukatpally, Hyderabad",
    //     description: "SSI - Water Front offers a serene living experience with a beautiful waterfront view in Kukatpally.",
    //     features: ["Waterfront view", "Serene living", "Premium amenities"],
    //     image: require("../images/projects/SSI - Water Front.jpg"),
    //     mapLink: "https://maps.google.com/?q=Kukatpally,Hyderabad"
    // },
    // {
    //     id: "sumadhura-horizon-kondapur",
    //     title: "Sumadhura Horizon",
    //     location: "Kondapur, Hyderabad",
    //     description: "Sumadhura Horizon offers luxury apartments in the heart of Kondapur with modern amenities.",
    //     features: ["Luxury apartments", "Modern amenities", "Prime location"],
    //     image: require("../images/projects/Sumadhura Horizon.jpg"),
    //     mapLink: "https://maps.google.com/?q=Kondapur,Hyderabad"
    // },
    // {
    //     id: "sumadhura-palais-royale-khajaguda",
    //     title: "Sumadhura - Palais Royale",
    //     location: "Khajaguda, Hyderabad",
    //     description: "Sumadhura Palais Royale offers upscale living with sophisticated design and features in Khajaguda.",
    //     features: ["Upscale living", "Sophisticated design", "Exclusive location"],
    //     image: require("../images/projects/Sumadhura - Palais Royale.jpg"),
    //     mapLink: "https://maps.google.com/?q=Khajaguda,Hyderabad"
    // },
    // {
    //     id: "sunshine-destino-puppalaguda-gandipet",
    //     title: "Sunshine Destino",
    //     location: "Puppalaguda, Gandipet, Hyderabad",
    //     description: "Sunshine Destino offers a peaceful and luxurious lifestyle in Puppalaguda, near the serene Gandipet lake.",
    //     features: ["Peaceful lifestyle", "Luxurious living", "Serene location"],
    //     image: require("../images/projects/Sunshine Destino.jpg"),
    //     mapLink: "https://maps.google.com/?q=Puppalaguda,Gandipet,Hyderabad"
    // },
    // {
    //     id: "the-vue-residences-nanakramguda",
    //     title: "The VUE Residences",
    //     location: "Nanakramguda, Hyderabad",
    //     description: "The VUE Residences provide contemporary living with stunning views and modern amenities in Nanakramguda.",
    //     features: ["Contemporary living", "Stunning views", "Modern amenities"],
    //     image: require("../images/projects/The VUE Residences.jpg"),
    //     mapLink: "https://maps.google.com/?q=Nanakramguda,Hyderabad"
    // },
    // {
    //     id: "trendset-allure-neopolis-kokapet",
    //     title: "Trendset Allure",
    //     location: "Neopolis, Kokapet, Hyderabad",
    //     description: "Trendset Allure offers a mix of luxury and comfort with world-class amenities in Kokapet.",
    //     features: ["Luxury living", "World-class amenities", "Comfortable design"],
    //     image: require("../images/projects/Trendset Allure.jpg"),
    //     mapLink: "https://maps.google.com/?q=Neopolis,Kokapet,Hyderabad"
    // },
    // {
    //     id: "urbanspaces-high-garden-chevella",
    //     title: "Urbanspaces - High Garden",
    //     location: "Chevella, Hyderabad",
    //     description: "Urbanspaces - High Garden offers luxurious residences with a blend of nature and modern design in Chevella.",
    //     features: ["Luxurious residences", "Blend of nature", "Modern design"],
    //     image: require("../images/projects/Urbanspaces - High Garden.jpg"),
    //     mapLink: "https://maps.google.com/?q=Chevella,Hyderabad"
    // },
    // {
    //     id: "urbanspaces-hmda-plotting-chevella",
    //     title: "Urbanspaces - HMDA Plotting",
    //     location: "Chevella, Hyderabad",
    //     description: "Urbanspaces - HMDA Plotting offers prime plots for residential development in the growing area of Chevella.",
    //     features: ["Prime plots", "Residential development", "Growing locality"],
    //     image: require("../images/projects/Urbanspaces - HMDA Plotting.jpg"),
    //     mapLink: "https://maps.google.com/?q=Chevella,Hyderabad"
    // },
    // {
    //     id: "vamsiram-builders-manhattan-khajaguda-gachibowli",
    //     title: "Vamsiram Builders - Manhattan",
    //     location: "Khajaguda, Gachibowli, Hyderabad",
    //     description: "Vamsiram Builders - Manhattan offers contemporary living with world-class amenities in Gachibowli.",
    //     features: ["Contemporary living", "World-class amenities", "Prime location"],
    //     image: require("../images/projects/Vamsiram Builders - Manhattan.jpg"),
    //     mapLink: "https://maps.google.com/?q=Khajaguda,Gachibowli,Hyderabad"
    // },
    // {
    //     id: "vamsiram-homes-the-niche-shaikpet",
    //     title: "Vamsiram Homes - The Niche",
    //     location: "Shaikpet, Hyderabad",
    //     description: "Vamsiram Homes - The Niche offers modern living with luxurious features in Shaikpet.",
    //     features: ["Modern living", "Luxurious features", "Exclusive locality"],
    //     image: require("../images/projects/Vamsiram Homes - The Niche.jpg"),
    //     mapLink: "https://maps.google.com/?q=Shaikpet,Hyderabad"
    // },
    // {
    //     id: "vasavi-ananda-nilayam-l-b-nagar",
    //     title: "Vasavi Ananda Nilayam",
    //     location: "L B Nagar, Hyderabad",
    //     description: "Vasavi Ananda Nilayam offers a blend of comfort and luxury in the well-connected area of L B Nagar.",
    //     features: ["Comfort and luxury", "Well-connected location", "Modern amenities"],
    //     image: require("../images/projects//Vasavi Ananda Nilayam.jpg"),
    //     mapLink: "https://maps.google.com/?q=L B Nagar,Hyderabad"
    // },
    // {
    //     id: "vasavi-atlantis-narsingi",
    //     title: "Vasavi Atlantis",
    //     location: "Narsingi, Hyderabad",
    //     description: "Vasavi Atlantis offers luxurious apartments in the peaceful area of Narsingi, Hyderabad.",
    //     features: ["Luxurious apartments", "Peaceful environment", "Exclusive location"],
    //     image: require("../images/projects/Vasavi Atlantis.jpg"),
    //     mapLink: "https://maps.google.com/?q=Narsingi,Hyderabad"
    // },
    // {
    //     id: "western-springs-nanakramguda-financial-district",
    //     title: "Western Springs",
    //     location: "Nanakramguda, Financial District, Hyderabad",
    //     description: "Western Springs offers a modern living experience in Hyderabad’s Financial District with excellent connectivity.",
    //     features: ["Modern living", "Financial District", "Excellent connectivity"],
    //     image: require("../images/projects/Western Springs.png"),
    //     mapLink: "https://maps.google.com/?q=Nanakramguda,Financial District,Hyderabad"
    // }



]



export default projects;
